
// @ts-nocheck
import config from '@/config/config'

import ContainerLayer from '@/assets/ContainerLayer'
import axios from "axios"
import ApiService from "@/core/services/api.service"
// FIXME: temporarily commented out
import mapboxgl, {
  FillPaint,
  GeoJSONSource,
  LinePaint,
  MapboxGeoJSONFeature,
} from "mapbox-gl"
import * as turf from "@turf/turf"

import { Component, Emit, Ref, Vue, Watch, Prop } from "vue-property-decorator"

// import functions
import {
  GETBerthInit
} from "@/core/services/store/berthplanning.module"



//Import of assets
import SlotParameters from "../assets/SlotParameters"
import SelectSlotsTool from "../assets/SelectSlotsTool"
import EditorTool from "../assets/EditorTool"
import ShipLayer from "../assets/ShipLayer"
import SedanLayer from "../assets/3DLayers/SedanLayer"
import VanLayer from "../assets/3DLayers/VanLayer"
import BikeLayer from "../assets/3DLayers/BikeLayer"
import PickupLayer from "../assets/3DLayers/PickupLayer"

import BusLayer from "../assets/3DLayers/BusLayer"

import HachbackLayer from "../assets/3DLayers/HachbackLayer"
import SuvLayer from "../assets/3DLayers/SuvLayer"
import StationwagonLayer from "../assets/3DLayers/StationwagonLayer"
import MinivanLayer from "../assets/3DLayers/MinivanLayer"
import TruckLayer from "../assets/3DLayers/TruckLayer"
import RTGLayer from "../assets/3DLayers/RTGLayer";

import BerthsLayer from "../assets/BerthsLayer"
// Import of types

import { Occupation, OccupationDictionary } from "@/types/Occupation"
import { SlotFeatureDictionary } from "@/types/Slots"
import ColorScheme from "../types/ColorScheme"
import SelectionInterface from "../types/Selection"
import YardViewObject from "../types/YardViewObject"
import Lane from "@/types/Lane"
import LaneOccupation from "@/types/LaneOccupation"
import { v4 as uuidv4 } from 'uuid'
import configs from "@/config/config"
import { Container } from "konva/lib/Container"
const MAPBOX_ACCESS_TOKEN = "pk.eyJ1IjoiZi1rYXJpbWkxOTk5IiwiYSI6ImNtMDN0YmE1YzAxY2Yya3IwNDF3aWp0ejkifQ.MPbbQYa8AtCo_YpdyD5F0Q"


// @ts-ignore
@Component({
  name: "YardView",
})
export default class YardView extends Vue {
  // $refs!: {
  //   map: HTMLElement;
  // };

  @Prop({ default: "height:100%;overflow-y: hidden" })
  private readonly styleMap!: string

  @Prop({ type: String, terminal: [String, Number, Array], key: Boolean })
  private readonly terminalId!: string

  @Prop({ default: () => [], type: Array })
  private readonly terminals!: string

  @Prop({ default: "1" })
  private readonly terminal!: string

  @Ref("map") readonly mapElement!: HTMLElement

  private PALETTE_FIELD_MAP: Record<string, string> = {
    containerCycleType: 'containerCycleType',
    containerSize: 'containerSize',
    containerType: 'containerType',
    voyageName: 'voyageName',
    portOfTranship: 'portOfTranship',
    portOfDischarge: 'portOfDischarge',
    terminalDestination: 'terminalDestination',
    shipmentType: 'shipmentType',
    loadStatus: 'loadStatus',
    blockedStatus: 'blockedStatus',
    orderType: 'orderType',
    layer:'layer'
  };

  private CONTAINER_FILTER_ORDER: string[] = [
    'containerCycleType',
    'orderType',
    'loadStatus',
    'code',
    'voyageName',
    'terminalDestination',
    'shipmentType',
    'containerSize',
    'containerType',
    'portOfDischarge',
    'portOfTranship',
    'noDeliveryToPTIsRequired',
  ];

  private EQUIPMENT_PALETTE_FIELD_MAP: Record<string, string> = {
    code: 'code',
    currentArea: 'currentArea',
    status: 'status',
    operationType: 'operationType',
    vessel: 'vessel',
    terminal: 'terminal',
  };

  fixedPalettes = {
    layer: {
      "1": "#16a34a",
      "2": "#65a30d",
      "3": "#ca8a04",
      "4": "#ea580c",
      "5": "#dc2626",
      "6": "#7f1d1d"
    },
    orderType: {
      "Full EXP": "#d92626",
      "Dis Marshal": "#b5d926",
      "Dis TRP": "#26d96e",
      "Dis MT": "#266ed9",
      "MT EXP": "#b526d9"
    },
    containerCycleType: {
      "Export": "#d92626",
      "Full Inbound": "#b5d926",
      "Empty": "#26d96e",
    },
    operationType: {
      "Idle": "#727272 ",
      "Out Of Service": "#181c32",
      "Deliver To PT": "#3498DB",
      "Discharge From Vessel": "#27AE60",
      "Send & Receive": "#1ABC9C",
      "Gate Of Full": "#fd27eb",
      "Send To Vessel": "#f64e60",
      "Landed At MY": "#f15600",
      "PM": "#ffa800",
      "LiftOn": "#8950fc",
      "LiftOff": "#22b9ff",
      "Unload": "#4b1d17",
      "ReLift": "#8f3991",
      "Reshuffling": "#494d06"
    }
  }

  showFiltersPanel: boolean = true // نمایش/مخفی کردن کل پنل فیلترها
  showContainerPanel: boolean = true // نمایش/مخفی کردن محتوای فیلتر کانتینرها
  showEquipmentPanel: boolean = true // نمایش/مخفی کردن محتوای فیلتر تجهیزات
  activeTab: 'containers' | 'equipment' | 'addContainer' = 'containers'
  containerJsonInput = ''
  containerJsonError = ''
  containerJsonSuccess = ''

  private isFilterActive: boolean = false;
  private isEquipmentFilterActive: boolean = false;

  private showContainerFilterPanel: boolean = false;
  private showEquipmentFilterPanel: boolean = false;
  private containerStackModal = {
    visible: false,
    area: '',
    bay: null as number | null,
    bay2: null as string | null,
    bay3: null as string | null,
    maxTire: 1,
    maxLevel: 1,
    containers: [] as any[],
  };
  private allContainersFlat: any[] = [];
  private allAreaObjectsArray: any[] = [];
  private containersData: []
  private containerFilter: {
    area?: string;
    bay?: number;
    row?: number;
    layer?: number;
    line?: string;
    containerCycleType?: [];
    loadStatus: string,
    noDeliveryToPTIsRequired: boolean,
    containerSize: [],
    containerType: string,
    voyageName: [],
    portOfDischarge: [],
    portOfTranship: [],
    shipmentType: [],
    terminalDestination: []
    orderType?: []
  } = {};

  private equipmentsData: []
  private equipmentsFilter: {
    code?: [];
    currentArea?: [];
    operationType?: [];
    status?: [];
    vessel?: [];
    terminal?: []
  } = {};

  private codeOptions = [];
  private currentAreaOptions = [];
  private operationTypeOptions = [];
  private statusOptions = [];
  private vesselOptions = [];
  private terminalOptions = [];



  private containerCycleTypeOptions = [];
  private orderTypeOptions = [];

  private noDeliveryToPTIsRequiredOptions = [
    { label: "Blocked", value: "1" },
    { label: "None Blocked", value: "0" },
  ];
  private Full_EmptyOptions = [
    { label: "Full", value: "Full" },
    { label: "Empty", value: "Empty" },
  ];
  private containerSizeOptions = [];
  private containerTypeOptions = [];
  private shipmentTypeOptions = [];

  get activeContainerFiltersCount(): number {
    let count = 0

    if (this.containerFilter.orderType && this.containerFilter.orderType.length > 0) count++
    if (this.containerFilter.containerCycleType && this.containerFilter.containerCycleType.length > 0) count++
    if (this.containerFilter.code && this.containerFilter.code !== null && this.containerFilter.code !== '') count++
    if (this.containerFilter.voyageName && this.containerFilter.voyageName.length > 0) count++
    if (this.containerFilter.shipmentType && this.containerFilter.shipmentType.length > 0) count++
    if (this.containerFilter.loadStatus && this.containerFilter.loadStatus !== null && this.containerFilter.loadStatus !== '') count++
    if (this.containerFilter.containerSize && this.containerFilter.containerSize.length > 0) count++
    if (this.containerFilter.terminalDestination && this.containerFilter.terminalDestination.length > 0) count++
    if (this.containerFilter.portOfDischarge && this.containerFilter.portOfDischarge.length > 0) count++
    if (this.containerFilter.portOfTranship && this.containerFilter.portOfTranship.length > 0) count++
    if (this.containerFilter.noDeliveryToPTIsRequired && this.containerFilter.noDeliveryToPTIsRequired !== null && this.containerFilter.noDeliveryToPTIsRequired !== '') count++
    if (this.containerFilter.containerType && this.containerFilter.containerType.length > 0) count++

    return count
  }

  get activeEquipmentFiltersCount(): number {
    let count = 0

    if (this.equipmentsFilter.status && this.equipmentsFilter.status.length > 0) count++
    if (this.equipmentsFilter.operationType && this.equipmentsFilter.operationType.length > 0) count++
    if (this.equipmentsFilter.code && this.equipmentsFilter.code.length > 0) count++
    if (this.equipmentsFilter.vessel && this.equipmentsFilter.vessel.length > 0) count++
    if (this.equipmentsFilter.terminal && this.equipmentsFilter.terminal.length > 0) count++

    return count
  }

  get operationTypeLegendItems() {
    return this.operationTypeOptions.map(opt => ({
      label: opt.label,
      color: this.equipmentcolorPalettes.operationType[opt.value]?.FillColor
        || this.fixedPalettes.operationType[opt.value]
        || '#ccc'
    }));
  }

  applyFilterFromUI() {
    const cleanFilter: any = {};
    this.$store.state.berthMonitoring.isLoading = true

    const blockCode = this.getAreaObjectCode(this.containerFilter.code);
    if (blockCode) {
      cleanFilter.code = blockCode;
    }

    if (this.containerFilter.bay !== undefined &&
      this.containerFilter.bay !== null &&
      this.containerFilter.bay !== '') {
      cleanFilter.bay = Number(this.containerFilter.bay);
    }

    if (this.containerFilter.row !== undefined &&
      this.containerFilter.row !== null &&
      this.containerFilter.row !== '') {
      cleanFilter.row = Number(this.containerFilter.row);
    }

    if (this.containerFilter.layer !== undefined &&
      this.containerFilter.layer !== null &&
      this.containerFilter.layer !== '') {
      cleanFilter.layer = Number(this.containerFilter.layer);
    }
    if (this.containerFilter.containerCycleType?.length > 0) {
      cleanFilter.containerCycleType = this.containerFilter.containerCycleType;
    }
    if (this.containerFilter.orderType?.length > 0) {
      cleanFilter.orderType = this.containerFilter.orderType;
    }
    if (this.containerFilter.loadStatus && String(this.containerFilter.loadStatus).trim() !== '') {
      cleanFilter.loadStatus = String(this.containerFilter.loadStatus).trim();
    }
    if (this.containerFilter.noDeliveryToPTIsRequired && this.containerFilter.noDeliveryToPTIsRequired !== '') {
      cleanFilter.noDeliveryToPTIsRequired = this.containerFilter.noDeliveryToPTIsRequired;
    }
    if (this.containerFilter.containerSize?.length > 0) {
      cleanFilter.containerSize = this.containerFilter.containerSize;
    }
    if (this.containerFilter.containerType?.length > 0) {
      cleanFilter.containerType = this.containerFilter.containerType
    }
    if (this.containerFilter.voyageName?.length > 0) {
      cleanFilter.voyageName = this.containerFilter.voyageName
    }
    if (this.containerFilter.terminalDestination?.length > 0) {
      cleanFilter.terminalDestination = this.containerFilter.terminalDestination
    }
    if (this.containerFilter.shipmentType?.length > 0) {
      cleanFilter.shipmentType = this.containerFilter.shipmentType
    }
    if (this.containerFilter.line && this.containerFilter.line.trim() !== '') {
      cleanFilter.line = this.containerFilter.line.trim();
    }
    if (this.containerFilter.portOfDischarge?.length > 0) {
      cleanFilter.portOfDischarge = this.containerFilter.portOfDischarge
    }
    if (this.containerFilter.portOfTranship?.length > 0) {
      cleanFilter.portOfTranship = this.containerFilter.portOfTranship
    }
    this.setContainerFilter(cleanFilter);
  }

  applyEquipmentFilterFromUI() {
    const cleanFilter: any = {};
    this.$store.state.berthMonitoring.isLoading = true

    if (this.equipmentsFilter.code?.length > 0) {
      cleanFilter.code = this.equipmentsFilter.code;
    }
    if (this.equipmentsFilter.operationType?.length > 0) {
      cleanFilter.operationType = this.equipmentsFilter.operationType;
    }
    if (this.equipmentsFilter.status?.length > 0) {
      cleanFilter.status = this.equipmentsFilter.status;
    }
    if (this.equipmentsFilter.vessel?.length > 0) {
      cleanFilter.vessel = this.equipmentsFilter.vessel;
    }
    if (this.equipmentsFilter.terminal?.length > 0) {
      cleanFilter.terminal = this.equipmentsFilter.terminal;
    }
    this.setEquipmentFilter(cleanFilter);
  }



  clearFilterFromUI() {
    this.containerFilter = {};
    this.clearContainerFilter();
    this.refreshContainerFilterOptionsFromData();
  }

  clearEquipmentFilterFromUI() {
    this.equipmentsFilter = {};
    this.clearEquipmentFilter();
  }

  closeFilterFromUI(){
    this.activeTab = null
  }

  submitContainerJsonFromUI() {

    this.containerJsonError = ''
    this.containerJsonSuccess = ''

    const outcome = this.applyContainerStackPayload(this.containerJsonInput)
    this.setContainerStackApplyMessages(outcome)
    Vue.$toast.open({
      message: `
    <div style="text-align: center;  color: black;">
      <strong>${this.containerJsonSuccess || this.containerJsonError || outcome.error || 'Failed to add containers.'}</strong>
    </div>
  `,
      type: this.containerJsonSuccess ? 'success' : 'error',
      position: 'top',
      duration: 10000,
      html: true,
    })

  }

  applyContainerStackPayloadAndShowToast(payload: any) {
    const outcome = this.applyContainerStackPayload(payload)
    this.setContainerStackApplyMessages(outcome)
    Vue.$toast.open({
      message: `
    <div style="text-align: center;  color: black;">
      <strong>${this.containerJsonSuccess || this.containerJsonError || outcome.error || 'Failed to add containers.'}</strong>
    </div>
  `,
      type: this.containerJsonSuccess ? 'success' : 'error',
      position: 'top',
      duration: 10000,
      html: true,
    })
  }

  submitContainerJsonFromUIRaw(payload: any) {
    this.containerJsonError = ''
    this.containerJsonSuccess = ''
    return this.applyContainerStackPayload(payload)
  }

  private formatContainerStackSuccessMessage(outcome: { ContainersNo?: string }): string {
    const containersNo = outcome.ContainersNo?.trim()
    if (containersNo) {
      return `${containersNo} added to map.`
    }
    return 'Containers added to map.'
  }

  private setContainerStackApplyMessages(outcome: {
    ok: boolean
    error?: string
    addedContainers?: number
    ContainersNo?: string
    postion:?string
    failed?: Array<{ area: string; bay: number; row: number; reason: string }>
  }) {
    if (!outcome.ok) {
      this.containerJsonError = outcome.error || 'Failed to add containers.'
      return
    }

    const failed = outcome.failed || []
    if (failed.length) {
      const details = failed
        .map((item) => `${item.area}/${item.bay}/${item.row}: ${item.reason}`)
        .join(' | ')
      if ((outcome.addedContainers || 0) > 0) {
        this.containerJsonSuccess = this.formatContainerStackSuccessMessage(outcome)
        this.containerJsonError = `Some stacks failed: ${details}`
      } else {
        this.containerJsonError = details
      }
      return
    }

    if (!outcome.addedContainers) {
      this.containerJsonError =
        'No containers were added. Check area/bay/row and wait for the map to finish loading.'
      return
    }

    this.containerJsonSuccess = this.formatContainerStackSuccessMessage(outcome)
  }

  private normalizeContainerStackPayload(payload: any): any[] | null {
    if (payload == null || payload === '') {
      return null
    }

    let parsed = payload
    if (typeof payload === 'string') {
      const raw = payload.trim()
      if (!raw) {
        return null
      }
      parsed = JSON.parse(raw)
    }

    if (Array.isArray(parsed)) {
      return parsed
    }

    if (!parsed || typeof parsed !== 'object') {
      return null
    }

    const list =
      parsed.list ??
      parsed.List ??
      parsed.stacks ??
      parsed.Stacks ??
      parsed.items ??
      parsed.Items

    if (Array.isArray(list)) {
      return list
    }

    const containersData = parsed.containersData ?? parsed.ContainersData
    if (containersData) {
      if (Array.isArray(containersData)) {
        return containersData
      }
      const nestedList = containersData.list ?? containersData.List
      if (Array.isArray(nestedList)) {
        return nestedList
      }
    }

    const containers = parsed.containers ?? parsed.Containers
    if (Array.isArray(containers)) {
      return [parsed]
    }

    return null
  }

  private isValidContainerStack(stack: any): boolean {
    const containers = stack?.containers ?? stack?.Containers
    return !!stack && Array.isArray(containers) && containers.length > 0
  }

  applyContainerStackPayload(payload: any): {
    ok: boolean
    error?: string
    addedStacks?: number
    addedContainers?: number
    ContainersNo?: string
    postion:?string
    failed?: Array<{ area: string; bay: number; row: number; reason: string }>
  } {
    if (payload == null || payload === '') {
      return { ok: false, error: 'Payload is empty.' }
    }

    let stacks: any[] | null = null
    try {
      stacks = this.normalizeContainerStackPayload(payload)
    } catch (error) {
      return {
        ok: false,
        error: error instanceof Error ? error.message : 'Invalid JSON.',
      }
    }

    if (!stacks?.length) {
      return {
        ok: false,
        error:
          'Payload is empty.',
      }
    }

    const invalidStack = stacks.find((stack) => !this.isValidContainerStack(stack))
    if (invalidStack) {
      return {
        ok: false,
        error:
          'Each stack must include a non-empty containers (or Containers) array.',
      }
    }

    const result = this.addContainerStacksToMap(stacks)
    return {
      ok: true,
      addedStacks: result.addedStacks,
      addedContainers: result.addedContainers,
      ContainersNo: result.ContainersNo,
      postion: result.postion,
      failed: result.failed,
    }
  }


  clearContainerJsonFromUI() {
    this.containerJsonInput = ''
    this.containerJsonError = ''
    this.containerJsonSuccess = ''
  }


  private containerColorPalettes = {

    containerSize: {},
    loadStatus: {},
    blockedStatus: {},
    containerCycleType: {},
    orderType: {},
    vesselName: {},
    shipmentType: {},
    terminal: {},
    portOfDischarge: {},
    portOfTranship: {},
    containerType: {},
    terminalDestination: {},
  }
  private activePalette = "orderType"; // مشخصه انتخابی کاربر
  private paletteOptions = [
    { value: "layer", label: "Level"},
    { value: "orderType", label: "Order Type" },
    { value: "containerCycleType", label: "Container Cycle Type" },
    { value: "voyageName", label: "Vessel Name" },
    { value: "shipmentType", label: "Shipment" },
    { value: "loadStatus", label: "Status(Full/Empty)" },
    { value: "containerSize", label: "containerSize" },
    { value: "terminalDestination", label: "Terminal Destination" },
    { value: "portOfDischarge", label: "POD" },
    { value: "portOfTranship", label: "POT" },
    { value: "blockedStatus", label: "Blocked Status" },
    { value: "containerType", label: "Container Type" }
  ];

  private equipmentactivePalette = "operationType";
  private equipmentcolorPalettes = {
    code: {},
    currentArea: {},
    status: {},
    operationType: {},
    vessel: {},
    terminal: {}
  }
  private equipmentPaletteOptions = [
    { value: "code", label: "EQ No" },
    { value: "currentArea", label: "Area" },
    { value: "status", label: "Eq status" },
    { value: "operationType", label: "Eq Operation" },
    { value: "vessel", label: "Vessel" },
    { value: "terminal", label: "Terminal" }
  ];

  buildColorExpression(paletteKey) {

    if (!paletteKey) {
      return [
        "match",
        ["get", "layer"],
        ...this.stackColorStyle,
        this.slotColorScheme.FillColor
      ];
    }

    const fieldMap = {
      containerSize: "containerSize",
      loadStatus: "loadStatus",
      containerCycleType: "containerCycleType",
      orderType: "orderType",
      vesselName: "voyageName",
      shipmentType: "shipmentType",
      portOfDischarge: "portOfDischarge",
      portOfTranship: "portOfTranship",
      blockedStatus: "blockedStatus",
      containerType: "containerType",
      terminalDestination: "terminalDestination",
    };

    const propertyMap = {
      containerSize: "containerSize",
      loadStatus: "loadStatus",
      containerCycleType: "containerCycleType",
      orderType: "orderType",
      vesselName: "voyageName",
      shipmentType: "shipmentType",
      portOfDischarge: "portOfDischarge",
      portOfTranship: "portOfTranship",
      blockedStatus: "blockedStatus",
      containerType: "containerType",
      terminalDestination: "terminalDestination",

    };

    const palette = this.buildPaletteFromData(fieldMap[paletteKey]);
    const expr = ["match", ["get", propertyMap[paletteKey]], ...this.containerColorPalettes[paletteKey].colorExpr];
    // ✅ اضافه کردن جفت‌های key-value
    Object.entries(palette).forEach(([key, val]) => {
      if (key !== "default") {
        expr.push(key, val.FillColor);
      }
    });

    // ✅ اضافه کردن fallback (حتماً باید باشه)
    //expr.push(palette.default?.FillColor || "#ccc");
    expr.push("#ffa800");

    //cons
    return expr;
  }

  onFilterChange(changedField: string) {
    this.updateAllFilterOptions(changedField);
    this.InvalidContainerFilterSelections(changedField);
  }

  private normalizeBlockCode(value: any): string {
    return value == null || value === '' ? '' : String(value).trim();
  }

  private getStackAreaCode(stack: any): string {
    return this.normalizeBlockCode(
      stack?.code ?? stack?.Code ?? stack?.area ?? stack?.Area
    );
  }

  private getAreaObjectCode(area: any): string {
    if (area == null) {
      return '';
    }
    if (typeof area === 'string' || typeof area === 'number') {
      return this.normalizeBlockCode(area);
    }
    return this.normalizeBlockCode(area.code ?? area.Code);
  }

  private getBlockCode(properties: any): string {
    const direct = this.normalizeBlockCode(
      properties?.code ?? properties?.Code ?? properties?.area ?? properties?.Area
    );
    if (direct) {
      return direct;
    }
    const positionId = properties?.PositionId ?? properties?.positionId;
    if (positionId && String(positionId).includes('-')) {
      return String(positionId).split('-')[0].trim();
    }
    return '';
  }

  private blockCodesMatch(a: any, b: any): boolean {
    const left = this.normalizeBlockCode(a).toUpperCase();
    const right = this.normalizeBlockCode(b).toUpperCase();
    return left !== '' && left === right;
  }

  buildAllContainersFlat() {
    if (!this.containersData?.length) {
      this.allContainersFlat = [];
      return;
    }
    this.allContainersFlat = this.containersData.flatMap((stack) => {
      const areaCode = this.getStackAreaCode(stack);
      const containers = stack.containers ?? stack.Containers ?? [];
      return containers.map((container) => ({
        ...container,
        code: areaCode,
      }));
    });
  }

  private getContainerProp(item: any, camelKey: string, pascalKey?: string): any {
    if (item[camelKey] !== undefined && item[camelKey] !== null) {
      return item[camelKey];
    }
    const pascal = pascalKey || camelKey.charAt(0).toUpperCase() + camelKey.slice(1);
    return item[pascal];
  }

  private multiSelectMatches(selected: any[], propertyValues: any): boolean {
    const propArray = Array.isArray(propertyValues) ? propertyValues : [propertyValues];
    return selected.some((val) =>
      propArray.map((v) => String(v).trim()).includes(String(val).trim())
    );
  }

  private isContainerFilterFieldActive(field: string): boolean {
    const f = this.containerFilter;
    switch (field) {
      case 'code':
        return this.getAreaObjectCode(f.code) !== '';
      case 'loadStatus':
        return !!(f.loadStatus && String(f.loadStatus).trim() !== '');
      case 'noDeliveryToPTIsRequired':
        return (
          f.noDeliveryToPTIsRequired !== null &&
          f.noDeliveryToPTIsRequired !== undefined &&
          f.noDeliveryToPTIsRequired !== ''
        );
      default: {
        const val = f[field];
        return Array.isArray(val) ? val.length > 0 : !!(val && String(val).trim() !== '');
      }
    }
  }

  matchesSingleContainerFilterField(item: any, field: string): boolean {
    const f = this.containerFilter;

    switch (field) {
      case 'code':
        return this.blockCodesMatch(this.getBlockCode(item), f.code);
      case 'containerCycleType': {
        const propertyValues = this.getContainerProp(item, 'containerCycleType', 'ContainerCycleType');
        return this.multiSelectMatches(f.containerCycleType, propertyValues);
      }
      case 'orderType': {
        const propertyValues = this.getContainerProp(item, 'orderType', 'OrderType');
        return this.multiSelectMatches(f.orderType, propertyValues);
      }
      case 'loadStatus': {
        const propertyValue = this.getContainerProp(item, 'loadStatus', 'LoadStatus');
        return propertyValue === String(f.loadStatus).trim();
      }
      case 'noDeliveryToPTIsRequired': {
        const propertyValue = this.getContainerProp(
          item,
          'noDeliveryToPTIsRequired',
          'NoDeliveryToPTIsRequired'
        );
        return Number(propertyValue) === Number(f.noDeliveryToPTIsRequired);
      }
      case 'voyageName': {
        const propertyValues = this.getContainerProp(item, 'voyageName', 'VoyageName');
        return this.multiSelectMatches(f.voyageName, propertyValues);
      }
      case 'terminalDestination': {
        const propertyValues = this.getContainerProp(item, 'terminalDestination', 'TerminalDestination');
        return this.multiSelectMatches(f.terminalDestination, propertyValues);
      }
      case 'shipmentType': {
        const propertyValues = this.getContainerProp(item, 'shipmentType', 'ShipmentType');
        return this.multiSelectMatches(f.shipmentType, propertyValues);
      }
      case 'portOfDischarge': {
        const propertyValues = this.getContainerProp(item, 'portOfDischarge', 'PortOfDischarge');
        return this.multiSelectMatches(f.portOfDischarge, propertyValues);
      }
      case 'portOfTranship': {
        const propertyValues = this.getContainerProp(item, 'portOfTranship', 'PortOfTranship');
        return this.multiSelectMatches(f.portOfTranship, propertyValues);
      }
      case 'containerSize': {
        const propertyValues = this.getContainerProp(item, 'containerSize', 'ContainerSize');
        return this.multiSelectMatches(f.containerSize, propertyValues);
      }
      case 'containerType': {
        const propertyValues = this.getContainerProp(item, 'containerType', 'ContainerType');
        return this.multiSelectMatches(f.containerType, propertyValues);
      }
      default:
        return true;
    }
  }

  getFilteredContainersUpToField(targetField: string) {
    if (!this.allContainersFlat?.length) {
      return [];
    }

    const targetIndex = this.CONTAINER_FILTER_ORDER.indexOf(targetField);
    if (targetIndex <= 0) {
      return [...this.allContainersFlat];
    }

    return this.allContainersFlat.filter((item) => {
      for (let i = 0; i < targetIndex; i++) {
        const field = this.CONTAINER_FILTER_ORDER[i];
        if (!this.isContainerFilterFieldActive(field)) {
          continue;
        }
        if (!this.matchesSingleContainerFilterField(item, field)) {
          return false;
        }
      }
      return true;
    });
  }

  updateFilterOptionsForField(field: string) {
    const filteredContainers = this.getFilteredContainersUpToField(field);

    if (field === 'code') {
      const codes = new Set(
        filteredContainers
          .map((item) => this.getBlockCode(item))
          .filter(Boolean)
          .map((c) => this.normalizeBlockCode(c).toUpperCase())
      );
      const source = this.allAreaObjectsArray.length ? this.allAreaObjectsArray : this.areaObjectsArray;
      this.areaObjectsArray = source.filter((area) =>
        codes.has(this.getAreaObjectCode(area).toUpperCase())
      );
      return;
    }

    if (field === 'loadStatus') {
      const statuses = new Set(
        filteredContainers
          .map((item) => this.getContainerProp(item, 'loadStatus', 'LoadStatus'))
          .filter((v) => v != null && String(v).trim() !== '')
          .map((v) => String(v).trim())
      );
      this.Full_EmptyOptions = [
        { label: 'Full', value: 'Full' },
        { label: 'Empty', value: 'Empty' },
      ].filter((o) => statuses.has(o.value));
      return;
    }

    if (field === 'noDeliveryToPTIsRequired') {
      const hasBlocked = filteredContainers.some(
        (c) => Number(this.getContainerProp(c, 'noDeliveryToPTIsRequired', 'NoDeliveryToPTIsRequired')) === 1
      );
      const hasNoneBlocked = filteredContainers.some(
        (c) => Number(this.getContainerProp(c, 'noDeliveryToPTIsRequired', 'NoDeliveryToPTIsRequired')) === 0
      );
      this.noDeliveryToPTIsRequiredOptions = [
        { label: 'Blocked', value: '1' },
        { label: 'None Blocked', value: '0' },
      ].filter((o) => (o.value === '1' && hasBlocked) || (o.value === '0' && hasNoneBlocked));
      return;
    }

    const result = this.generateColorPalette(field, filteredContainers);
    this[`${field}Options`] = result.options;
  }

  updateAllFilterOptions(changedField: string) {
    const changedIndex = this.CONTAINER_FILTER_ORDER.indexOf(changedField);
    if (changedIndex === -1) {
      return;
    }

    for (let i = changedIndex + 1; i < this.CONTAINER_FILTER_ORDER.length; i++) {
      this.updateFilterOptionsForField(this.CONTAINER_FILTER_ORDER[i]);
    }
  }

  refreshContainerFilterOptionsFromData() {
    if (!this.allContainersFlat?.length) {
      return;
    }
    for (const field of this.CONTAINER_FILTER_ORDER) {
      this.updateFilterOptionsForField(field);
    }
    this.areaObjectsArray = [...this.allAreaObjectsArray];
  }

  InvalidContainerFilterSelections(changedField: string) {
    const changedIndex = this.CONTAINER_FILTER_ORDER.indexOf(changedField);
    if (changedIndex === -1) {
      return;
    }

    const pruneMulti = (field: string, options: { value: any }[]) => {
      const selected = this.containerFilter[field];
      if (!Array.isArray(selected) || selected.length === 0) {
        return;
      }
      const allowed = new Set(options.map((o) => o.value));
      const pruned = selected.filter((v) => allowed.has(v));
      if (pruned.length !== selected.length) {
        this.containerFilter[field] = pruned;
      }
    };

    for (let i = changedIndex + 1; i < this.CONTAINER_FILTER_ORDER.length; i++) {
      const field = this.CONTAINER_FILTER_ORDER[i];

      if (field === 'code') {
        if (this.containerFilter.code) {
          const allowedCodes = new Set(
            (this.areaObjectsArray || []).map((a) => this.getAreaObjectCode(a).toUpperCase())
          );
          if (!allowedCodes.has(this.normalizeBlockCode(this.containerFilter.code).toUpperCase())) {
            this.containerFilter.code = null;
          }
        }
        continue;
      }

      if (field === 'loadStatus') {
        if (this.containerFilter.loadStatus) {
          const allowed = new Set(this.Full_EmptyOptions.map((o) => o.value));
          if (!allowed.has(this.containerFilter.loadStatus)) {
            this.containerFilter.loadStatus = null;
          }
        }
        continue;
      }

      if (field === 'noDeliveryToPTIsRequired') {
        if (
          this.containerFilter.noDeliveryToPTIsRequired !== null &&
          this.containerFilter.noDeliveryToPTIsRequired !== undefined &&
          this.containerFilter.noDeliveryToPTIsRequired !== ''
        ) {
          const allowed = new Set(this.noDeliveryToPTIsRequiredOptions.map((o) => o.value));
          if (!allowed.has(this.containerFilter.noDeliveryToPTIsRequired)) {
            this.containerFilter.noDeliveryToPTIsRequired = null;
          }
        }
        continue;
      }

      pruneMulti(field, this[`${field}Options`] || []);
    }
  }
  buildPaletteFromData(fieldName) {
    const uniqueValues = [
      ...new Set(
        this.containersData.flatMap(d =>
          d.containers.map(c => c[fieldName])
        )
      )
    ].filter(v => v);

    if (uniqueValues.length === 0) {
      return {
        default: { FillColor: "#ccc", label: "بدون داده" }
      };
    }

    const colors = [
      "#4CAF50", "#2196F3", "#9C27B0", "#FF9800",
      "#F44336", "#00BCD4", "#795548", "#607D8B"
    ];

    const palette = {};
    uniqueValues.forEach((val, idx) => {
      palette[val] = {
        FillColor: colors[idx % colors.length],
        label: val
      };
    });
    palette.default = { FillColor: "#ccc", label: "نامشخص" };

    return palette;
  }

  onColorPaletteChange(paletteKey) {
    if (!this.map) return

    this.activeColorPalette = paletteKey;
   if (!this.map || !this.map.getLayer("stacks3D")) {
      return;
    }
    console.log(this.containerColorPalettes[paletteKey])
    this.map.setPaintProperty("stacks3D", "fill-extrusion-color", ["match", ["get", paletteKey], ...this.containerColorPalettes[paletteKey].colorExpr])
      this.map.setPaintProperty('stacks2D', 'fill-color', ["match", ["get", this.activePalette], ...this.containerColorPalettes[this.activePalette].colorExpr]);

  }



  private isPageRefreshing: boolean
  private sessionId!: string
  private useRoro3dModel!: boolean

  private map: mapboxgl.Map
  private areas: Array<turf.Feature> = [];
  private slots: Array<turf.Feature> = [];
  private stacks: Array<turf.Feature> = [];
  private eq2Ds: Array<turf.Feature> = [];
  private eq2DsLabels: Array<turf.Feature> = [];
  private object3dlabelsFeatures: Array<turf.Feature> = [];
  private containers: Array<turf.Feature> = [];
  private vechiles: Array<turf.Feature> = [];
  private areaObjects: Array<YardViewObject> = [];
  private occupationObjectList: OccupationDictionary | null = null;
  private roro3DModelList: Array<string> = [];
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private bolards: Array<any> = [];
  private OccupationRoroLaneList: Array<LaneOccupation> = [];
  private showCancelButton = false;
  private showSaveSelectionButton = false;
  private selectionMode = false;
  private previewMode = false;
  private previewObject!: string | null
  private editor: EditorTool | null = null;

  private selectSlotsTool: SelectSlotsTool | null = null;
  private slotsDict: SlotFeatureDictionary = new SlotFeatureDictionary();
  private slotParametersByPosition: Map<string, any> = new Map();

  private apiUrl: string = null;
  private filtered: Array<turf.Feature> = [];
  private equipmentfiltered: Array<turf.Feature> = [];
  private lastMouseLngLat: mapboxgl.LngLat | null = null;

  private mapResizeObserver: ResizeObserver | null = null;
  private containerMapUpdateScheduled = false;


  private terminalId
  private terminals
  private terminal
  private berthTimeout = 0;
  private BerthData: BerthManagment.RootObject = null;
  private eq3DModelLayerIds: Array<any> = [];
  private areaObjectsArray = []
  private voyageNameOptions = []
  private terminalDestinationOptions = []
  private portOfTranshipOptions = []
  private portOfDischargeOptions = []
  private isOnline = Boolean(config?.VUE_APP_IS_ONLINE_MAP);
  private localStyle = {
    version: 8,
    sources: {
      "mapbox-tiles": {
        type: "raster",
        tiles: [
          `${config.VUE_APP_TILE_IP}/${config.VUE_APP_TILE_ROUTE}`
        ],
        tileSize: 256,
        attribution:
          "<a href='https://www.openstreetmap.org/copyright'>© OpenStreetMap contributors</a>"
      }
    },
    layers: [
      {
        id: "local-tiles",
        type: "raster",
        source: "mapbox-tiles",
        paint: {
          "raster-opacity": 1.0
        }
      }
    ],
    sprite: `${config.VUE_APP_TILE_IP}/maps/positron/sprite`,
    glyphs: `${config.VUE_APP_TILE_IP}/fonts/{fontstack}/{range}.pbf?key=vZlzcMeF80MFxl4thmYp`
  };
 get selectedStyle() {
  return this.isOnline
    ? "maps/Online/style.json"
    : this.localStyle
}
  pageurl!: string
  renderQuality!: string //"High" | "Low" | "Medium";
  @Emit("clickobject")
  clickobject(props: any) {
    return props
  }
  @Emit("loadcomplete")
  loadcomplete(mode) {
    return mode
  }

  get containerStackTireNumbers(): number[] {
    const count = Math.max(1, Number(this.containerStackModal.maxTire) || 1)
    return Array.from({ length: count }, (_, index) => index + 1)
  }

  get containerStackLevelNumbers(): number[] {
    const count = Math.max(1, Number(this.containerStackModal.maxLevel) || 1)
    return Array.from({ length: count }, (_, index) => count - index)
  }

  get containerStackCellMap(): Map<string, any> {
    const map = new Map<string, any>()
    const containers = this.containerStackModal.containers || []
    for (const container of containers) {
      const tireNo = Number(
        this.getContainerStackPositionValue(container, 'tire', containers)
      )
      const levelNo = Number(
        this.getContainerStackPositionValue(container, 'level', containers)
      )
      if (Number.isFinite(tireNo) && tireNo > 0 && Number.isFinite(levelNo) && levelNo > 0) {
        map.set(`${tireNo}-${levelNo}`, container)
      }
    }
    return map
  }

  buildContainerStackModalData(props: Record<string, any>) {
    const yardArea = this.areaObjects.find(
      (a) => (a.Code || a.code) === props.code
    )

    const normalizeBayPart = (value: unknown) => {
      if (value == null || value === '' || value === 'null' || value === 'undefined') {
        return null
      }
      return value
    }

    const matchingStacks = (this.containersData || []).filter((stack) => {
      const stackArea = stack.area ?? stack.Area
      const stackBay = stack.bay ?? stack.Bay
      const stackBay2 = normalizeBayPart(stack.bay2 ?? stack.Bay2)
      const stackBay3 = normalizeBayPart(stack.bay3 ?? stack.Bay3)
      const propsBay2 = normalizeBayPart(props.bay2)
      const propsBay3 = normalizeBayPart(props.bay3)
      return (
        stackArea === props.code &&
        stackBay == props.bay &&
        String(stackBay2 ?? 'null') === String(propsBay2 ?? 'null') &&
        String(stackBay3 ?? 'null') === String(propsBay3 ?? 'null')
      )
    })

    const containers = matchingStacks.flatMap((stack) => {
      const stackRow = stack.row ?? stack.Row
      const list = stack.containers ?? stack.Containers ?? []
      return list.map((container, index) => ({
        ...container,
        _stackRow: stackRow,
        _stackIndex: index + 1,
      }))
    })

    const tireValues = containers
      .map((c) =>
        Number(this.getContainerStackPositionValue(c, 'tire', containers))
      )
      .filter((n) => Number.isFinite(n) && n > 0)
    const levelValues = containers
      .map((c) =>
        Number(this.getContainerStackPositionValue(c, 'level', containers))
      )
      .filter((n) => Number.isFinite(n) && n > 0)
    const stackRowValues = matchingStacks
      .map((s) => Number(s.row ?? s.Row))
      .filter((n) => Number.isFinite(n) && n > 0)
    const stackMaxLayers = matchingStacks
      .map((s) => Number(s.maxLayer ?? s.MaxLayer))
      .filter((n) => Number.isFinite(n) && n > 0)

    const configuredMaxTire = Number(
      yardArea?.MaxTier ?? yardArea?.MaxRow ?? yardArea?.maxTire ?? 0
    )
    const configuredMaxLevel = Number(
      yardArea?.MaxLevel ?? yardArea?.maxLevel ?? 0
    )

    return {
      area: props.code,
      bay: props.bay,
      bay2: props.bay2 ?? null,
      bay3: props.bay3 ?? null,
      maxTire: Math.max(configuredMaxTire, ...stackRowValues, ...tireValues, 1),
      maxLevel: Math.max(
        configuredMaxLevel,
        ...stackMaxLayers,
        ...levelValues,
        1
      ),
      containers,
    }
  }

  openContainerStackModal(data: {
    area: string
    bay: number
    bay2: string | null
    bay3: string | null
    maxTire: number
    maxLevel: number
    containers: any[]
  }) {
    this.containerStackModal = {
      visible: true,
      area: data.area,
      bay: data.bay,
      bay2: data.bay2,
      bay3: data.bay3,
      maxTire: Math.max(1, Number(data.maxTire) || 1),
      maxLevel: Math.max(1, Number(data.maxLevel) || 1),
      containers: data.containers || [],
    }
  }

  getContainerStackProp(item: any, ...keys: string[]) {
    if (!item) {
      return null
    }
    for (const key of keys) {
      const value = item[key]
      if (value !== undefined && value !== null && value !== '') {
        return value
      }
    }
    const normalizedKeys = keys.map((key) => key.toLowerCase())
    for (const objectKey of Object.keys(item)) {
      if (normalizedKeys.includes(objectKey.toLowerCase())) {
        const value = item[objectKey]
        if (value !== undefined && value !== null && value !== '') {
          return value
        }
      }
    }
    return null
  }

  getContainerStackPositionValue(
    container: any,
    axis: 'tire' | 'level',
    allContainers: any[] = this.containerStackModal.containers || []
  ) {
    const layer = this.getContainerStackProp(container, 'layer', 'Layer')
    const tireNo = this.getContainerStackProp(
      container,
      'tireNo',
      'TireNo',
      'tierNo',
      'TierNo'
    )
    const levelNo = this.getContainerStackProp(container, 'levelNo', 'LevelNo')
    const stackRow = container._stackRow

    const siblings = allContainers.filter(
      (item) => item._stackRow === stackRow && stackRow != null
    )
    const siblingTireValues = new Set(
      siblings
        .map((item) => Number(this.getContainerStackProp(item, 'tireNo', 'TireNo')))
        .filter((value) => Number.isFinite(value) && value > 0)
    )
    const siblingLayerValues = new Set(
      siblings
        .map((item) => Number(this.getContainerStackProp(item, 'layer', 'Layer')))
        .filter((value) => Number.isFinite(value) && value > 0)
    )
    const tireNoIsVertical =
      siblingTireValues.size > 1 &&
      siblingLayerValues.size <= 1 &&
      (levelNo == null || Number(levelNo) === 1)

    if (axis === 'tire') {
      if (tireNoIsVertical) {
        return stackRow ?? levelNo ?? tireNo ?? 1
      }
      if (stackRow != null && stackRow !== '') {
        return stackRow
      }
      return tireNo ?? levelNo ?? stackRow
    }

    if (layer != null) {
      return layer
    }

    if (tireNoIsVertical && tireNo != null) {
      return tireNo
    }

    if (levelNo != null && Number(levelNo) > 1) {
      return levelNo
    }

    return levelNo ?? container._stackIndex ?? null
  }

  getContainerStackCell(tireNo: number, levelNo: number) {
    return this.containerStackCellMap.get(`${tireNo}-${levelNo}`) || null
  }

  getContainerStackDisplayId(container: any) {
    return (
      this.getContainerStackProp(container, 'containerNo', 'ContainerNo') ||
      this.getContainerStackProp(container, 'id', 'Id') ||
      '-'
    )
  }

  get containerStackCellViewMap(): Record<string, any> {
    const map: Record<string, any> = {}
    this.containerStackCellMap.forEach((container, key) => {
      map[key] = this.buildContainerStackCellView(container)
    })
    return map
  }

  buildContainerStackCellView(container: any) {
    const loadStatus = this.getContainerStackProp(
      container,
      'loadStatus',
      'LoadStatus'
    )
    const isEmpty =
      loadStatus === 'E' ||
      loadStatus === 'Empty' ||
      loadStatus === false

    return {
      isEmpty,
      cellNo:
        this.getContainerStackProp(container, 'positionId', 'PositionId') ??
        `${this.containerStackModal.area}-${this.containerStackModal.bay}`,
      weightLevel:
        this.getContainerStackProp(container, 'weightLevel', 'WeightLevel') ??
        'WL',
      containerNo: this.getContainerStackDisplayId(container),
      containerSize:
        this.getContainerStackProp(
          container,
          'lengthFt',
          'LengthFt',
          'containerSize',
          'ContainerSize'
        ) ?? '',
      containerType:
        this.getContainerStackProp(
          container,
          'containerType',
          'ContainerType',
          'type',
          'Type'
        ) ?? '',
      grossWeight:
        this.getContainerStackProp(container, 'weight', 'Weight') ?? 'W',
      temprature:
        this.getContainerStackProp(
          container,
          'temprature',
          'Temprature',
          'temperature',
          'Temperature'
        ) ?? '-',
      iMODGClassNumber:
        this.getContainerStackProp(
          container,
          'iMODGClassNumber',
          'IMODGClassNumber',
          'imodgClassNumber'
        ) ?? '-',
      fill:
        this.getContainerStackProp(container, 'fill', 'Fill') ?? '009999',
    }
  }

  getContainerStackCellView(tireNo: number, levelNo: number) {
    return this.containerStackCellViewMap[`${tireNo}-${levelNo}`] ?? null
  }

  getContainerStackCellTitle(tireNo: number, levelNo: number) {
    const container = this.getContainerStackCell(tireNo, levelNo)
    if (!container) {
      return ''
    }
    const containerNo = this.getContainerStackDisplayId(container)
    const loadStatus = this.getContainerStackProp(
      container,
      'loadStatus',
      'LoadStatus'
    )
    const size = this.getContainerStackProp(
      container,
      'lengthFt',
      'LengthFt',
      'containerSize',
      'ContainerSize'
    )
    return [containerNo, size, loadStatus].filter(Boolean).join(' | ')
  }
  onContainerStackCellClicked(tireNo: number, levelNo: number) {
    const container = this.getContainerStackCell(tireNo, levelNo)
    if (!container) {
      return
    }
    const containerinfo = JSON.stringify(container)
    const url = window.location.href
    this.$router.push(`?containerinfo=${containerinfo}`)
    setTimeout(() => { window.location.replace(url) }, 200)
  }

  get designing() {
    if (!(this.editor && this.editor.editObject)) return ""
    return this.editor.editObject.yardviewObject.GeoShape
  }

  constructor() {
    super()

    this.isPageRefreshing = this.$store.state.berthMonitoring.isPageRefreshing
    this.renderQuality = "High"
    this.sessionId = this.readQueryStringParams()


    //this.sessionId = this.getSessionId();

    //const path = window["appInterface"].getWebServicesBaseUrl();
    //
    //let webserviceurl = "http://localhost:59003";
    let webserviceurl = "http://localhost:5000/api/v1/system/yard/"

    //let webserviceurl ="http://development-cluster.phaeros.com/yardview-webservices" ;
    // FIXME: temporarily commented out
    // Instantiate the Terminal Control API component
  }
  getSessionId(): string {
    let sessionId = ""


    this.useRoro3dModel = false

    window.location.href.replace(
      /[?&]+([^=&]+)=([^&]*)/gi,
      //@ts-ignore
      (m: string, key: string, value: string) => {
        if (key.toLowerCase() == "sessionid") {
          sessionId = value
        }
        if (key.toLowerCase() == "useroro3dmodel") {
          this.useRoro3dModel = Number(value) == 1
        }
      }
    )

    //For testing purposes only
    if (!sessionId) {
      //  sessionId = "130b02a0-920b-4616-9143-e28369e553dc";
      sessionId = "xxx"

      //sessionId = "4809fea4-d3e0-431d-b633-bfec73ab59e9";
      //console.error("No session Id found!");
    }

    return sessionId
  }
  created() {
    // فرض کنید که می‌خواهید ابعاد نقشه را به 500px در 300px تغییر دهید
   // this.$refs.map.style.width = "500px";
   // this.$refs.map.style.height = "300px";

    // سپس با فراخوانی متد resize نقشه را به ابعاد جدید تطبیق دهید
    //this.map.resize();
  }
  // getInit() {
  //     this.$store.dispatch(GETBerthInit).then(() => {
  //       const errors = this.getBerthChartErrors;
  //       if (errors.length > 0) {
  //         this.showErrors(errors);
  //       } else {
  //         var model = this.getBerthChartInit;
  //         this.terminals = model.ports;

  //         if (this.terminals.length > 0) {
  //           if (this.standalone) {
  //             this.terminal = [this.terminals[0].id];
  //             this.terminalId = this.terminals[0].id;
  //           }
  //         }
  //         this.Refresh_Click();
  //       }
  //     });
  //   }


  @Watch("selectionMode")
  onSelectionModeChanged() {
    this.toggleOccupationLayers()
  }


  @Watch("terminalId")
  onTerminalIdChanged(val, oldVal) {
    if (val != oldVal && val !== undefined) {
      this._onMapReloaded()
    }
  }

  @Watch("isPageRefreshing")
  function() {
  }

  @Watch("previewMode")
  onPreviewModeChanged() {
    this.toggleOccupationLayers()
  }
  rePaintMap(terminalId: string, renderQuality: string) {
    this.renderQuality = renderQuality
    if (this.renderQuality == "Low") {
      this.useRoro3dModel = false
    }
    this.terminalId = terminalId
    this.map.remove()

    this.congigMapbox(this.mapElement)
  }

  mapResize() {
    this.map.resize()
  }

  mounted() {
    //this.sessionId=this.getSessionFromBerthViewApi();
    this.sessionId = this.readQueryStringParams()
    // this.getInit();
    //this.readQueryStringParams();

    this.congigMapbox(this.mapElement)
    this.bindMapResizeObserver()
    
  }

  congigMapbox(parentEL: HTMLElement) {
    let firstlocation = { lng: 0, lat: 0, bearing: 0, zoom: 1 }
    if (this.BerthData) {
      firstlocation = this.extractTerminalLocation(this.BerthData.data)
    }

    // TODO removed temporarily
    //Support Right to left
    // if (mapboxgl.getRTLTextPluginStatus() !== "loaded") {
    //   mapboxgl.setRTLTextPlugin(
    //     "https://api.mapbox.com/mapbox-gl-js/plugins/mapbox-gl-rtl-text/v0.2.3/mapbox-gl-rtl-text.js",
    //     null,
    //     true // Lazy load the plugin
    //   )
    // }



    this.map = new mapboxgl.Map({
      container: parentEL,
      style: this.selectedStyle,
      center: [firstlocation.lng, firstlocation.lat],
      zoom: firstlocation.zoom ? firstlocation.zoom : 14,
      bearing: firstlocation.bearing,
      antialias: false,
      maxPitch: 60,
    })

    // Disable default box zooming.
    this.map.boxZoom.disable()
    this.editor = new EditorTool(this.map)

    this.areas = []
    this.slots = []
    this.stacks = []
    this.containers = []
    this.vechiles = []

    this.map.on("load", () => {
      this.map.resize()
      this._onMapLoaded()
    })
    this.map.on("pitch", () => this._onPitch())
    this.map.on("click", (e) => this.onFeatureClicked(e))
    this.map.on("mousemove", (e) => this._onMouseMove(e))
    this.map.on("rotateend", () => this._onRotated())

    const me = this

    //@ts-ignore
    window.update = function update() {
      //@ts-ignore
      this.update()
    }

    //@ts-ignore
    window.design = function design(yvObject, yvOverrideShape) {
      if (me.editor != null) {
        me.editor.design(yvObject, yvOverrideShape)
      }
    }

    //@ts-ignore
    window.preview = function preview(yvObject) {
      me.preview(JSON.parse(yvObject))
    }

    //@ts-ignore
    window.refresh = function refresh(includingStructure) {
      me.refresh(includingStructure)
    }

    window["highlightSlots"] = function highlightSlots(selected: string) {
      me.highlightSlots(selected)
    }

    window["selectSlots"] = function selectSlots(selected: string) {
      me.selectSlots(selected)
    }

    window["addContainerStacksToMap"] = function addContainerStacksToMap(stacks: any) {
      me.addContainerStacksToMap(stacks)
    }
    // به‌روزرسانی ابعاد نقشه در صورت تغییر اندازه صفحه
  window.addEventListener("resize", () => {
      if (me.map) {
        me.map.resize()
      }
    })
  }

  beforeDestroy() {
    if (this.mapResizeObserver) {
      this.mapResizeObserver.disconnect()
      this.mapResizeObserver = null
    }
  }
  
   bindMapResizeObserver() {
    if (!this.mapElement || typeof ResizeObserver === "undefined") {
      return
    }

    this.mapResizeObserver = new ResizeObserver(() => {
      if (this.map) {
        this.map.resize()
      }
    })

    const rootEl = this.mapElement.parentElement
    if (rootEl) {
      this.mapResizeObserver.observe(rootEl)
    }
    this.mapResizeObserver.observe(this.mapElement)

    this.$nextTick(() => {
      this.map?.resize()
    })
  }

  generateAnchorageLine(geoShapePoints) {
    const geometryCoordinates: Array<Array<number>> = []
    const coordinates = geoShapePoints.split(",")
    coordinates.forEach((coordinate) => {
      const latlon = coordinate.split("/")
      geometryCoordinates.push([Number(latlon[1]), Number(latlon[0])])
    })

    return turf.lineString(geometryCoordinates, {
      code: "",
      objectType: "",
      structure: "POLYLINE",
    })
  }
  getBerths() {
    if (this.terminal == undefined) {
      this.berthTimeout = 2000
    }
    this.sessionId = this.readQueryStringParams()
    const url = `tos/BerthMonitoring/getterminalmonitoring`
    const payload = {
      terminalId: typeof (this.terminal) == 'object' ? this.terminal[0] : this.terminal
    }

    this.$store.state.berthMonitoring.isLoading = true
    ApiService.setUserPayload()
    ApiService
      .post(url, payload)
      .then(({ data }) => {
        this.berthTimeout = 0
        if (data.isSuccessful) {
          this.BerthData = data

          setTimeout(() => {
            this.RenderBerth(data)
          }, 2000)
        } else {
          console.error("error load terminal data:", this.$props.terminal[0])
        }
      })
      .catch(console.error).finally(() => {
        this.$store.state.berthMonitoring.isLoading = false
      })
  }
  addBolardsLabel(bolards) {
    bolards.forEach((item) => {
      const objCoordLane = turf.destination(item.position, 0, 0)

      const bolard = item.bolard

      const labelRotation = this.getLabelRotation(0)
      const label = item.bolard.name //+ "\n" + String(vParameters.berthId);
      const vParameters = {
        origin: objCoordLane,
        vin: bolard.name,
        berthId: item.berthId,
        bolardId: Number(bolard.id),
        //  row: ncount,
      }
      const props = {
        label: label,
        code: label,
        anchor: "top-center",
        offset: [0.0, 1],
        rotate: labelRotation,
      }
      objCoordLane.properties = props

      //  this.object3dlabelsFeatures.push(objCoordLane);
      this.bolards.push(vParameters)
    })
    this.renderBerthLabels()
  }
  renderBerthLabels() {
    const bolardslotsSource: GeoJSONSource = this.map.getSource(
      "object3dlabels"
    ) as GeoJSONSource
    bolardslotsSource?.setData(
      turf.featureCollection(
        this.object3dlabelsFeatures
      ) as GeoJSON.FeatureCollection<GeoJSON.Geometry>
    )

    //Set vechiles stacks data
     const rorobox3dSource: GeoJSONSource = this.map.getSource(
      "vechiles"
    ) as GeoJSONSource

    rorobox3dSource.setData(
      turf.featureCollection(
        this.vechiles
      ) as GeoJSON.FeatureCollection<GeoJSON.Geometry>
    )
   //this.syncVechilesSource()
  }
  
  extractTerminalLocation(data: BerthManagment.Data) {
    let target = [0, 0]

    if (
      data.mapLatitude &&
      data.mapLongitude &&
      Number(data.mapLatitude) &&
      Number(data.mapLongitude)
    ) {
      target = [Number(data.mapLongitude), Number(data.mapLatitude)]
    } else {
      if (data.berths.length > 0) {
        const points = this.getBerthCoordinates(data.berths[0])
        target = [Number(points[0][0]), Number(points[0][1])]
      } else {
        const points = this.getAnchroheLineCoordinates(data.geoAnchorageLine)
        target = [Number(points[0][0]), Number(points[0][1])]
      }
    }
    let bearing = 0
    if (data.mapBearing) {
      bearing = Number(data.mapBearing)
    }
    return { lng: target[0], lat: target[1], bearing: bearing, zoom: 14 }
  }
  flytoTerminalPosition(data: BerthManagment.Data) {
    const result = this.extractTerminalLocation(data)
    this.map.setPitch(0)
    //24.25185906455384/54.44505079512584
    this.map.flyTo({
      center: [result.lng, result.lat],
      //  center: [54.44505079512584, 24.25185906455384],
      bearing: result.bearing,
      zoom: 16, // this.map.getZoom(),
      essential: true, // this animation is considered essential with respect to prefers-reduced-motion
    })
  }
  RenderBerth(res: BerthManagment.RootObject) {

    if (res.isSuccessful) {
      this.flytoTerminalPosition(res.data)
      if (!res.data.berths || res.data.berths.length == 0) {
        this.pagecomplete()
        return
      }
      const berthGroups = this.getBerthGroups(res.data)

      berthGroups.forEach((item) => {
        item.portUnCode = res.data.portUnCode
        item.portName = res.data.portName
        item.name = res.data.name
        const berhsLayer = new BerthsLayer(item, (bolards) => {
          this.addBolardsLabel(bolards)

          if (item.voyageInBerths)
            this.VoyageInBerthRender(item.voyageInBerths, item)
        })
        this.map.addLayer(berhsLayer as mapboxgl.AnyLayer)
      })
      this.VoyageInAnchoragesRender(res.data)
      this.renderBerthLabels()
      this.pagecomplete()

      // SECTION Add ship layers to map
      this.map.addLayer({
        id: `vessel-peripheral-layer`,
        type: 'line',
        source: 'vechiles',
        paint: {
          'line-color': 'transparent',
        }
      })
      this.map.addLayer({
        id: `vessel-surface-layer`,
        type: 'fill',
        source: 'vechiles',
        paint: {
          'fill-color': 'transparent',
          'fill-opacity': 1.0
        }
      })
      // !SECTION Add ship layers to map

    } else {
      console.error(res.message.join(","))
    }
  }
  getBerthGroups(data: BerthManagment.Data) {
    const BerthGroups: BerthManagment.Data[] = []
    let drawBerths: BerthManagment.Data = {} as BerthManagment.Data

    drawBerths.berths = []
    drawBerths.berths.push(data.berths[0])
    let sumlength = data.berths[0].length
    let berthPoints0 = this.getBerthCoordinates(data.berths[0])

    for (let i = 1; i < data.berths.length; i++) {
      const berth = data.berths[i]
      const berthPoints = this.getBerthCoordinates(berth)
      if (berthPoints && berthPoints.length > 0) {
        const distance =
          1000 *
          turf.distance(
            [berthPoints0[0][0], berthPoints0[0][1]],
            [berthPoints[0][0], berthPoints[0][1]]
          )
        if (distance - sumlength > 5) {
          berthPoints0 = this.getBerthCoordinates(berth)
          sumlength = 0
          BerthGroups.push(Object.assign({}, drawBerths))
          drawBerths.berths = []
          drawBerths.berths.push(data.berths[i])
        } else {
          sumlength += berth.length + (distance - sumlength)
        }
      } else {
        drawBerths.berths.push(berth)
        sumlength += berth.length
      }

      //drawBerths.berths.push(berth);
    }

    BerthGroups.push(drawBerths)
    for (let i = 0; i < data.voyageInBerths.length; i++) {
      const ship = data.voyageInBerths[i]
      for (let g = 0; g < BerthGroups.length; g++) {
        if (this.CheckIsInGroup(ship, BerthGroups[g])) {
          if (!BerthGroups[g].voyageInBerths) {
            BerthGroups[g].voyageInBerths = []
          }
          BerthGroups[g].voyageInBerths.push(Object.assign({}, ship))
        }
      }
    }
    for (let i = 0; i < BerthGroups.length; i++) {
      BerthGroups[i].id = `GROUP_${i}-${uuidv4()}`
    }
    return BerthGroups
  }
  CheckIsInGroup(
    ship: BerthManagment.VoyageInBerth,
    berthGroup: BerthManagment.Data
  ) {
    const ids: number[] = []
    berthGroup.berths.forEach((v) => {
      const u = v.bollards.map((r) => r.id)
      ids.push(...u)
    })
    const results = ids.filter((id) => id == Number(ship.startBollardId))

    return results.length > 0
  }

  getAnchroheLineCoordinates(geoAnchorageLine: string) {
    const geometryCoordinates: Array<Array<number>> = []
    if (geoAnchorageLine) {
      try {
        const geogson = JSON.parse(geoAnchorageLine)
        if (geogson.geometry && geogson.geometry.coordinates) {
          geogson.geometry.coordinates.forEach((item) => {
            geometryCoordinates.push([item[0], item[1]])
          })
        }
      } catch {
        const coordinates = geoAnchorageLine.split(",")
        coordinates.forEach((coordinate) => {
          const latlon = coordinate.split("/")
          geometryCoordinates.push([Number(latlon[1]), Number(latlon[0])])
        })
      }
    }

    return geometryCoordinates
  }
  getBerthCoordinates(Berth: BerthManagment.Berth) {
    const geometryCoordinates: Array<Array<number>> = []
    if (Berth.polygon) {
      try {
        const geogson = JSON.parse(Berth.polygon)
        if (geogson.geometry && geogson.geometry.coordinates) {
          geogson.geometry.coordinates[0].forEach((item) => {
            geometryCoordinates.push([item[0], item[1]])
          })
        }
      } catch {
        const coordinates = Berth.polygon.split(",")
        coordinates.forEach((coordinate) => {
          const latlon = coordinate.split("/")
          geometryCoordinates.push([Number(latlon[1]), Number(latlon[0])])
        })
      }
    }

    return geometryCoordinates
  }
  VoyageInBerthRender(
    VoyageInBerths: BerthManagment.VoyageInBerth[],
    data: BerthManagment.Data
  ) {
    const BerhStartPoints = this.getBerthCoordinates(data.berths[0])
    const anglex = turf.bearing(BerhStartPoints[0], BerhStartPoints[1])
    let angley = turf.bearing(BerhStartPoints[1], BerhStartPoints[2])
    const BerthHeight = 70 //    1000 * turf.distance(BerhStartPoints[1], BerhStartPoints[2]);
    //const fg = turf.destination.destination(BerhStartPoints[2], BerthHeight / 1000, anglex + 90);

    let feturePoints = []
    for (let i = 0; i < VoyageInBerths.length; i++) {
      feturePoints = []
      const ship = VoyageInBerths[i]

      const bolard = this.bolards.find(
        (bolrad) => bolrad.bolardId == Number(ship.startBollardId)
      )

      const endbolard = this.bolards.find(
        (bolrad) => bolrad.bolardId == Number(ship.endBollardId)
      )

      //P0
      feturePoints.push(bolard.origin.geometry.coordinates)

      const endpoint = turf.destination(bolard.origin, ship.loa / 1000, anglex)

      //P1
      feturePoints.push(endpoint.geometry.coordinates)
      //P2
      const newPoint2 = turf.destination(endpoint, BerthHeight / 1000, angley)
      feturePoints.push(newPoint2.geometry.coordinates)

      //P3
      const P3 = turf.destination(bolard.origin, BerthHeight / 1000, angley)
      feturePoints.push(P3.geometry.coordinates)

      const fetureShip = this.CreateShip3DFetureModel(feturePoints, ship, data)
      this.vechiles.push(fetureShip)

      const origin = turf.midpoint(bolard.origin, newPoint2)

      const shiplayear = new ShipLayer(
        origin,
        ship,
        bolard.origin,
        endpoint,
        anglex
      )
      this.map.addLayer(shiplayear as mapboxgl.AnyLayer)

      const captionOrigin = turf.destination(
        origin,
        ship.loa / 3 / 1000,
        angley
      )
      const label = `${ship.vesselName}\n(${ship.voyageNoIn},${ship.voyageNoOut})\n${ship.loa}m`
      const props = {
        label: label,
        code: ship.id,
        anchor: "top-center",
        offset: [0.0, -1],
        rotate: 0,
      }
      captionOrigin.properties = props
      this.object3dlabelsFeatures.push(captionOrigin)
    }
    this.renderBerthLabels()
  }
  CreateShip3DFetureModel(points, ship, terminal) {
    const properties = {
      base: 0,
      height: 50,
      layer: 1,
      shipid: ship.id,
      shipName: ship.vesselName,
      type: "ship",
      maxLayer: 1,
      terminal: terminal.name,
      portName: terminal.portName,
      portUnCode: terminal.portUnCode,
    }

    return turf.polygon(
      [
        [
          //@ts-ignore
          points[0],
          //@ts-ignore
          points[1],
          //@ts-ignore
          points[2],

          //@ts-ignore
          points[3],
          //@ts-ignore
          points[0],
        ],
      ],
      {
        ...properties,
      }
    )
  }

  VoyageInAnchoragesRender(data: BerthManagment.Data) {
    const VoyageInAnchorages = data.voyageInAnchorages
    let geometryCoordinates: Array<Array<number>> = []

    const points = this.getAnchroheLineCoordinates(data.geoAnchorageLine)
    points.forEach((coordinate) => {
      geometryCoordinates.push([coordinate[0], coordinate[1]])
    })

    // geometryCoordinates.reverse();
    geometryCoordinates = this.addnewPoint(
      geometryCoordinates,
      VoyageInAnchorages.length + 1
    )

    for (let i = 0; i < VoyageInAnchorages.length; i++) {
      const ship = VoyageInAnchorages[i]
      const feturePoints = []
      const startPoint = turf.destination(geometryCoordinates[i], 0, 0)
      const bearing = turf.bearing(startPoint, geometryCoordinates[i + 1])
      const shipWidth = Number(ship.loa)
      const endPoint = turf.destination(startPoint, shipWidth / 1000, bearing)
      const midPoint = turf.midpoint(startPoint, endPoint)
      const shiplayear1 = new ShipLayer(
        midPoint,
        ship,
        startPoint,
        endPoint,
        bearing,
      )

      this.map.addLayer(shiplayear1 as mapboxgl.AnyLayer)
      //this.roro3DModelList.push(shiplayear1.id)

      const captionOrigin = turf.destination(
        midPoint,
        shipWidth / 3 / 1000,
        bearing + 90
      )
      //Create Ship Feture For Click Event
      //P0
      const p0 = turf.destination(
        startPoint,
        shipWidth / 4 / 1000,
        90 + bearing
      )
      const p3 = turf.destination(
        startPoint,
        shipWidth / 4 / 1000,
        270 + bearing
      )
      const p1 = turf.destination(endPoint, shipWidth / 4 / 1000, 90 + bearing)
      const p2 = turf.destination(
        endPoint,
        shipWidth / 4 / 1000,
        270 + bearing
      )
      feturePoints.push(p0.geometry.coordinates)
      feturePoints.push(p1.geometry.coordinates)
      feturePoints.push(p2.geometry.coordinates)
      feturePoints.push(p3.geometry.coordinates)
      const fetureShip = this.CreateShip3DFetureModel(feturePoints, ship, data)
      this.vechiles.push(fetureShip)

      // Create ship Label
      const label = `${ship.vesselName}\n(${ship.voyageNoIn},${ship.voyageNoOut})\n${ship.loa}m`
      const props = {
        label: label,
        code: ship.id,
        anchor: "top-center",
        offset: [0.0, -1],
        rotate: 0,
      }
      captionOrigin.properties = props
      this.object3dlabelsFeatures.push(captionOrigin)
    }
  }


  addnewPoint(coordinates, count) {
    const geometryCoordinates: Array<Array<number>> = []

    for (let i = 0; i < coordinates.length - 1; i++) {
      geometryCoordinates.push(coordinates[i])
      const midPoint = turf.midpoint(coordinates[i], coordinates[i + 1])
      const lat = Number(midPoint.geometry.coordinates[0])
      const lng = Number(midPoint.geometry.coordinates[1])
      geometryCoordinates.push([lat, lng])
    }
    geometryCoordinates.push(coordinates[coordinates.length - 1])
    if (geometryCoordinates.length >= count) {
      return geometryCoordinates
    } else {
      const geopoints = this.addnewPoint(geometryCoordinates, count)
      return geopoints
    }
  }

  _onMapReloaded() {

    if (this.berthTimeout == 0) {
      this.clear3DModels()
      this.berthTimeout = setTimeout(() => this.getBerths(), 2000)
      this.fetchObjectData()
    }
  }

  _onMapLoaded() {
    this.createSources()
    this._createLayers()




    // try {
    //   this.fetchColorSettings((error, colorScheme) => {
    //     this._createLayers(colorScheme)

    //     this.selectSlotsTool = new SelectSlotsTool(
    //       this.map as mapboxgl.Map,
    //       this.slotsDict
    //     )
    //   })
    // } catch (error) {
    //   console.error('error creating layers')
    // }

    this.fetchObjectData()
    if (this.apiUrl) {

      // Api Url read from query string
      if (this.berthTimeout == 0) {
        this.clear3DModels()
        this.berthTimeout = setTimeout(() => this.getBerths(), 2000)
      }
    } else {

      // Api Url read from appSetting.json
      axios
        .get("/json/appSetting.json", { baseURL: '/' })
        .then(({ data }) => {
          this.apiUrl = data.serverUrl
          this.clear3DModels()
          //debugger;
          //  this.getBerths();
          if (this.berthTimeout == 0) {
            this.berthTimeout = setTimeout(() => this.getBerths(), 2000)
          }
        })
        .catch(console.error)
    }
  }
  /**
   * Is called when the map is pitched
   */
  _onPitch() {
    this.toggleOccupationLayers()
  }
  /**
   * Is called when the map is rotated
   */
  _onRotated() {
    this.renderOnlyAreas()
  }
  /**
   * Create the MapBox data sources
   */
  createSources() {
    if (!this.map) return
    this.map.addSource("area-labels-hitbox", {
      type: "geojson",
      data: {
        type: "FeatureCollection",
        features: [],
      },
    })

    this.map.addSource("areas", {
      type: "geojson",
      data: {
        type: "FeatureCollection",
        features: [],
      },
    })

    this.map.addSource("slots", {
      type: "geojson",
      data: {
        type: "FeatureCollection",
        features: [],
      },
    })

    this.map.addSource("occupation", {
      type: "geojson",
      data: {
        type: "FeatureCollection",
        features: [],
      },
    })

    this.map.addSource("containers", {
      type: "geojson",
      data: {
        type: "FeatureCollection",
        features: [],
      },
    })

    this.map.addSource("containers-filtered", {
      type: "geojson",
      data: {
        type: "FeatureCollection",
        features: [],
      },
    })


    //vechiles
    this.map.addSource("vechiles", {
      type: "geojson",
      data: {
        type: "FeatureCollection",
        features: [],
      },
    })

    // this.map.addSource("previewareas", {
    //   type: "geojson",
    //   data: {
    //     type: "FeatureCollection",
    //     features: [],
    //   },
    // })
    // this.map.addSource("previewslots", {
    //   type: "geojson",
    //   data: {
    //     type: "FeatureCollection",
    //     features: [],
    //   },
    // })

    this.map.addSource("object3dlabels", {
      type: "geojson",
      data: {
        type: "FeatureCollection",
        features: [],
      },
    })
    this.map.addSource("eq2Ds", {
      type: "geojson",
      data: {
        type: "FeatureCollection",
        features: [],
      },
    });
    this.map.addSource("eq2DsLabels", {
      type: "geojson",
      data: {
        type: "FeatureCollection",
        features: [],
      },
    });
  }

  _createLayers(colorScheme: Array<ColorScheme>) {


    if (this.map == null) {
      return
    }

    let objectColor
    let slotColorScheme
    let areaColorFillStyle: Array<string> = []
    let areaColorStrokeStyle: Array<string> = []
    let stackColorStyle: Array<string | number> = []

    if (colorScheme) {
      objectColor = colorScheme.find((color) => {
        return color.Category == "Object" && color.Subcategory == null
      })

      //Generate the stack color style
      colorScheme
        .filter((color) => {
          return color.Category == "Object" && color.Subcategory != null
        })
        .forEach((areaColorScheme) => {
          areaColorFillStyle.push(areaColorScheme.Subcategory)
          areaColorFillStyle.push(areaColorScheme.FillColor)
          areaColorStrokeStyle.push(areaColorScheme.Subcategory)
          areaColorStrokeStyle.push(areaColorScheme.BorderColor)
        })

      slotColorScheme = colorScheme.find((color) => {
        return color.Category == "Layer" && color.Subcategory == "0"
      })

      //Generate the stack color style
      colorScheme
        .filter((color) => {
          return color.Category == "Layer" && Number(color.Subcategory) > 0
        })
        .forEach((layer) => {
          stackColorStyle.push(Number(layer.Subcategory))
          stackColorStyle.push(layer.FillColor)
        })
    }
    if (!slotColorScheme) {
      slotColorScheme = {
        BorderColor: "#333",
        FillColor: "#ccc",
      }
    }
    if (!objectColor) {
      objectColor = {
        BorderColor: "#555",
        FillColor: "#ddd",
      }
    }
    if (areaColorFillStyle.length == 0) {
      areaColorFillStyle = ["Highlight", "#ffff9e"]
    }
    if (areaColorStrokeStyle.length == 0) {
      areaColorStrokeStyle = ["Highlight", "#ff0"]
    }
    if (stackColorStyle.length == 0) {
      stackColorStyle = [
        1,
        "#fbb03b",
        2,
        "#223b53",
        3,
        "#e55e5e",
        4,
        "#3bb2d0",
      ]
    }

    let paintConfiguration = {
      "fill-color": objectColor.FillColor,
      "fill-outline-color": objectColor.BorderColor,
    }

    paintConfiguration = {
      "fill-color": [
        "match",
        ["get", "objectType"],
        ...areaColorFillStyle,
        objectColor.FillColor,
      ],
      "fill-outline-color": [
        "match",
        ["get", "objectType"],
        ...areaColorStrokeStyle,
        objectColor.BorderColor,
      ],
      "fill-opacity": [
        "case",
        ["boolean", ["!=", ["get", "structure"], "LANE"], false],
        1,
        0,
      ], //if structure LANE then opacity set zero
    }


    this.map.addLayer({
      id: "areas",
      type: "fill",
      source: "areas",
      paint: paintConfiguration,
      filter: ["!=", ["geometry-type"], "LineString"],
    })

    // this.map.addLayer({
    //   id: "lines",
    //   type: "line",
    //   source: "areas",
    //   paint: {
    //     "line-color": [
    //       "match",
    //       ["get", "objectType"],
    //       ...areaColorStrokeStyle,
    //       objectColor.BorderColor,
    //     ],
    //     "line-width": 3,
    //   } as LinePaint,
    //   filter: ["==", ["geometry-type"], "LineString"],
    // })

    // this.map.addLayer({
    //   id: "line-labels",
    //   type: "symbol",
    //   source: "areas",
    //   filter: ["==", ["geometry-type"], "LineString"],
    //   layout: {
    //     "symbol-placement": "line",
    //     "text-field": [
    //       "format",
    //       ["upcase", ["get", "code"]],
    //       { "font-scale": 0.8 },
    //     ],
    //     "text-font": ["Open Sans Semibold", "Arial Unicode MS Bold"],
    //   },
    //   paint: {
    //     "text-color": "#202",
    //     "text-halo-color": "#fff",
    //     "text-halo-width": 2,
    //   },
    // })

    this.map.addLayer({
      id: `slots`,
      type: "fill",
      source: "slots",
      paint: {
        "fill-color": slotColorScheme ? slotColorScheme.FillColor : "#CCC",
        "fill-outline-color": slotColorScheme.BorderColor,
      },
      filter: ["==", ["geometry-type"], "Polygon"],
    })

    this.map.addLayer({
      id: 'slot-cross-lines',
      type: 'line',
      source: 'slots',
      paint: {
        'line-color': '#212529',
        'line-width': 2,
        'line-opacity': 0.8
      },
      filter: ['all',
        ['==', ['geometry-type'], 'LineString'],
        ['==', ['get', 'crossLine'], true]
      ]
    });

    this.map.addLayer({
      id: `stacks2D`,
      type: "fill",
      source: "containers",
      paint: {
        "fill-color": [
          "match",
          ["get", "maxLayer"],
          ...stackColorStyle,
          slotColorScheme.FillColor,
        ],
        "fill-outline-color": "#999",
      } as FillPaint,
    })

    this.map.addLayer({
      id: "area-labels-hitbox",
      type: "circle",
      source: "area-labels-hitbox",
      paint: {
        "circle-radius": 5,
        "circle-radius": {
          stops: [
            [15, 10],   // در zoom 15، شعاع 15 پیکسل
            [16, 15],   // در zoom 16، شعاع 20 پیکسل
            [20, 20],   // در zoom 20، شعاع 30 پیکسل
          ],
        },
        "circle-color": "red",
        "circle-opacity": 0.0,
        "circle-stroke-opacity": 0.0,
        "circle-stroke-color": "black",
      },
    })

    const me = this
    // setTimeout(() => {
    //   const containersData = me.containers


    //   const containerLayer = new ContainerLayer(containersData)
    //   me.map.addLayer(containerLayer)
    // }, 3000)



    this.map.addLayer({
      id: "stacks3D",
      type: "fill-extrusion",
      source: "containers",
      layout: {
        visibility: "none",
      },
      paint: {
        "fill-extrusion-color": [
          "match",
          ["get", "layer"],
          ...stackColorStyle,
          slotColorScheme.FillColor,
        ],
        "fill-extrusion-height": ["get", "height"],
        "fill-extrusion-base": ["get", "base"],
        "fill-extrusion-opacity": 0.9,  // مقدار پیش‌فرض
      },
    })

    this.map.addLayer({
      id: "stacks3D-dimmed",
      type: "fill-extrusion",
      source: "containers-filtered",
      layout: {
        visibility: "none",
      },
      paint: {
        "fill-extrusion-color": [
          "match",
          ["get", "layer"],
          ...stackColorStyle,
          slotColorScheme.FillColor,
        ],
        "fill-extrusion-height": ["get", "height"],
        "fill-extrusion-base": ["get", "base"],
        "fill-extrusion-opacity": 0,
      },
    })

    // if (this.useRoro3dModel) {
    //   this.map.addLayer({
    //     id: "vechiles3D",
    //     type: "fill-extrusion",
    //     source: "vechiles",

    //     paint: {
    //       // Get fill-extrusion-height from the source 'height' property.
    //       "fill-extrusion-height": ["get", "height"],

    //       // Get fill-extrusion-height from the source 'height' property.
    //       "fill-extrusion-base": ["get", "base"],
    //       // Make extrusions slightly opaque for see through indoor walls.
    //       "fill-extrusion-opacity": 0.0,
    //     },
    //   })
    // }
    this.map.addLayer({
      id: "slot-labels",
      type: "symbol",
      source: "slots",
      minzoom: 18,
      layout: {
        "text-field": [
          "format",
          ["upcase", ["get", "label"]],
          { "font-scale": 0.8 },
        ],
        "text-font": ["Open Sans Semibold", "Arial Unicode MS Bold"],
        "text-offset": ["get", "offset"],
        "text-anchor": ["get", "anchor"],
        "text-size": {
          stops: [
            [16, 9],
            [16, 16],
            [20, 18],
          ],
        },
        "text-allow-overlap": true,
      },
      paint: {
        "text-color": "#202",
        "text-halo-color": "#fff",
        "text-halo-width": 2,
      },
    })

    this.map.addLayer({
      id: "area-labels",
      type: "symbol",
      source: "areas",
      interactive: true,
       layout: {
        "text-field": [
          "format",
          ["upcase", ["get", "label"]],
          { "font-scale": 1 },
        ],
        "text-font": ["Open Sans Semibold", "Arial Unicode MS Bold"],
        "text-offset": ["get", "offset"],
        "text-anchor": ["get", "anchor"],
        "text-size": {
          stops: [
            [10, 8],
            [16, 15],
            [20, 19],
          ],
        },
        "text-allow-overlap": true,
      },
      paint: {
        "text-color": "#000",
        "text-halo-color": "#000",
        "text-halo-width": 1,
      },
    })

    // this.map.addLayer({
    //   id: "previewareas",
    //   type: "fill",
    //   source: "previewareas",
    //   paint: {
    //     "fill-color": "#fff9a8",
    //     "fill-outline-color": "#b5af55",
    //   },
    //   filter: ["!=", "$type", "LineString"],
    // })

    // this.map.addLayer({
    //   id: "previewlines",
    //   type: "line",
    //   source: "previewareas",
    //   layout: {
    //     "line-join": "bevel",
    //     "line-cap": "round",
    //   },
    //   paint: {
    //     "line-color": "#fff9a8",
    //     "line-blur": 2,
    //     "line-width": 5,
    //   },
    //   filter: ["==", "$type", "LineString"],
    // })

    // this.map.addLayer({
    //   id: "previewslots",
    //   type: "fill",
    //   source: "previewslots",
    //   paint: {
    //     "fill-color": "#fff240",
    //     "fill-outline-color": "#807b38",
    //   },
    // })

    // this.map.addLayer({
    //   id: "preview-slot-labels",
    //   type: "symbol",
    //   source: "previewslots",
    //   minzoom: 16,
    //   layout: {
    //     "text-field": [
    //       "format",
    //       ["upcase", ["get", "label"]],
    //       { "font-scale": 0.5 },
    //     ],
    //     "text-font": ["Open Sans Semibold", "Arial Unicode MS Bold"],
    //     "text-offset": ["get", "offset"],
    //     "text-anchor": ["get", "anchor"],
    //   },
    //   paint: {
    //     "text-color": "#202",
    //     "text-halo-color": "#fff",
    //     "text-halo-width": 2,
    //   },
    // })

    this.map.addLayer({
      id: "object3d-labels",
      type: "symbol",
      maxzoom: 20,
      source: "object3dlabels",
      interactive: true,
      layout: {
        // "visibility": "none",
        "text-field": ["get", "label"],
        "text-font": ["Open Sans Semibold", "Arial Unicode MS Bold"],

        "text-offset": ["get", "offset"],
        "text-anchor": ["get", "anchor"],
        "text-rotation-alignment": "auto",
        "text-size": {
          stops: [
            [15, 6],
            [16, 12],
            [20, 17],
          ],
        },
      },
      paint: {
        "text-color": "#202",
        "text-halo-color": "#fff",
        "text-halo-width": 2,
      },
    })

    //@ts-ignore
    this.map.addLayer({
      id: `eq2Ds`,
      type: "fill",
      source: "eq2Ds",
      paint: {
        "fill-color": ["get", "statusColor"],
        "fill-outline-color": "#999",
        "fill-opacity": 0.9,
      } as mapboxgl.FillPaint,
    });

    this.map.addLayer({
      id: "eq-labels",
      type: "symbol",
      source: "eq2DsLabels",
      layout: {
        "text-field": ["format", ["upcase", ["get", "label"]]],
        "text-font": ["Open Sans Semibold", "Arial Unicode MS Bold"],
        "text-offset": ["get", "offset"],
        "text-anchor": ["get", "anchor"],
        "text-rotate": ["get", "rotate"],
        "text-rotation-alignment": "map",
        "text-size": {
          stops: [
            [15, 6],
            [16, 12],
            [20, 14],
          ],
        },
      },
      paint: {
        "text-color": "#202",
        "text-halo-color": "#fff",
        "text-halo-width": 2,
      },
    });

    this.map.addLayer({
      id: "rtg-surface-layer",
      type: "fill",
      source: "eq2Ds",
      paint: {
        "fill-color": "transparent",
        "fill-opacity": 1.0,
      },
    });

  }

  renderOnlyAreas() {
    if (this.map == null) {
      return
    }

    //Clear the slots array
    this.areas = []

    this.areaObjects.forEach((area) => {
      this.renderObject(area)
    })

    //Set area data
    const areaSource: GeoJSONSource = this.map.getSource(
      "areas"
    ) as GeoJSONSource
    areaSource.setData(
      turf.featureCollection(
        this.areas
      ) as GeoJSON.FeatureCollection<GeoJSON.Geometry>
    )


  }

  renderYard() {
    if (this.map == null) {
      return
    }

    //Clear the slots array
    this.slots = []
    this.areas = []
    this.slotParametersByPosition.clear()
    // this.bolardslots = [];

    this.areaObjects.forEach((area) => {
      if (area.Code !== this.previewObject) {
        this.renderObject(area)
      }
    })

    const bolardslotsSource: GeoJSONSource = this.map.getSource(
      "object3dlabels"
    ) as GeoJSONSource
    bolardslotsSource?.setData(
      turf.featureCollection(
        this.object3dlabelsFeatures
      ) as GeoJSON.FeatureCollection<GeoJSON.Geometry>
    )

    //Set area data
    const areaSource: GeoJSONSource = this.map.getSource(
      "areas"
    ) as GeoJSONSource

    areaSource.setData(
      turf.featureCollection(
        this.areas
      ) as GeoJSON.FeatureCollection<GeoJSON.Geometry>
    )

    //Set slot data
    const slotSource: GeoJSONSource = this.map.getSource(
      "slots"
    ) as GeoJSONSource

    slotSource.setData(
      turf.featureCollection(
        this.slots
      ) as GeoJSON.FeatureCollection<GeoJSON.Geometry>
    )
    const areaLabelHitboxes = this.areas
      .filter(feature => feature.geometry.type === 'Point' && feature.properties.label)
      .map(feature => ({
        ...feature,
        properties: {
          ...feature.properties,
          totalCapacity: feature.properties.totalCapacity,
          freeSpace: feature.properties.freeSpace,
          oneTEUFreeSlot: feature.properties.oneTEUFreeSlot,
          twoTEUFreeSlot: feature.properties.twoTEUFreeSlot,
          clickType: 'area-label'
        }
      }))

    const hitboxSource: GeoJSONSource = this.map.getSource(
      "area-labels-hitbox"
    ) as GeoJSONSource

    hitboxSource?.setData(
      turf.featureCollection(
        areaLabelHitboxes
      ) as GeoJSON.FeatureCollection<GeoJSON.Geometry>
    )

    if (!this.previewMode) {

      if (this.isFilterActive) {
        this.applyContainerFilter();
      } else {
        const occupationSource: GeoJSONSource = this.map.getSource(
          "occupation"
        ) as GeoJSONSource
        occupationSource.setData(
          turf.featureCollection(
            this.stacks
          ) as GeoJSON.FeatureCollection<GeoJSON.Geometry>
        )

        const containersSource: GeoJSONSource = this.map.getSource(
          "containers"
        ) as GeoJSONSource
        containersSource.setData(
          turf.featureCollection(
            this.containers
          ) as GeoJSON.FeatureCollection<GeoJSON.Geometry>
        )

        const containersFilteredSource: GeoJSONSource = this.map.getSource(
          "containers-filtered"
        ) as GeoJSONSource
        containersFilteredSource.setData(
          turf.featureCollection([]) as GeoJSON.FeatureCollection<GeoJSON.Geometry>
        )
      }

      //Set vechiles stacks data
      const rorobox3dSource: GeoJSONSource = this.map.getSource(
        "vechiles"
      ) as GeoJSONSource
      rorobox3dSource.setData(
        turf.featureCollection(
          this.vechiles
        ) as GeoJSON.FeatureCollection<GeoJSON.Geometry>
      )

      //Set equipments  data
      const eqSource: GeoJSONSource = this.map.getSource(
        "eq2Ds"
      ) as GeoJSONSource;
      eqSource.setData(
        turf.featureCollection(this.eq2Ds) as GeoJSON.FeatureCollection<
          GeoJSON.Geometry
        >
      );

      const eqSourceLb: GeoJSONSource = this.map.getSource(
        "eq2DsLabels"
      ) as GeoJSONSource;
      eqSourceLb.setData(
        turf.featureCollection(this.eq2DsLabels) as GeoJSON.FeatureCollection<
          GeoJSON.Geometry
        >
      );
    }
  }

  getLabelRotation(rotation) {
    let labelRotation = rotation
    if (this.map != null) {
      // const mapRotation = this.map.getBearing();

      let bearing = this.map.getBearing()
      if (bearing <= 0) {
        bearing *= -1
      } else {
        bearing = 360 - bearing
      }

      let sumRotations = bearing + rotation
      if (sumRotations > 360) {
        sumRotations -= 360
      }

      if (sumRotations > 90 && sumRotations < 270) {
        labelRotation = rotation + 180
        if (labelRotation >= 360) {
          labelRotation -= 360
        }
      }
    }
    return labelRotation
  }

  getAreaBlockInfoProperties(object: YardViewObject) {
    const yardObject = object as YardViewObject & {
      TotalCapacity?: number | string
      FreeSpace?: number | string
      OneTEUFreeSlot?: number | string
      TwoTEUFreeSlot?: number | string
      MaxLevel:number
      MaxRow:number
      MaxTier:number      
    }
    return {
      label: object.Code,
      code: object.Code,
      totalCapacity: yardObject.TotalCapacity,
      freeSpace: yardObject.FreeSpace,
      oneTEUFreeSlot: yardObject.OneTEUFreeSlot,
      twoTEUFreeSlot: yardObject.TwoTEUFreeSlot,
      maxTier: yardObject.MaxTier,
      maxRow: yardObject.MaxRow,
      maxLevel: yardObject.MaxLevel
    }
  }

  enrichAreaFeatureProperties(feature: turf.Feature, object: YardViewObject) {
    feature.properties = {
      ...feature.properties,
      ...this.getAreaBlockInfoProperties(object),
    }
  }



  renderObject(object: YardViewObject) {
    const feat = this.generateFeature(object)
    object.Feature = feat

    if (!object.Feature) {
      return
    }

    this.areas.push(object.Feature)
    if (object.Structure !== "NONE") {
      try {
        this.slots.push(...this.renderSlots(object))
      } catch (error) {
        console.error('error loading slot', object,)
      }
    }

    if (object.GeoShape == "POLYGON" || object.GeoShape == "RECTANGLE") {

      const areaRect: turf.Polygon = object.Feature.geometry as turf.Polygon

      if (object.AngleX == null) object.AngleX = 0
      if (object.AngleY == null) object.AngleY = 0

      let anchorCoord = 1
      const angleX = 90 + object.AngleX
      const angleY = object.AngleY

      if (
        (object.Structure == "BAY" && angleX + angleY < 270) ||
        (object.Structure == "ROW" && angleX + angleY < 270)
      ) {
        anchorCoord = 2
      }

      let rotation = 0
      if (object.Structure == "BAY" && angleX + angleY >= 270) {
        rotation = object.AngleX - 90
      } else if (object.Structure == "BAY") {
        rotation = object.AngleX
      } else if (angleX + angleY < 270) {
        rotation = object.AngleX
      }

      const labelRotation = this.getLabelRotation(rotation)
      // 

      this.areas.push(
        //Anchor point in the bottom right corner
        turf.point(areaRect.coordinates[0][2], {
          label: object.Code,
          code: object.Code,
          //anchor: labelRotation != rotation ? "bottom-left" : "top-right",
          //offset: labelRotation != rotation ? [0.0, -0.2] : [0.0, 0.2],
          rotate: labelRotation,
          totalCapacity:object.TotalCapacity,
          freeSpace:object.FreeSpace,
          oneTEUFreeSlot:object.OneTEUFreeSlot,
          twoTEUFreeSlot:object.TwoTEUFreeSlot,
          MaxLevel:object.MaxLevel,
          MaxRow:object.MaxRow,
          MaxTier:object.MaxTier
        })
      )
    } else if (
      object.GeoShape == "CIRCLE" &&
      object.GeoPointLongitude &&
      object.GeoPointLatitude
    ) {
      //Anchor point in the center of the circle
      this.areas.push(
        turf.point([object.GeoPointLongitude, object.GeoPointLatitude], {
          label: object.Code,
          code: object.Code,
          anchor: "center",
        })
      )
    }
  }
  resolveAreaBlockInfoForClick(properties: Record<string, unknown> | null) {
    if (!properties) {
      return {}
    }
    const code = properties.code as string
    const blockInfo = {
      code,
      label: (properties.label as string) ?? code,
      totalCapacity: properties.totalCapacity,
      freeSpace: properties.freeSpace,
      oneTEUFreeSlot: properties.oneTEUFreeSlot,
      twoTEUFreeSlot: properties.twoTEUFreeSlot,
      maxTier: properties.MaxTier,
      maxRow: properties.MaxRow,
      maxLevel: properties.MaxLevel
    }
    console.log(blockInfo)
    const hasCapacityInfo =
      blockInfo.totalCapacity != null ||
      blockInfo.freeSpace != null ||
      blockInfo.oneTEUFreeSlot != null ||
      blockInfo.twoTEUFreeSlot != null
    if (hasCapacityInfo || !code) {
      return blockInfo
    }
    const area = this.areaObjects.find((a) => a.Code === code)
    if (area) {
      return this.getAreaBlockInfoProperties(area)
    }
    return blockInfo
  }

  getVisibleRTGEquipmentCodes(): Set<string> {
    const filtered = this.equipmentfiltered as { eq2Ds?: turf.Feature[] }
    if (filtered?.eq2Ds?.length) {
      return new Set(
        filtered.eq2Ds.map((feature) => String(feature.properties?.code ?? ""))
      )
    }
    return new Set(this.eq2Ds.map((feature) => String(feature.properties?.code ?? "")))
  }

  findRTG3DClickAtLngLat(lngLat: mapboxgl.LngLat): turf.Feature | null {
    const point = turf.point([lngLat.lng, lngLat.lat])
    const visibleCodes = this.getVisibleRTGEquipmentCodes()
    const candidates = [...this.vechiles]
      .reverse()
      .filter((feature) => feature.properties?.type === "rtg")

    for (const feature of candidates) {
      const code = String(feature.properties?.code ?? "")
      if (visibleCodes.size > 0 && !visibleCodes.has(code)) {
        continue
      }
      if (
        feature.geometry &&
        turf.booleanPointInPolygon(point, feature as turf.Feature<turf.Polygon>)
      ) {
        return feature
      }
    }
    return null
  }

  updateVechilesSource() {
    if (!this.map) return
    const vechilesSource = this.map.getSource("vechiles") as GeoJSONSource
    if (!vechilesSource) return
    vechilesSource.setData(
      turf.featureCollection(this.vechiles) as GeoJSON.FeatureCollection<
        GeoJSON.Geometry
      >
    )
  }

  createRTG3DClickFeature(
    equipemnt,
    area,
    bay,
    ang,
    point0,
    point1,
    point2,
    point3,
    point4,
    point5,
    point6,
    point7,
    point8,
    point9,
    point10,
    point11
  ) {
    let clickFeature = turf.polygon(
      [
        [
          //@ts-ignore
          point0.geometry.coordinates,
          //@ts-ignore
          point1.geometry.coordinates,
          //@ts-ignore
          point2.geometry.coordinates,
          //@ts-ignore
          point3.geometry.coordinates,
          //@ts-ignore
          point4.geometry.coordinates,
          //@ts-ignore
          point5.geometry.coordinates,
          //@ts-ignore
          point6.geometry.coordinates,
          //@ts-ignore
          point7.geometry.coordinates,
          //@ts-ignore
          point8.geometry.coordinates,
          //@ts-ignore
          point9.geometry.coordinates,
          //@ts-ignore
          point10.geometry.coordinates,
          //@ts-ignore
          point11.geometry.coordinates,
          //@ts-ignore
          point0.geometry.coordinates,
        ],
      ],
      {
        type: "rtg",
        equipmentid: equipemnt.code,
        code: equipemnt.code,
        label: equipemnt.code,
        area,
        bay,
        statusColor: equipemnt.statusColor,
        operationType: equipemnt.operationType,
        status: equipemnt.status,
        vessel: equipemnt.vessel,
        terminal: equipemnt.terminal,
        base: 0,
        height: 50,
        layer: 1,
        maxLayer: 1,
      }
    )

    if (equipemnt.currentBay % 2 === 0) {
      clickFeature = turf.transformTranslate(clickFeature, 3, ang, {
        units: "meters",
      })
    }

    return clickFeature
  }

  resolveRTGEquipmentForClick(properties: Record<string, unknown> | null) {
    if (!properties) {
      return {}
    }
    return {
      code: properties.code,
      label: properties.label ?? properties.code,
      area: properties.area,
      bay: properties.bay,
      status: properties.status,
      statusColor: properties.statusColor,
      operationType: properties.operationType,
      vessel: properties.vessel,
      terminal: properties.terminal,
      objectType: "equipment",
    }
  }

  handleRTGEquipmentClick(properties: Record<string, unknown> | null) {
    const props = properties || {}
    this.clickobject(props)
    if (props.code) {
      const equipmentInfo = this.resolveRTGEquipmentForClick(props)
      this.$router.push({
        query: { equipmentInfo: JSON.stringify(equipmentInfo) },
      })
    }
  }

  generateFeature(object: YardViewObject) {
    let feat
    try {
      if (object.GeoShape == "CIRCLE") {
        if (object.GeoPointLongitude && object.GeoPointLatitude) {
          const center = turf.point([
            object.GeoPointLongitude,
            object.GeoPointLatitude,
          ])
          feat = this.generateCircleAreaFeature(
            center,
            object.GeoRadius,
            object.Type,
            object.Code,
            object.Structure
          )
        }
      } else if (object.GeoShape == "POLYLINE") {
        feat = this.generateLineFeature(
          object.GeoShape,
          object.GeoShapePoints,
          object.Type,
          object.Code,
          object.Structure
        )
      } else {
        feat = this.generateAreaFeature(
          object.GeoShape,
          object.GeoShapePoints,
          object.Type,
          object.Code,
          object.Structure,
          object.AngleY
        )
      }
    } catch (err) {
      console.error(
        "Error creating feature " + object.GeoShape + ": " + object.Code
      )
      return null
    }

    return feat
  }

  /**
   * Renders the slots of a given area
   */
  renderSlots(areaObj: YardViewObject) {
    // debugger
    const slots: Array<turf.Feature> = []

    if (areaObj.Structure == "LANE") {
      return this.renderLanesSlots(areaObj)
    }

    // Abort when no feature is present
    if (areaObj.Feature == null || areaObj.Feature.geometry == null) {
      return slots
    }
    const areaRect: turf.Polygon = areaObj.Feature.geometry as turf.Polygon
    const referencePoint = areaRect.coordinates[0][0]

    const iNbrOfBays = Number(areaObj.NumberOfBays)
    const iNbrOfRows = Number(areaObj.NumberOfRows)
    const dblBayInterspace = Number(areaObj.BayInterspace)
    const dblRowInterspace = Number(areaObj.RowInterspace)
    const dblPositionWidth = Number(areaObj.PositionWidth)
    const dblPositionLength = Number(areaObj.PositionLength)

    if (areaObj.BayStepSize == null) areaObj.BayStepSize = 0

    // We need to calculate the positions of all ground slots..
    // We support multiple scenarios..
    // The first and most important switch is TEUGroundSlots: when true all positions will be based o nstandard 1 TEU ground slot dimensions.
    // When false custom position dimensions can be entered, but no overlapping positions will be generated, only the standard positions will exist.
    //
    // When using standard TEU ground slots, we support standard 1 TEU, 2 TEU and 3 TEU positions.
    // However there is only one case in which we can render non 20ft slots as ground slots.
    //   - If 1 TEU ground slots are disabled and 2 OR 3 TEU slots are enabled and no overlapping positions are generated.
    //   - In all other cases the 1 TEU ground slots are rendered.
    let iSlotMultiplier = 1
    if (areaObj.TEUGroundSlots && !areaObj.OneTEUPositions) {
      if (
        areaObj.TwoTEUPositions &&
        !areaObj.ThreeTEUPositions &&
        areaObj.TwoTEUPositionStart !== "B"
      )
        iSlotMultiplier = 2
      else if (
        !areaObj.TwoTEUPositions &&
        areaObj.ThreeTEUPositions &&
        areaObj.ThreeTEUPositionStart !== "A"
      )
        iSlotMultiplier = 3
    }

    const angleX = 90 + Number(areaObj.AngleX)
    const angleY = Number(areaObj.AngleY)

    let iBayStartNumber = Number(areaObj.BayStartNumber)
    const iRowStartNumber = Number(areaObj.RowStartNumber)

    const iBayMaxNumber =
      iBayStartNumber + iNbrOfBays * areaObj.BayStepSize - 1
    const iRowMaxNumber = iRowStartNumber + iNbrOfRows - 1

    // If we stard with position slots only on the second or third bay, update the bay in which to start..
    // Note that in practice, this doesn't make much sense to do this.. at least not in an area without 1 TEU ground slots!
    let objFirstBayCoord = turf.point(referencePoint)
    if (iSlotMultiplier == 2) {
      if (areaObj.TwoTEUPositionStart == "S") {
        iBayStartNumber += areaObj.BayStepSize
        objFirstBayCoord = turf.destination(
          referencePoint,
          (dblPositionLength + dblBayInterspace) / 1000,
          angleX
        )
      }
    } else if (iSlotMultiplier == 3) {
      if (areaObj.ThreeTEUPositionStart == "S") {
        iBayStartNumber += areaObj.BayStepSize
        objFirstBayCoord = turf.destination(
          referencePoint,
          (dblPositionLength + dblBayInterspace) / 1000,
          angleX
        )
      } else if (areaObj.ThreeTEUPositionStart == "T") {
        iBayStartNumber += 2 * areaObj.BayStepSize
        objFirstBayCoord = turf.destination(
          referencePoint,
          (dblPositionLength * 2 + dblBayInterspace * 2) / 1000,
          angleX
        )
      }
    }

    const iBayStepSize = areaObj.BayStepSize * iSlotMultiplier
    for (
      let iBay = iBayStartNumber, i = 0;
      iBay <= iBayMaxNumber;
      iBay += iBayStepSize, i++
    ) {
      // When the standard ground slots are not shown, but 2 or 3 TEU slots are shown instead, verify that all the
      // underlying bays of these multi bay slots exist before rendering it..
      if (iSlotMultiplier > 1 && iBay + areaObj.BayStepSize > iBayMaxNumber)
        break

      let objCoordBay
      if (i == 0) {
        objCoordBay = objFirstBayCoord
      } else {
        objCoordBay = turf.destination(
          objFirstBayCoord,
          (dblPositionLength * iSlotMultiplier * i +
            dblBayInterspace * iSlotMultiplier * i) /
          1000,
          angleX
        )
      }

      for (
        let iRow = iRowStartNumber, j = 0;
        iRow <= iRowMaxNumber;
        iRow++, j++
      ) {
        let objGroundPos
        if (j == 0) {
          objGroundPos = objCoordBay
        } else {
          objGroundPos = turf.destination(
            objCoordBay,
            (dblPositionWidth * j + dblRowInterspace * j) / 1000,
            angleX + angleY
          )
        }

        const slotParameters = new SlotParameters(
          {
            origin: objGroundPos,
            angleX: angleX,
            angleY: angleY,
            length: dblPositionLength,
            width: dblPositionWidth,
            multiplier: iSlotMultiplier,
            interspace: dblBayInterspace,
            row: iRow,
            bay: iBay,
            areaCode: areaObj.Code,
            containerYardBlockExcludeRow: areaObj.ContainerYardBlockExcludeRow,
            containerCycleType: areaObj.ContainerCycleType,
            containerNo: areaObj.ContainerNo,
            loadStatus: areaObj.LoadStatus,
            type: areaObj.Type,
            weight: areaObj.Weight
          }
        )
        this.cacheSlotParameters(areaObj.Code, iBay, iRow, slotParameters)

        if (j == 0) {
          // لیبل bay اصلی (فرد یا زوج)
          const bayLabel = this._createBayLabel(slotParameters, iBay, areaObj.AngleX)
          slots.push(bayLabel)

          if (iBay + 1 < iBayMaxNumber) {
            // لیبل زوج بعدی - به داخل بلوک
            const evenLabel = this._createBayEvenLabel(slotParameters, iBay, areaObj.AngleX)
            if (evenLabel) {
              slots.push(evenLabel)
            }
          }
        }

        if (iBay == iBayStartNumber) {
          slots.push(
            this._createRowLabel(slotParameters, iRow, areaObj.AngleX)
          )
        }

        //Create the slot and push it to the array of slots
        const feature = this.createGroundSlotFeature(
          slotParameters,
          iRow,
          iBay
        )
        slots.push(feature)
        // اگر این slot دارای ضربدر است، خطوط را هم اضافه کنید
        if (feature.crossLines && feature.crossLines.length > 0) {
          slots.push(...feature.crossLines);
        }
        this.slotsDict.insert(
          areaObj.Code,
          iRow,
          iBay,
          feature
        )

        if (!this.previewMode && this.occupationObjectList != null) {
          //Create the occupation feature and push it to the array of stacks
          const stack = this.occupationObjectList.getOccupation(
            areaObj.Code,
            iBay, //i + 1,
            iRow //j + 1
          )
          if (
            stack != null &&
            (stack.Bay2 == null ||
              (stack.Bay2 != null && stack.Bay == i + 1) ||
              (stack.Bay3 != null && stack.Bay == i + 2))
          ) {
            const firstLastPos = this._checkAllowContainerOnFirstOrLastBayPos(
              stack,
              areaObj
            )

            //@ts-ignore
            stack.slotParameters = slotParameters
            //@ts-ignore
            stack.isFirstOrLastPos = firstLastPos

            const properties = {
              maxLayer: stack.MaxLayer,
            }

            this.stacks.push(
              this._createStackFeature(
                slotParameters,
                stack,
                firstLastPos,
                properties
              )
            )
          }
        }
      }
    }
    return slots
  }
  renderLanesSlots(areaObj: YardViewObject) {
    const slots: Array<turf.Feature> = []
    // Abort when no feature is present
    if (areaObj.Feature == null || areaObj.Feature.geometry == null) {
      return slots
    }
    const areaRect: turf.Polygon = areaObj.Feature.geometry as turf.Polygon
    const referencePoint = areaRect.coordinates[0][0]

    const mLaneInterspace = Number(areaObj.LaneInterspace)
    if (!areaObj.LaneStartNumber) {
      areaObj.LaneStartNumber = 1
    }

    const mLaneStartNumber = Number(areaObj.LaneStartNumber)
    const mlaneWidth = Number(areaObj.LaneWidth)

    const angleX = 90 + Number(areaObj.AngleX)
    const angleY = Number(areaObj.AngleY)
    const mLaneCount = Number(areaObj.Lanes.length)
    if (!areaObj.Lanes) {
      areaObj.Lanes = new Array<Lane>()
    }
    const listofLanes: Lane[] = areaObj.Lanes

    for (let i = 0; i < mLaneCount; i++) {
      const iLane = mLaneStartNumber + i
      const lane = listofLanes.find((l) => l.Number == iLane)
      if (!lane) continue

      const objCoordLane = turf.destination(
        referencePoint,
        ((mlaneWidth + mLaneInterspace) * i) / 1000,
        angleX
      )

      const slotParameters = new SlotParameters(
        objCoordLane,
        angleX,
        angleY,
        lane.LaneLength,
        mlaneWidth,
        0,
        mLaneInterspace,
        iLane,
        0,
        areaObj.Code
      )

      slots.push(this._createLaneRowLabel(slotParameters, iLane))

      if (lane.StartOffset > 0) {
        const startOffsetPoint = turf.destination(
          objCoordLane,
          lane.StartOffset / 1000,
          angleX + angleY
        )
        //new start point
        slotParameters.origin = startOffsetPoint
      }

      const feature = this.createGroundLaneSlotFeature(slotParameters, lane)

      slots.push(feature)

      this.slotsDict.insert(
        areaObj.Code,
        lane.Number,
        0,
        //@ts-ignore
        feature as MapboxGeoJSONFeature
      )
    }

    return slots
  }
  /**
   * Generate a label point feature for the Lanes
   */
  _createLaneRowLabel(
    slotParameters: SlotParameters,
    rowNumber: number
  ): turf.Feature {
    const objCoordP2: turf.Feature = turf.destination(
      slotParameters.origin,
      slotParameters.width / 1000,
      slotParameters.angleX
    )

    let feature = turf.midpoint(
      slotParameters.origin.geometry.coordinates,
      //@ts-ignore
      objCoordP2.geometry.coordinates
    )

    if (slotParameters.angleY == 90) {
      feature = turf.destination(feature, 1 / 1000, 0)
    }
    if (slotParameters.angleY == 270) {
      feature = turf.destination(feature, 1 / 1000, slotParameters.angleX + 90)
    }

    feature.properties = {
      label: `${rowNumber}`,
      code: slotParameters.areaCode,
    }

    return feature
  }

  createGroundLaneSlotFeature(slotParameters: SlotParameters, lane: Lane) {
    // C=P1     P2
    //  ________
    // |        |
    // |________|
    //
    // P4       P3
    // AngleX contains the bearing from C to P2
    // AngleY contains the bearing from C to P4 which is identical to the bearing of P2 to P3.

    const objCoordP1: turf.Feature = turf.destination(
      slotParameters.origin,
      slotParameters.width / 1000,
      slotParameters.angleX
    )

    const objCoordP2: turf.Feature = turf.destination(
      //@ts-ignore
      objCoordP1,
      (slotParameters.length - lane.StartOffset) / 1000,
      slotParameters.angleX + slotParameters.angleY
    )
    const objCoordP3: turf.Feature = turf.destination(
      slotParameters.origin,
      (slotParameters.length - lane.StartOffset) / 1000,
      slotParameters.angleX + slotParameters.angleY
    )

    return turf.polygon(
      [
        [
          slotParameters.origin.geometry.coordinates,
          //@ts-ignore
          objCoordP1.geometry.coordinates,
          //@ts-ignore
          objCoordP2.geometry.coordinates,
          //@ts-ignore
          objCoordP3.geometry.coordinates,
          slotParameters.origin.geometry.coordinates,
        ],
      ],
      {
        code: slotParameters.areaCode,
        row: lane.Number,

        fid: `${slotParameters.areaCode}_${lane.Number}`,
      }
    )
  }
  _checkAllowContainerOnFirstOrLastBayPos(stack, areaObj) {
    const result = {
      isFirstPos: false,
      isLastPos: false,
    }

    const lastOccupiedBay = stack.Bay2 != null ? stack.Bay2 : stack.Bay
    result.isFirstPos = stack.Bay == areaObj.BayStartNumber
    result.isLastPos =
      lastOccupiedBay == areaObj.BayStartNumber + areaObj.NumberOfBays - 1

    return result
  }

  /**
   * Generate a label point feature for the rows
   */
  _createRowLabel(
    slotParameters: SlotParameters,
    rowNumber: number,
    angelx
  ): turf.Feature {
    const objCoordP2: turf.Feature = turf.destination(
      slotParameters.origin,
      slotParameters.width / 1000,
      slotParameters.angleX + slotParameters.angleY
    )

    let feature = turf.midpoint(
      slotParameters.origin.geometry.coordinates,
      //@ts-ignore
      objCoordP2.geometry.coordinates
    )
    let space = 3
    if (slotParameters.angleY == 270) {
      space = -3
    }
    feature = turf.destination(
      feature,
      space / 1000,
      slotParameters.angleX + slotParameters.angleY + 90
    )

    feature.properties = {
      label: `${rowNumber}`,
      code: slotParameters.areaCode,
    }

    return feature
  }

  /**
   * Generate a label point feature for the bays
   */
  _createBayLabel(slotParameters, bayNumber, angelx) {
    const objCoordP1 = turf.destination(
      slotParameters.origin,
      (slotParameters.length * slotParameters.multiplier +
        slotParameters.interspace * (slotParameters.multiplier - 1)) /
      1000,
      slotParameters.angleX
    )

    let feature = turf.midpoint(
      slotParameters.origin.geometry.coordinates,
      //@ts-ignore
      objCoordP1.geometry.coordinates
    )
    let space = 3
    if (slotParameters.angleY == 270) {
      space = -3
    }
    feature = turf.destination(
      feature,
      space / 1000,
      slotParameters.angleX - 90
    )

    feature.properties = {
      label: `${bayNumber}`,
      code: slotParameters.code,
    }
    let feature2 = turf.midpoint(
      slotParameters.origin.geometry.coordinates,
      //@ts-ignore
      objCoordP1.geometry.coordinates
    )

    feature2 = turf.destination(
      feature2,
      space / 1000,
      slotParameters.angleX - 90
    )

    // به داخل بلوک
    const inwardOffset = 0
    feature2 = turf.destination(
      feature2,
      inwardOffset / 1000,
      slotParameters.angleX + slotParameters.angleY
    )

    feature2.properties = {
      label: `${bayNumber + 1}`,
      code: slotParameters.code,
    }

    //@ts-ignore
    feature._extraLabel = feature2

    return feature
  }

  _createBayEvenLabel(slotParameters, bayNumber, angelx): turf.Feature | null {
    if (bayNumber % 2 === 0) return null

    const objCoordP1 = turf.destination(
      slotParameters.origin,
      (slotParameters.length * slotParameters.multiplier +
        slotParameters.interspace * (slotParameters.multiplier - 1)) /
      1000,
      slotParameters.angleX
    )

    let feature = turf.midpoint(
      slotParameters.origin.geometry.coordinates,
      //@ts-ignore
      objCoordP1.geometry.coordinates
    )

    let space = 3
    if (slotParameters.angleY == 270) {
      space = -3
    }

    feature = turf.destination(
      feature,
      space / 1000,
      slotParameters.angleX
    )

    const inwardOffset = -2
    feature = turf.destination(
      feature,
      inwardOffset / 1000,
      slotParameters.angleX + slotParameters.angleY
    )

    feature.properties = {
      label: `${bayNumber + 1}`,
      code: slotParameters.areaCode,
    }

    return feature
  }

  /**
   * Generate a groundslot feature
   */
  createGroundSlotFeature(slotParameters, row, bay) {
    // C=P1     P2
    //  ________
    // |        |
    // |________|
    //
    // P4       P3
    // AngleX contains the bearing from C to P2
    // AngleY contains the bearing from C to P4 which is identical to the bearing of P2 to P3.

    const objCoordP1: turf.Feature = turf.destination(
      slotParameters.origin,
      (slotParameters.length * slotParameters.multiplier +
        slotParameters.interspace * (slotParameters.multiplier - 1)) /
      1000,
      slotParameters.angleX
    )
    const objCoordP2: turf.Feature = turf.destination(
      //@ts-ignore
      objCoordP1,
      slotParameters.width / 1000,
      slotParameters.angleX + slotParameters.angleY
    )
    const objCoordP3: turf.Feature = turf.destination(
      slotParameters.origin,
      slotParameters.width / 1000,
      slotParameters.angleX + slotParameters.angleY
    )


    var isContainerYardBlockExcludeRow = false
    for (let i = 0; i < slotParameters.containerYardBlockExcludeRow.length; i++) {
      const start = slotParameters.containerYardBlockExcludeRow[i].startRow;
      const end = slotParameters.containerYardBlockExcludeRow[i].endRow;

      if (bay >= start && bay <= end) {


        const mainPolygonCoords = [
          slotParameters.origin.geometry.coordinates,
          objCoordP1.geometry.coordinates,
          objCoordP2.geometry.coordinates,
          objCoordP3.geometry.coordinates,
          slotParameters.origin.geometry.coordinates,
        ];

        // محاسبه مرکز
        const center = turf.center(turf.polygon([mainPolygonCoords]));
        const centerCoords = center.geometry.coordinates;

        // محاسبه ابعاد slot
        const slotWidth = turf.distance(
          slotParameters.origin.geometry.coordinates,
          objCoordP3.geometry.coordinates,
          { units: 'meters' }
        );

        const slotLength = turf.distance(
          slotParameters.origin.geometry.coordinates,
          objCoordP1.geometry.coordinates,
          { units: 'meters' }
        );

        // اندازه تقریبی از کوچکترین ضلغ
        const crossSize = Math.min(slotWidth, slotLength) * 0.4;

        const bearing = turf.bearing(
          slotParameters.origin.geometry.coordinates,
          objCoordP1.geometry.coordinates
        );

        const crossP1 = turf.destination(centerCoords, crossSize, bearing + 45, { units: 'meters' });
        const crossP2 = turf.destination(centerCoords, crossSize, bearing + 135, { units: 'meters' });
        const crossP3 = turf.destination(centerCoords, crossSize, bearing + 225, { units: 'meters' });
        const crossP4 = turf.destination(centerCoords, crossSize, bearing + 315, { units: 'meters' });

        const crossLine1 = turf.lineString(
          [
            crossP1.geometry.coordinates,
            crossP3.geometry.coordinates
          ],
          {
            code: slotParameters.areaCode,
            row: row,
            bay: bay,
            fid: `${slotParameters.areaCode}_${row}_${bay}_cross1`,
            crossLine: true,
          }
        );

        const crossLine2 = turf.lineString(
          [
            crossP2.geometry.coordinates,
            crossP4.geometry.coordinates
          ],
          {
            code: slotParameters.areaCode,
            row: row,
            bay: bay,
            fid: `${slotParameters.areaCode}_${row}_${bay}_cross2`,
            crossLine: true,
          }
        );

        const mainPolygon = turf.polygon(
          [mainPolygonCoords],
          {
            code: slotParameters.areaCode,
            row: row,
            bay: bay,
            fid: `${slotParameters.areaCode}_${row}_${bay}`,
          }
        );

        mainPolygon.crossLines = [crossLine1, crossLine2];

        return mainPolygon;
      }
    }
    return turf.polygon(
      [
        [
          slotParameters.origin.geometry.coordinates,
          //@ts-ignore
          objCoordP1.geometry.coordinates,
          //@ts-ignore
          objCoordP2.geometry.coordinates,
          //@ts-ignore
          objCoordP3.geometry.coordinates,
          slotParameters.origin.geometry.coordinates,
        ],
      ],
      {
        code: slotParameters.areaCode,
        row: row,
        bay: bay,
        fid: `${slotParameters.areaCode}_${row}_${bay}`,
      }
    )
  }

  /**
   * Generate a container stack feature
   */
  _createStackFeature(slotParameters, stack, firstLastPos, properties) {
    let groundPosition = slotParameters.origin

    //Convert feet to metric
    const containerLengthMetric: number = stack.ContainerLength / 3.2808399 //TODO round!
    let occupiedLength = containerLengthMetric
    let assignedSlotLength = slotParameters.length

    if (stack.Bay2 != null) {
      assignedSlotLength += slotParameters.length + slotParameters.interspace
    }
    if (stack.Bay3 != null) {
     // assignedSlotLength += slotParameters.length + slotParameters.interspace
    }

    if (containerLengthMetric != assignedSlotLength) {
      // Two scenarios:
      //   1. The container stack does not fill the full length of the position, in which case a smaller slot must be rendered.
      //      It is rendered in the center of the position.
      //   2. The container stack is longer than the position. In this scensio we have 2 further classifications.
      //        a. The stack is in the first or last bay and the container is allowed on smaller ground slots in the first or last bay.
      //           In this case the stack will extend outside the normal confines of the area.
      //        b. The stack is not in the first or last bay or the container is not allowed on smaller ground slots in the first or last bay.
      //           This scenario is only possible if bay interspacing is sufficiently large to allow for for example 45ft containers to be placed on 40ft ground slots.
      //           In this scenario we reduce the bay interspacing in both direcrtions by half. We can't take up the full interspace because the next 40ft position might also contain a 45ft stack.
      //           Note that even though the first and last bay technically do not have a start/end interspace, we still add the offset as we don't know exactly how the slot size is exceeded.

      if (containerLengthMetric < assignedSlotLength) {
        // Case 1
        const offset = (assignedSlotLength - containerLengthMetric) / 2

        // Move the origin so we draw the container stack in the center of the position..
        groundPosition = turf.destination(
          slotParameters.origin,
          offset / 1000,
          slotParameters.angleX
        )
      } else if (firstLastPos.isFirstPos || firstLastPos.isLastPos) {
        // Case 2a
        // Note that it's possible the area only has a single position of this length in which case it can extend in both directions..
        // For this we need to check bIsFirstPos && bIsLastPos..
        if (firstLastPos.isFirstPos && firstLastPos.isLastPos) {
          // Move the origin so we draw the container stack in the center of the position..
          const offset = (containerLengthMetric - assignedSlotLength) / 2
          groundPosition = turf.destination(
            slotParameters.origin,
            offset / 1000,
            slotParameters.angleX
          )
        } else if (firstLastPos.isFirstPos) {
          // Move the origin so we draw the container stack in the center of the position..
          const offset = containerLengthMetric - assignedSlotLength
          groundPosition = turf.destination(
            slotParameters.origin,
            offset / 1000,
            slotParameters.angleX + 180
          )
        }
      } else {
        // Case 2b
        let offset = (containerLengthMetric - assignedSlotLength) / 2
        // Max the offset at half the interspace to prevent overlapping in the renderer...
        offset = Math.min(offset, slotParameters.interspace / 2)

        groundPosition = turf.destination(
          slotParameters.origin,
          offset / 1000,
          slotParameters.angleX + 180
        )

        // Render the length of the position, with double the offset. This can result in the full stack length or max the position + bay interspace.
        occupiedLength = assignedSlotLength + 2 * offset
      }
    }

    // C=P1     P2
    //  ________
    // |        |
    // |________|
    //
    // P4       P3
    // AngleX contains the bearing from C to P2
    // AngleY contains the bearing from C to P4 which is identical to the bearing of P2 to P3.

    const objCoordP1 = turf.destination(
      groundPosition,
      (occupiedLength +
        slotParameters.interspace * (slotParameters.multiplier - 1)) /
      1000,
      slotParameters.angleX
    )
    const objCoordP2 = turf.destination(
      objCoordP1,
      slotParameters.width / 1000,
      slotParameters.angleX + slotParameters.angleY
    )
    const objCoordP3 = turf.destination(
      groundPosition,
      slotParameters.width / 1000,
      slotParameters.angleX + slotParameters.angleY
    )
    return turf.polygon(
      [
        [
          groundPosition.geometry.coordinates,
          objCoordP1.geometry.coordinates,
          objCoordP2.geometry.coordinates,
          objCoordP3.geometry.coordinates,
          groundPosition.geometry.coordinates,
        ],
      ],
      {
        code: slotParameters.areaCode,
        row: slotParameters.row,
        bay: slotParameters.bay,
        angleY: slotParameters.angleY,
        containerCycleType: slotParameters.containerCycleType,
        containerNo: slotParameters.containerNo,
        ...properties,
      }
    )
  }

  private normalizeStackContainer(container: any): Record<string, any> {
    const lengthFt = this.getContainerProp(container, 'lengthFt', 'LengthFt')
    const length = this.getContainerProp(container, 'length', 'Length')
    const resolvedLength =
      length ?? (lengthFt != null ? Number(lengthFt) / 3.2808399 : 6.096)

    return {
      ...container,
      Id: this.getContainerProp(container, 'id', 'Id'),
      Length: resolvedLength,
      Height: this.getContainerProp(container, 'height', 'Height') ?? 8.5,
      width: container.width ?? container.Width ?? 2.4384,
      Layer:
        this.getContainerProp(container, 'layer', 'Layer') ??
        this.getContainerProp(container, 'levelNo', 'LevelNo') ??
        1,
      LengthFt: lengthFt ?? resolvedLength * 3.2808399,
      Line: this.getContainerProp(container, 'line', 'Line'),
      ContainerSize: this.getContainerProp(container, 'containerSize', 'ContainerSize'),
      LoadStatus: this.getContainerProp(container, 'loadStatus', 'LoadStatus'),
      ContainerCycleType: this.getContainerProp(
        container,
        'containerCycleType',
        'ContainerCycleType'
      ),
      OrderType: this.getContainerProp(container, 'orderType', 'OrderType'),
      ShipmentType: this.getContainerProp(container, 'shipmentType', 'ShipmentType'),
      PortOfDischarge: this.getContainerProp(
        container,
        'portOfDischarge',
        'PortOfDischarge'
      ),
      PortOfLoading: this.getContainerProp(container, 'portOfLoading', 'PortOfLoading'),
      PortOfTranship: this.getContainerProp(
        container,
        'portOfTranship',
        'PortOfTranship'
      ),
      TerminalDestination: this.getContainerProp(
        container,
        'terminalDestination',
        'TerminalDestination'
      ),
      NoDeliveryToPTIsRequired: !!this.getContainerProp(
        container,
        'noDeliveryToPTIsRequired',
        'NoDeliveryToPTIsRequired'
      ),
      BlockedStatus: this.getContainerProp(container, 'blockedStatus', 'BlockedStatus'),
      ContainerType: this.getContainerProp(container, 'containerType', 'ContainerType'),
      VoyageName: this.getContainerProp(container, 'voyageName', 'VoyageName'),
      Teu: this.getContainerProp(container, 'teu', 'Teu'),
      Bay: this.getContainerProp(container, 'bay', 'Bay'),
      Bay2: this.getContainerProp(container, 'bay2', 'Bay2'),
      Bay3: this.getContainerProp(container, 'bay3', 'Bay3'),
    }
  }

  private getStackPosition(stack: any): { area: string; bay: number; row: number } | null {
    const area = this.getStackAreaCode(stack)
    const bay = Number(stack?.bay ?? stack?.Bay)
    const row = Number(stack?.row ?? stack?.Row)
    if (!area || !Number.isFinite(bay) || !Number.isFinite(row)) {
      return null
    }
    return { area, bay, row }
  }

  private upsertContainerStackData(stackInput: any): {
    area: string
    bay: number
    row: number
    containers: any[]
  } | null {
    const position = this.getStackPosition(stackInput)
    if (!position) {
      return null
    }

    const incomingContainers = stackInput.containers ?? stackInput.Containers ?? []
    if (!Array.isArray(this.containersData)) {
      this.containersData = []
    }

    const stacks = this.containersData as any[]
    let existing = stacks.find((stack) => {
      const stackPosition = this.getStackPosition(stack)
      return (
        stackPosition &&
        stackPosition.area === position.area &&
        stackPosition.bay === position.bay &&
        stackPosition.row === position.row
      )
    })

    if (!existing) {
      existing = {
        ...stackInput,
        area: position.area,
        bay: position.bay,
        row: position.row,
        containers: [...incomingContainers],
      }
      stacks.push(existing)
    } else {
      const existingContainers = existing.containers ?? existing.Containers ?? []
      const byId = new Map<any, any>()
      existingContainers.forEach((container) => {
        byId.set(this.getContainerProp(container, 'id', 'Id'), container)
      })
      incomingContainers.forEach((container) => {
        byId.set(this.getContainerProp(container, 'id', 'Id'), container)
      })
      const mergedContainers = Array.from(byId.values())
      Object.assign(existing, stackInput, {
        area: position.area,
        bay: position.bay,
        row: position.row,
        containers: mergedContainers,
      })
      if (existing.Containers) {
        existing.Containers = mergedContainers
      }
    }

    return {
      area: position.area,
      bay: position.bay,
      row: position.row,
      containers: existing.containers ?? existing.Containers ?? [],
    }
  }

  private removeContainerFeaturesAtPosition(area: string, bay: number, row: number) {
    this.containers = this.containers.filter((feature) => {
      const props = feature.properties
      if (!props) {
        return true
      }
      return !(props.code === area && props.bay === bay && props.row === row)
    })
  }

  private syncAllContainersFlatForStack(
    area: string,
    bay: number,
    row: number,
    containers: any[]
  ) {
    this.allContainersFlat = this.allContainersFlat.filter((container) => {
      const containerArea = this.getBlockCode(container)
      const containerBay = Number(this.getContainerProp(container, 'bay', 'Bay'))
      const containerRow = Number(this.getContainerProp(container, 'row', 'Row'))
      return !(
        containerArea === area &&
        containerBay === bay &&
        containerRow === row
      )
    })

    containers.forEach((container) => {
      this.allContainersFlat.push({
        ...container,
        code: area,
      })
    })
  }

  private getSlotParametersCacheKey(area: string, bay: number, row: number) {
    return `${area}/${bay}/${row}`
  }

  private cacheSlotParameters(area: string, bay: number, row: number, slotParameters: any) {
    this.slotParametersByPosition.set(
      this.getSlotParametersCacheKey(area, bay, row),
      slotParameters
    )
  }

  private resolveSlotParametersForPosition(
    area: string,
    bay: number,
    row: number,
    stack?: Occupation | null
  ) {
    if (stack?.slotParameters) {
      return stack.slotParameters
    }

    const cached = this.slotParametersByPosition.get(
      this.getSlotParametersCacheKey(area, bay, row)
    )
    if (cached) {
      return cached
    }

    const slotFeature = this.slotsDict.getFeature(area, bay, row)
    if (!slotFeature?.geometry) {
      return null
    }

    const areaObj = this.areaObjects.find((item) => item.Code === area)
    if (!areaObj) {
      return null
    }

    const coordinates = (slotFeature.geometry as GeoJSON.Polygon).coordinates?.[0]
    if (!coordinates?.length) {
      return null
    }

    const angleX = 90 + Number(areaObj.AngleX)
    const angleY = Number(areaObj.AngleY)
    const rebuilt = new SlotParameters({
      origin: turf.point(coordinates[0]),
      angleX,
      angleY,
      length: Number(areaObj.PositionLength),
      width: Number(areaObj.PositionWidth),
      multiplier: 1,
      interspace: Number(areaObj.BayInterspace),
      row,
      bay,
      areaCode: area,
      containerYardBlockExcludeRow: areaObj.ContainerYardBlockExcludeRow ?? [],
      containerCycleType: areaObj.ContainerCycleType,
      containerNo: areaObj.ContainerNo,
      loadStatus: areaObj.LoadStatus,
      type: areaObj.Type,
      weight: areaObj.Weight,
    })
    this.cacheSlotParameters(area, bay, row, rebuilt)
    return rebuilt
  }

  private buildContainerFeatureProperties(
    container: Record<string, any>,
    base: number,
    maxLayer = 1
  ) {
    return {
      base,
      height: base + container.Height * 0.3048,
      layer: container.Layer,
      maxLayer,
      id: container.Id,
      line: container.Line,
      containerinfo: container,
      containerSize: container.ContainerSize,
      lengthFt: container.LengthFt,
      loadStatus: container.LoadStatus,
      containerCycleType: container.ContainerCycleType,
      orderType: container.OrderType,
      shipmentType: container.ShipmentType,
      portOfDischarge: container.PortOfDischarge,
      portOfLoading: container.PortOfLoading,
      portOfTranship: container.PortOfTranship,
      terminalDestination: container.TerminalDestination,
      noDeliveryToPTIsRequired: container.NoDeliveryToPTIsRequired ? 1 : 0,
      blockedStatus: container.BlockedStatus,
      containerType: container.ContainerType,
      voyageName: container.VoyageName,
      teu: container.Teu,
      bay: container.Bay,
      bay2: container.Bay2,
      bay3: container.Bay3,
    }
  }

  private sortStackContainers(containers: any[]) {
    return [...containers].sort((left, right) => {
      const leftLayer = Number(
        this.getContainerProp(left, 'layer', 'Layer') ??
          this.getContainerProp(left, 'levelNo', 'LevelNo') ??
          0
      )
      const rightLayer = Number(
        this.getContainerProp(right, 'layer', 'Layer') ??
          this.getContainerProp(right, 'levelNo', 'LevelNo') ??
          0
      )
      return leftLayer - rightLayer
    })
  }

  private _createContainerFeaturesForPosition(
    area: string,
    bay: number,
    row: number,
    containers: any[],
    stackMeta?: any
  ): turf.Feature[] {
    const stack = this.occupationObjectList?.getOccupation(area, bay, row)
    const slotParameters = this.resolveSlotParametersForPosition(area, bay, row, stack)
    if (slotParameters == null) {
      return []
    }

    const areaObj = this.areaObjects.find((item) => item.Code === area)
    const stackForFirstLast = stack ?? {
      Bay: bay,
      Bay2: stackMeta?.bay2 ?? stackMeta?.Bay2 ?? null,
      Bay3: stackMeta?.bay3 ?? stackMeta?.Bay3 ?? null,
      ContainerLength:
        stackMeta?.containerLength ?? stackMeta?.ContainerLength ?? 20,
    }
    const firstLastPos =
      stack?.isFirstOrLastPos ??
      (areaObj
        ? this._checkAllowContainerOnFirstOrLastBayPos(stackForFirstLast, areaObj)
        : { isFirstPos: false, isLastPos: false })
    const maxLayer =
      stack?.MaxLayer ?? stackMeta?.maxLayer ?? stackMeta?.MaxLayer ?? 1

    const features: turf.Feature[] = []
    let base = 0

    this.sortStackContainers(containers).forEach((rawContainer) => {
      const container = this.normalizeStackContainer(rawContainer)
      const containerParameters = {
        ContainerLength: container.Length * 3.2808399,
        ContainerWidth: container.width,
        Bay: stack?.Bay ?? bay,
        Bay2: stack?.Bay2 ?? stackMeta?.bay2 ?? stackMeta?.Bay2 ?? null,
        Bay3: stack?.Bay3 ?? stackMeta?.bay3 ?? stackMeta?.Bay3 ?? null,
        id: container.Id,
      }
      features.push(
        this._createStackFeature(
          slotParameters,
          containerParameters,
          firstLastPos,
          this.buildContainerFeatureProperties(container, base, maxLayer)
        )
      )
      base += container.Height * 0.3048 + 0.1
    })

    return features
  }

  private scheduleContainersMapUpdate() {
    if (this.containerMapUpdateScheduled || !this.map) {
      return
    }

    this.containerMapUpdateScheduled = true
    requestAnimationFrame(() => {
      this.containerMapUpdateScheduled = false
      this.flushContainersToMap()
    })
  }

  private flushContainersToMap() {
    if (!this.map) {
      return
    }

    if (this.isFilterActive) {
      this.applyContainerFilter()
      this.toggleOccupationLayers()
      this.map.triggerRepaint()
      return
    }

    const containersSource = this.map.getSource('containers') as GeoJSONSource
    containersSource?.setData(
      turf.featureCollection(this.containers) as GeoJSON.FeatureCollection<GeoJSON.Geometry>
    )

    const containersFilteredSource = this.map.getSource(
      'containers-filtered'
    ) as GeoJSONSource
    containersFilteredSource?.setData(
      turf.featureCollection([]) as GeoJSON.FeatureCollection<GeoJSON.Geometry>
    )

    this.toggleOccupationLayers()
    this.map.triggerRepaint()
  }

  /**
   * Adds or updates container stacks on the map without a full yard re-render.
   * Accepts one stack object or an array of stacks in API format (camelCase or PascalCase).
   */
  addContainerStacksToMap(stacksInput: any | any[]): {
    addedStacks: number
    addedContainers: number
    failed: Array<{ area: string; bay: number; row: number; reason: string }>
  } {
    const result = {
      addedStacks: 0,
      addedContainers: 0,
      ContainersNo: [],
      failed: [] as Array<{ area: string; bay: number; row: number; reason: string }>,
    }

    if (!this.map || this.occupationObjectList == null) {
      console.warn('addContainerStacksToMap: map or occupation data is not ready')
      result.failed.push({
        area: '-',
        bay: 0,
        row: 0,
        reason: 'Map or occupation data is not ready yet.',
      })
      return result
    }

    const stacks = Array.isArray(stacksInput) ? stacksInput : [stacksInput]
    if (!stacks.length) {
      return result
    }

    let hasUpdates = false

    stacks.forEach((stackInput) => {
      const stackData = this.upsertContainerStackData(stackInput)
      if (!stackData || !stackData.containers.length) {
        return
      }

      const { area, bay, row, containers } = stackData
      const features = this._createContainerFeaturesForPosition(
        area,
        bay,
        row,
        containers,
        stackInput
      )
      if (!features.length) {
        result.failed.push({
          area,
          bay,
          row,
          reason: 'Slot geometry not found for this area/bay/row.',
        })
        return
      }

      this.removeContainerFeaturesAtPosition(area, bay, row)
      this.syncAllContainersFlatForStack(area, bay, row, containers)
      this.containers.push(...features)
      result.addedStacks += 1
      result.addedContainers += features.length
      result.ContainersNo = features.map((feature) => feature.properties.containerinfo.containerNo || []).join(', ')
      result.postion = `${area}/${bay}/${row}`
      hasUpdates = true
    })

    if (hasUpdates) {
      this.scheduleContainersMapUpdate()
    }

    return result
  }

  createContainerFeatures(detailedOccupation) {
    if (this.occupationObjectList == null) {
      return
    }

    detailedOccupation.forEach((occupation) => {
      const containers = occupation.Containers ?? []
      const features = this._createContainerFeaturesForPosition(
        occupation.Area,
        occupation.Bay,
        occupation.Row,
        containers,
        occupation
      )
      this.containers.push(...features)
    })
  }

  fetchObjectData() {
    let testUrl = this.config = config.VUE_APP_BASE_YARDVIEW + "/json/getObjectsByArguments.json"
    let areaDataUrl = this.config = config.VUE_APP_BASE_API + "/Tos/BerthMonitoring/GetObjectsByArguments"
    axios.post(areaDataUrl, {
      TerminalId: typeof (this.terminal) == 'object' ? this.terminal[0] : this.terminal
    }).then((response) => {

      const areas = (response.data.data || []).map((area) => ({
        ...area,
        code: area.code ?? area.Code,
      }));
      this.allAreaObjectsArray = areas
      this.areaObjectsArray = areas


      function capitalizeFirstLetter(str: string): string {
        return str.charAt(0).toUpperCase() + str.slice(1)
      }

      const capitalizedObjectsArray = this.areaObjectsArray.map((areaObject) => {
        const capitalizedObject: Record<string, any> = {}

        for (const key in areaObject) {
          if (areaObject.hasOwnProperty(key)) {
            const capitalizedKey = capitalizeFirstLetter(key)
            capitalizedObject[capitalizedKey] = areaObject[key]
          }
        }
        capitalizedObject.TEUGroundSlots = areaObject

        return capitalizedObject
      })

      this.areaObjects = capitalizedObjectsArray


      // this.fetchRoRoLanes()
      this.fetchOccupation()
      this.renderYard()


    })

  }
  // fetchObjectData() {
  //   debugger;
  //   this.tcServices.YardViewServices.YVObjectServices.GetObjectsByArguments1(
  //     this.sessionId,
  //     ["CONTAREA", "OPENAREA", "WAREHOUSE" ,"BUILDING", "TANK", "TRACK", "GATE", "RORO"],
  //     [],
  //     [],
  //     "",
  //     false
  //   ).then((response) => {
  //     this.areaObjects = response.data.Result;
  //     this.fetchRoRoLanes();
  //     this.fetchOccupation();
  //     this.renderYard();
  //   });
  // }


  // fetchObjectData() {
  //   debugger;
  //   this.tcServices.YardViewServices.YVObjectServices.GetObjectsByArguments1(
  //     this.sessionId,
  //     ["CONTAREA", "OPENAREA", "WAREHOUSE" ,"BUILDING", "TANK", "TRACK", "GATE", "RORO"],
  //     [],
  //     [],
  //     "",
  //     false
  //   ).then((response) => {
  //     this.areaObjects = response.data.Result;
  //     this.fetchRoRoLanes();
  //     this.fetchOccupation();
  //     this.renderYard();
  //   });
  // }

  generateAreaFeature(
    geoShape,
    geoShapePoints,
    objectType,
    objectCode,
    structure,
    AngleY
  ) {
    const geometryCoordinates: Array<Array<number>> = []

    if (geoShapePoints.geometry) {
      if (geoShapePoints.geometry.coordinates) {
        geoShapePoints.geometry.coordinates[0].forEach((item) => {
          geometryCoordinates.push([item[0], item[1]])
        })
      }
    } else {
      const coordinates = geoShapePoints.split(",")
      coordinates.forEach((coordinate) => {
        const latlon = coordinate.split("/")
        geometryCoordinates.push([Number(latlon[1]), Number(latlon[0])])
      })
      //Polygon requires first and last position to be the same
      geometryCoordinates.push(geometryCoordinates[0])
    }


    return turf.polygon([geometryCoordinates], {
      code: objectCode,
      fid: objectCode,
      objectType: objectType,
      structure: structure,
      angleY: AngleY,

    })
  }
  generateAreaCorrectPolygon(
    point0,
    maxLength,
    maxWidth,
    angelX,
    directionAngle
  ) {
    const point1 = turf.destination(point0, maxLength / 1000, angelX).geometry
      .coordinates
    const point2 = turf.destination(
      point1,
      maxWidth / 1000,
      angelX + directionAngle
    ).geometry.coordinates
    const point3 = turf.destination(
      point0,
      maxWidth / 1000,
      angelX + directionAngle
    ).geometry.coordinates
    return [point0, point1, point2, point3, point0]
  }

  generateLineFeature(
    geoShape,
    geoShapePoints,
    objectType,
    objectCode,
    structure
  ) {
    const geometryCoordinates: Array<Array<number>> = []
    const coordinates = geoShapePoints.split(",")
    coordinates.forEach((coordinate) => {
      const latlon = coordinate.split("/")
      geometryCoordinates.push([Number(latlon[0]), Number(latlon[1])])
    })

    return turf.lineString(geometryCoordinates, {
      code: objectCode,
      objectType: objectType,
      structure: structure,
    })
  }

  generateCircleAreaFeature(
    center,
    radius,
    objectType,
    objectCode,
    structure
  ): turf.Feature {
    const resolution = radius > 30 ? radius : 30
    const options = {
      steps: resolution,
      units: "meters",
      properties: {
        code: objectCode,
        objectType: objectType,
        structure: structure,
      },
    }
    //@ts-ignore
    return turf.circle(center, radius, options)
  }

  async fetchRenderSettings(callback) {
    await axios
      .get("json/GetRenderSetting.json")
      .then((response) => {
        callback(null, response.data.Result)
      })
      .catch((error) => {
        console.error(error.message)
      })
  }

  async fetchColorSettings(callback) {
    await fetch("/json/GetColorSchemes.json")
      .then((response) => {
        const colorScheme = response.data.Result as Array<ColorScheme>

        callback(null, colorScheme)
      })
      .catch((error) => {
        console.error(error.message)
      })
  }

  async fetchRoRoLanes() {
    // 

    //GetROROLanesOccupation
    // Fetch the config.json file
    let urldata = ''

    const VUE_APP_BASE_YARDVIEW = configs.VUE_APP_BASE_YARDVIEW

    urldata = (VUE_APP_BASE_YARDVIEW) + "/json/test/20items.json"
    if (this.terminalId == 7) {
      urldata = "json/roroDar.json"
    }

    await axios.get(urldata).then((response) => {
      this.fillOccupationRoroLaneList(response.data.Result)
      this.createRoroFetures()
      this.renderYard()
    })
  }

  fillOccupationRoroLaneList(array: Array<LaneOccupation>) {
    this.OccupationRoroLaneList = new Array<LaneOccupation>()
    if (!array || array.length == 0) {
      return
    }
    for (const item of array) {
      this.OccupationRoroLaneList.push(item as LaneOccupation)
    }
  }

  createRoroFetures() {
    this.vechiles = []
    this.OccupationRoroLaneList.forEach((item) =>
      this.createRoroLaneFetures(item)
    )
  }

  createRoroLaneFetures(laneOccupation: LaneOccupation): void {
    const Vehicleslist = laneOccupation.Vehicles

    const VehiclesCount = laneOccupation.Vehicles.length
    const slotLaneFeture = this.slotsDict.getRowFeatures(
      laneOccupation.Area,
      laneOccupation.LaneNumber
    )[0]
    if (slotLaneFeture == undefined) {
      return
    }

    for (let i = 1; i <= VehiclesCount; i++) {
      const vehicles = Vehicleslist.find((v) => v.Sequence == i)
      if (vehicles == null) {
        continue
      }

      const area = this.areaObjects.find(
        (r) => r.Code == laneOccupation.Area
      ) as YardViewObject

      const slotRect: turf.Polygon = slotLaneFeture.geometry as turf.Polygon
      const referencePoint = slotRect.coordinates[0][0]
      const angleX = Number(area.AngleX)
      const angleY = Number(area.AngleY)
      // const vehicleInterspace = Number(area.VehicleInterspace);
      const laneWidth = Number(area.LaneWidth)
      // const laneLenth = Number(area.LaneLength);
      if (!vehicles.Width) {
        vehicles.Width = Number(laneWidth * 0.8)
      }
      const vehiclesWidth = Number(vehicles.Width)
      if (!vehicles.Length) {
        vehicles.Length = 4
      }
      if (!vehicles.Offset) {
        vehicles.Offset = 0.4
      }
      const vehiclesLength = Number(vehicles.Length)
      const vehiclesoffset = Number(vehicles.Offset)

      let objCoordLane = turf.destination(
        referencePoint,
        (0.5 * (laneWidth - vehiclesWidth)) / 1000,
        angleY + (angleY == 270 ? 180 : 0)
      )

      if (vehiclesoffset > 0) {
        objCoordLane = turf.destination(
          objCoordLane,
          vehiclesoffset / 1000,
          angleX + (angleY == 270 ? 0 : 180)
        )
      }
      const model3dVersion = this.renderQuality == "High" ? "v4" : "v3"
      // 

      const vParameters = {
        origin: objCoordLane,
        angleX: angleX + 90,
        angleY: angleY,
        length: vehiclesLength,
        width: vehiclesWidth,
        area: laneOccupation.Area,
        laneNumber: laneOccupation.LaneNumber,
        offset: vehiclesoffset,
        sequence: vehicles.Sequence,
        uid: vehicles.Uid,
        vin: vehicles.VIN,
        type: vehicles.Type,
        laneWidth: laneWidth,
        model3dVersion: model3dVersion,
      }
      /// E.g. CAR (generic), BIKE, SEDAN, HATCHBACK, STATIONWAGON, MINIVAN, VAN, PICKUP, SUV, TRUCK, BUS
      //HATCHBACK,  MINIVAN, SUV, TRUCK,MPV
      // need for click event
      const feture = this.createRoroVechileFeature(vParameters)

      if (this.useRoro3dModel) {
        const Vechile = this.createVechile3DModelLayer(feture, vParameters)
        // if define 3d model added else use container layer
        if (Vechile != null) {
          this.map.addLayer(Vechile as mapboxgl.AnyLayer)
          this.roro3DModelList.push(Vechile.id)
          this.vechiles.push(feture)
        } else {
          this.stacks.push(feture)
          this.containers.push(feture)
        }
      } else {
        this.stacks.push(feture)
        this.containers.push(feture)
      }
    }
  }

  createVechile3DModelLayer(
    feture,
    vParameters
  ):
    | VanLayer
    | SedanLayer
    | BikeLayer
    | PickupLayer
    | StationwagonLayer
    | BusLayer
    | HachbackLayer
    | SuvLayer
    | TruckLayer
    | null {
    switch (vParameters.type) {
      case "HATCHBACK":
        return new HachbackLayer(feture, vParameters)
      case "VAN":
        return new VanLayer(feture, vParameters)
      case "SUV":
        return new SuvLayer(feture, vParameters)
      case "MINIVAN":
        return new MinivanLayer(feture, vParameters)
      case "SEDAN":
      case "CAR":
        // we can select other type example width >5 return PickupLayer
        // if(vParameters.width>5.5)
        //  return new PickupLayer(feture, vParameters);
        // else
        return new SedanLayer(feture, vParameters)

      case "BIKE":
        return new BikeLayer(feture, vParameters)
      case "PICKUP":
        return new PickupLayer(feture, vParameters)
      case "STATIONWAGON":
        return new StationwagonLayer(feture, vParameters)
      case "BUS":
        return new BusLayer(feture, vParameters)
      case "TRUCK":
        return new TruckLayer(feture, vParameters)
      default:
        return new SedanLayer(feture, vParameters)
    }
  }

  createRoroVechileFeature(vParameters) {
    // incorrect server cal rectangle points
    const objCoordP1: turf.Feature = turf.destination(
      vParameters.origin,
      vParameters.width / 1000,
      vParameters.angleX
    )

    const objCoordP2: turf.Feature = turf.destination(
      //@ts-ignore
      objCoordP1,
      vParameters.length / 1000,
      vParameters.angleX + vParameters.angleY
    )
    const objCoordP3: turf.Feature = turf.destination(
      vParameters.origin,
      vParameters.length / 1000,
      vParameters.angleX + vParameters.angleY
    )

    const properties = {
      base: 0,
      height: 2.2,
      layer: 1,
      id: vParameters.uid,
      line: "",
      type: vParameters.type,
      maxLayer: 1,
      ...vParameters,
    }

    //for Triangle
    // const frontMidPoint = turf.midpoint(
    //   //@ts-ignore
    //   objCoordP2.geometry.coordinates,
    //   //@ts-ignore
    //   objCoordP3.geometry.coordinates
    // );

    return turf.polygon(
      [
        [
          //@ts-ignore
          vParameters.origin.geometry.coordinates,
          //@ts-ignore
          objCoordP1.geometry.coordinates,
          //@ts-ignore
          objCoordP2.geometry.coordinates,
          //@ts-ignore
          // frontMidPoint.geometry?.coordinates,
          //@ts-ignore
          objCoordP3.geometry.coordinates,
          //@ts-ignore
          vParameters.origin.geometry.coordinates,
        ],
      ],
      {
        code: vParameters.area,
        row: vParameters.laneNumber,
        bay: vParameters.sequence,
        ...properties,
      }
    )
  }
  /**
   * MapOccupationIntoDictionary
   */

  async fetchOccupation() {
    this.stacks = []

    let dataurl = config.VUE_APP_BASE_API + `/tos/BerthMonitoring/getcontainerstacks`
    let testurl = config.VUE_APP_BASE_YARDVIEW + `/json/getContainerStacks.json`
    // if (this.terminalId == 7) {
    //   dataurl = "json/stack_DAR.json";
    // }`

    await axios.post(dataurl, {
      TerminalId: this.terminalId
    }).then((response) => {

      const occupationObjectList = response.data.data

      function capitalizeFirstLetter(str: string): string {
        return str.charAt(0).toUpperCase() + str.slice(1)
      }

      const capitalizedObjectsArray = occupationObjectList.map((areaObject) => {
        const capitalizedObject: Record<string, any> = {}

        for (const key in areaObject) {
          if (areaObject.hasOwnProperty(key)) {
            const capitalizedKey = capitalizeFirstLetter(key)
            capitalizedObject[capitalizedKey] = areaObject[key]
          }
        }
        capitalizedObject.TEUGroundSlots = areaObject

        return capitalizedObject
      })



      this.occupationObjectList = this.MapOccupationIntoDictionary(
        capitalizedObjectsArray
      )

      // Now that we have the occupation also request to detailed occupation for the 3D view
      this.fetchDetailedOccupation()
      this.fetchRTGEquipments();
      this.renderYard()
      //  this.fetchRoRoLanes();
    })
  }

  // /**
  //  * Retrieves the details slot occupation from the YardView webservice. This is used to draw the 3D container stacks
  //  */


  // async fetchOccupation() {
  //   this.stacks = []

  //   await this.tcServices.YardViewServices.YVTerminalOccupationServices.GetContainerStacks(
  //     this.sessionId,
  //     this.areaObjects.map((area) => {
  //       return area.Code
  //     })
  //   )
  //     .then((response) => {
  //       if (response.data.Result && response.data.Result.length > 0) {
  //         this.occupationObjectList = this.MapOccupationIntoDictionary(
  //           response.data.Result
  //         )
  //         this.fetchDetailedOccupation()
  //       }
  //       this.fetchRoRoLanes()
  //       // Now that we have the occupation also request to detailed occupation for the 3D view
  //       this.renderYard()
  //     })
  // }
  fetchRTGEquipments() {
    var body = {
      EquipmentType: 201,
      EquipmentCategory: 2,
      terminalId: this.terminalId
    }
    var self = this;
    ApiService.post(
      "tos/BerthMonitoring/GetHandlingEquipmentByClass",
      body
    )
      .then((response) => {
        this.equipmentsData = response.data.data;
        for (const [key, field] of Object.entries(this.EQUIPMENT_PALETTE_FIELD_MAP)) {
          const result = this.generateEquipmentColorPalette(field, this.equipmentsData);
          this.equipmentcolorPalettes[key] = result.colorPalette;
          this[`${field}Options`] = result.options;
        }
        this.map.setPaintProperty('eq2Ds', 'fill-color', ["match", ["get", this.equipmentactivePalette], ...this.equipmentcolorPalettes[this.equipmentactivePalette].colorExpr]);
        self.createRTGEquipmentFeatures(response.data.data);
      })
      .catch((error) => {
        console.error(error.message);
      });

  }
  createRTGEquipmentFeatures(equipemnts: any[]) {
    this.vechiles = this.vechiles.filter(
      (feature) => feature.properties?.type !== "rtg"
    )

    //First add 2D
    equipemnts
      //.filter((e) => e.status != "Hidden")
      .forEach((eq) => {
        if (eq.currentArea) {// && eq.cancelClickedurrentBay) {
          const features = this.createRTGSlotFeture(eq);
          this.eq2Ds.push(features);
        }
      });
    //next add 3D (first render is heddin if pinch <10)
    this.eq3DModelLayerIds = [];
    equipemnts
      //.filter((e) => e.status != "Hidden")
      .forEach((eq) => {
        if (this.map?.getLayer(eq.code)) {
          this.map?.removeLayer(eq.code);
        }
        if (eq.currentArea && eq.currentBay) {
          const rtg3D = this.createRTG3DModelLayer(eq);

          this.map?.addLayer(rtg3D as mapboxgl.AnyLayer);
          const pitch = Number(this.map?.getPitch());
          if (pitch < 10)
            this.map?.setLayoutProperty(rtg3D.id, "visibility", "none");
          else {
            this.map?.setLayoutProperty(rtg3D.id, "visibility", "visible");
            this.map?.triggerRepaint();
          }
          this.eq3DModelLayerIds.push(rtg3D.id);
        }
      });

    this.updateVechilesSource()
  }
  createRTGSlotFeture(equipemnt) {
    const area = equipemnt.currentArea; // eq.area;
    var bay = equipemnt.currentBay; //eq.bay;
    if (bay % 2 === 0) {
      bay--;
    }
    //const yardOperationId = equipemnt.yardOperationId; //eq.bay;
    const areaobject = this.areas.find((r) => r.properties?.code === area);

    const rect: turf.Polygon = areaobject?.geometry as turf.Polygon;

    const features = this.slotsDict.getBayFeatures(area, bay);
    const angleY = Number(areaobject?.properties?.angleY);

    const feature = features[0];
    var areaWidth = 0
    var ang = 0;
    if (angleY != null) {
      areaWidth = turf.distance(
        turf.point(rect.coordinates[0][0]),
        turf.point(rect.coordinates[0][1])
      );
      ang = turf.bearing(
        turf.point(rect.coordinates[0][1]),
        turf.point(rect.coordinates[0][2])
      );
    }


    const areaRect: turf.Polygon = feature.geometry as turf.Polygon;

    const retgHeight = areaWidth + 0.0006;

    let point000: any = areaRect.coordinates[0][0];

    //if (angleY == 270) {
    // point000 = turf.destination(point000, -(retgHeight - 0.0006), ang + 90);
    //}

    const point00 = turf.destination(point000, -0.0003, ang + 90);
    const point0 = turf.destination(point00, 0.002, ang);

    const point1 = turf.destination(point0, -0.001, ang);
    const point2 = turf.destination(point1, -0.0015, ang + 90);
    const point3 = turf.destination(point2, 0.001 + 0.002 + 0.001, ang);
    const point4 = turf.destination(point3, 0.0015, ang + 90);
    const point5 = turf.destination(point4, -0.001, ang);
    const point6 = turf.destination(point5, retgHeight, ang + 90);
    const point7 = turf.destination(point6, 0.001, ang);
    const point8 = turf.destination(point7, 0.0015, ang + 90);
    const point9 = turf.destination(point8, -1 * (0.001 + 0.002 + 0.001), ang);
    const point10 = turf.destination(point9, -0.0015, ang + 90);
    const point11 = turf.destination(point10, 0.001, ang);
    const frontMidPoint = turf.midpoint(
      //@ts-ignore
      point8.geometry.coordinates,
      //@ts-ignore
      point9.geometry.coordinates
    );


    //calc Label position
    var rtgLablePoint=0;
    rtgLablePoint = turf.destination(frontMidPoint, 0.002, ang + 90);
    if (equipemnt.currentBay % 2 === 0) {
      rtgLablePoint = turf.destination(frontMidPoint, 0.002, ang + 90);
      rtgLablePoint = turf.destination(rtgLablePoint, 0.003, ang );
    }
    // if(angleY==270){
    //  rtgLablePoint =  turf.destination(rtgLablePoint,  -(areaWidth+0.001),  -ang);
    //}
    rtgLablePoint.properties = {
      anchor: "top-center",
      offset: [0.0, 0],
      rotate: 90 + ang + (ang < 0 ? 0 : 180),
      code: equipemnt.code,
      label: equipemnt.code,
      area: area,
      bay: bay,
      statusColor: equipemnt.statusColor,
      operationType: equipemnt.operationType,
      status: equipemnt.status,
      vessel: equipemnt.vessel,
      terminal: equipemnt.terminal

    };

    this.eq2DsLabels.push(rtgLablePoint);

    const properties = {
      anchor: "top-center",
      offset: [0.0, 0],
      rotate: 90 + ang,
    };

    var originalPolygon = turf.polygon(
      [
        [
          //@ts-ignore
          point0.geometry.coordinates,
          //@ts-ignore
          point1.geometry.coordinates,
          //@ts-ignore
          point2.geometry.coordinates,
          //@ts-ignore
          point3.geometry.coordinates,
          //@ts-ignore
          point4.geometry.coordinates,
          //@ts-ignore
          point5.geometry.coordinates,
          //@ts-ignore
          point6.geometry.coordinates,
          //@ts-ignore
          point7.geometry.coordinates,
          //@ts-ignore
          point8.geometry.coordinates,
          //@ts-ignore
          point9.geometry.coordinates,
          //@ts-ignore
          point10.geometry.coordinates,
          //@ts-ignore
          point11.geometry.coordinates,
          //@ts-ignore
          point0.geometry.coordinates,
        ],
      ],
      {
        code: equipemnt.code,
        label: equipemnt.code,
        area: area,
        bay: bay,
        statusColor: equipemnt.statusColor,
        operationType: equipemnt.operationType,
        status: equipemnt.status,
        vessel: equipemnt.vessel,
        terminal: equipemnt.terminal,
        //yardOperationId: equipemnt.yardOperationId,
        ...properties,
      }
    );

    var translatedPolygon = originalPolygon

    if (equipemnt.currentBay % 2 === 0) {
      const bearing = ang;
      const distance = 3;
      const options = { units: 'meters' };

      translatedPolygon = turf.transformTranslate(
        originalPolygon,
        distance,
        bearing,
        options
      );
    }

    return translatedPolygon
  }
  createRTG3DModelLayer(equipemnt) {
    const area = equipemnt.currentArea; // eq.area;
    var bay = equipemnt.currentBay; //eq.bay;
    if (equipemnt.currentBay % 2 === 0) {
      bay--;
    }
    const features = this.slotsDict.getBayFeatures(area, bay);
    const feature = features[0];
    const areaobject = this.areas.find((r) => r.properties?.code === area);
    const rect: turf.Polygon = areaobject?.geometry as turf.Polygon;
    const angleY = Number(areaobject?.properties?.angleY);
    var areaWidth = 0;
    var ang = 0;
    if (angleY != null && angleY == 270) {
      areaWidth = turf.distance(
        turf.point(rect.coordinates[0][0]),
        turf.point(rect.coordinates[0][1])
      );
      ang = turf.bearing(
        turf.point(rect.coordinates[0][1]),
        turf.point(rect.coordinates[0][2])
      );
    }
    else {
      areaWidth = turf.distance(
        turf.point(rect.coordinates[0][0]),
        turf.point(rect.coordinates[0][1])
      );
      ang = turf.bearing(
        turf.point(rect.coordinates[0][1]),
        turf.point(rect.coordinates[0][2])
      );
    }

    const bayRect: turf.Polygon = feature.geometry as turf.Polygon;

    const retgHeight = areaWidth + 0.0006;

    let point000: any = bayRect.coordinates[0][0];
    if (angleY == 270) {
      point000 = turf.destination(point000, -(retgHeight - 0.0006), ang + 90);
    }
    const point00 = turf.destination(point000, -0.0003, ang + 90);
    const point0 = turf.destination(point00, 0.002, ang);

    const point1 = turf.destination(point0, -0.001, ang);
    const point2 = turf.destination(point1, -0.0015, ang + 90);
    const point3 = turf.destination(point2, 0.001 + 0.002 + 0.001, ang);
    const point4 = turf.destination(point3, 0.0015, ang + 90);
    const point5 = turf.destination(point4, -0.001, ang);
    const point6 = turf.destination(point5, retgHeight, ang + 90);
    const point7 = turf.destination(point6, 0.001, ang);
    const point8 = turf.destination(point7, 0.0015, ang + 90);
    const point9 = turf.destination(point8, -1 * (0.001 + 0.002 + 0.001), ang);
    const point10 = turf.destination(point9, -0.0015, ang + 90);
    const point11 = turf.destination(point10, 0.001, ang);
    const frontMidPoint = turf.midpoint(
      //@ts-ignore
      point8.geometry.coordinates,
      //@ts-ignore
      point9.geometry.coordinates
    );

    //center position
   var centerRect = turf.destination(
      frontMidPoint,
      -areaWidth / 2 - 0.002,+
      ang + 90
    );
    if(equipemnt.currentBay % 2 === 0)
    {
      centerRect = turf.destination(
      centerRect,
       0.003,
      ang  )
    }    

    const center = centerRect.geometry?.coordinates;

    // Create RTG Feature For Click Event (3D)
    const clickFeature = this.createRTG3DClickFeature(
      equipemnt,
      area,
      bay,
      ang,
      point0,
      point1,
      point2,
      point3,
      point4,
      point5,
      point6,
      point7,
      point8,
      point9,
      point10,
      point11
    )
    this.vechiles.push(clickFeature)

    const rtg3D = new RTGLayer(center, ang, equipemnt, this.fixedPalettes.operationType[equipemnt.operationType] );
    rtg3D.id = equipemnt.code;
    this.map.addLayer(rtg3D as mapboxgl.AnyLayer)

    return rtg3D;
  }
  fetchDetailedOccupation() {
    const me = this
    // this.tcServices.YardViewServices.YVTerminalOccupationServices.GetContainerStackDetails(
    //   this.sessionId,
    //   this.areaObjects.map((area) => {
    //     return area.code
    //   })
    // )
    const URL = config.VUE_APP_BASE_API + "/tos/berthMonitoring/getcontainerstackdetails"
    // const testUrl = "http://localhost:9090/json/getContainerStackDetails"
    axios.post(URL, {
      TerminalId: this.terminalId
    })
      .then((response) => {
        this.containersData = response.data.data
        this.buildAllContainersFlat();

        for (const [key, field] of Object.entries(this.PALETTE_FIELD_MAP)) {
          const result = this.generateColorPalette(field, this.allContainersFlat);
          this.containerColorPalettes[key] = result.colorPalette;
          this[`${field}Options`] = result.options;
        }

        function capitalizeFirstLetter(str: string): string {
          return str.charAt(0).toUpperCase() + str.slice(1)
        }

        const capitalizedObjectsArray = this.containersData.map((areaObject) => {
          const capitalizedObject: Record<string, any> = {}

          for (const key in areaObject) {
            if (areaObject.hasOwnProperty(key)) {
              const capitalizedKey = capitalizeFirstLetter(key)

              capitalizedObject[capitalizedKey] = areaObject[key]

            }
          }

          capitalizedObject.Containers.map((container) => {
            for (const k in container) {
              const capitalizedContainersKey = capitalizeFirstLetter(k)
              container[capitalizedContainersKey] = container[k]
              delete container[k]
            }
          })


          return capitalizedObject
        })
        this.createContainerFeatures(capitalizedObjectsArray)
        this.renderYard()

       this.map.once('idle', () => {
        this.onColorPaletteChange(this.activePalette)
      })
      })
      .catch((error) => {
        console.error(error.message)
      })
  }

  generateColorPalette(propertyName, containersData) {
    
    // تابع کمکی برای ساخت رنگ‌های متفاوت
    const generateColors = (count) => {
      const colors = [];
      for (let i = 0; i < count; i++) {
        const hue = Math.round((360 / count) * i);
        colors.push(`hsl(${hue}, 70%, 50%)`);
      }
      return colors;
    };

    const uniqueValues = [
      ...new Set(
        containersData.flatMap(d => d[propertyName])
      )
    ];

    // ایجاد options برای فیلتر
    const options = uniqueValues.map(v => ({
      label: v,
      value: v
    }));

    // محاسبه TEU برای هر مقدار
    const teuCounters = uniqueValues.reduce((acc, value) => {
      const containersOfThisValue = containersData.filter(d =>
        d[propertyName] === value
      )
      const counts = containersOfThisValue.reduce(
        (c, ctn) => {
          if (ctn.teu === 1) {
            c.one++;
            c.box++;
            c.teu++;
          } else if (ctn.teu === 2) {
            c.two++;
            c.box++;
            c.teu = c.teu + 2;
          }
          return c;
        },
        { one: 0, two: 0, box: 0, teu: 0 }
      );

      acc[value] = counts;
      return acc;
    }, {});
    const fixedPalette = this.fixedPalettes[propertyName];

    const colors = generateColors(uniqueValues.length);
    const colorPalette = {
      default: { FillColor: "#ccc", label: "نامشخص" },
      colorExpr: []
    };
    uniqueValues.forEach((value, i) => {

      var color = "";
      if (fixedPalette) {




        color = fixedPalette[value];
      }
      else
        color = colors[i];

      const counts = teuCounters[value];
      const teus = `${counts.one}/${counts.two}/${counts.box}/${counts.teu}`;

      colorPalette[value] = {
        FillColor: color,
        label: value,
        teus: teus
      };
      colorPalette.colorExpr.push(value, color);
    });
    colorPalette.colorExpr.push("#ffa800");
    return { options, colorPalette };
  }

  generateEquipmentColorPalette(propertyName, equipmentData) {
    console.log("propertyName", propertyName)
    // تابع کمکی برای ساخت رنگ‌های متفاوت
    const generateColors = (count) => {
      const colors = [];
      for (let i = 0; i < count; i++) {
        const hue = Math.round((360 / count) * i);
        colors.push(`hsl(${hue}, 70%, 50%)`);
      }

      return colors;

    };
    const uniqueValues = [
      ...new Set(
        equipmentData.flatMap(d => d[propertyName])
      )
    ];
    // ایجاد options برای فیلتر
    const options = uniqueValues.map(v => ({
      label: v,
      value: v
    }));

    console.log("propertyName", propertyName)
    const fixedPalette = this.fixedPalettes[propertyName];
    console.log("fixedPalette", fixedPalette)

    const colors = generateColors(uniqueValues.length);
    const colorPalette = {
      default: { FillColor: "#ccc", label: "نامشخص" },
      colorExpr: []
    };
    uniqueValues.forEach((value, i) => {

      var color = "";
      if (fixedPalette) {
        console.log("value", value)
        color = fixedPalette[value];
        console.log("color", color)

      }
      else
        color = colors[i];

      colorPalette[value] = {
        FillColor: color,
        label: value,
      };
      colorPalette.colorExpr.push(value, color);
    });
    colorPalette.colorExpr.push("#ffa800");
    console.log("colorPalette", colorPalette)
    return { options, colorPalette };
  }

  applyContainerFilter() {
    if (!this.map) return;

    const { filtered, dimmed } = this.splitContainersByFilter();
    this.filtered = filtered;
    const containersSource = this.map.getSource("containers") as GeoJSONSource;
    if (containersSource) {
      containersSource.setData(
        turf.featureCollection(filtered.containers) as GeoJSON.FeatureCollection<GeoJSON.Geometry>
      );
    }

    for (const [key, field] of Object.entries(this.PALETTE_FIELD_MAP)) {
      const result = this.generateColorPalette(field, this.filtered.containers.map(c => c.properties));
      this.containerColorPalettes[key] = result.colorPalette;
    }

      this.map.setPaintProperty('stacks3D', 'fill-extrusion-color', ["match", ["get", this.activePalette], ...this.containerColorPalettes[this.activePalette].colorExpr]);
    
      this.map.setPaintProperty('stacks2D', 'fill-color', ["match", ["get", this.activePalette], ...this.containerColorPalettes[this.activePalette].colorExpr]);
    
  }


  applyEquipmentFilter() {
    if (!this.map) return;
    const { filtered, dimmed } = this.splitEquipmentsByFilter();
    this.equipmentfiltered = filtered;


    const EquipmentsSource = this.map.getSource("eq2Ds") as GeoJSONSource;
    if (EquipmentsSource) {
      EquipmentsSource.setData(
        turf.featureCollection(filtered.eq2Ds) as GeoJSON.FeatureCollection<GeoJSON.Geometry>
      );
    }

    const eq2DsLabelsSource = this.map.getSource("eq2DsLabels") as GeoJSONSource;
    if (eq2DsLabelsSource) {
      eq2DsLabelsSource.setData(
        turf.featureCollection(filtered.eq2DsLabels) as GeoJSON.FeatureCollection<GeoJSON.Geometry>
      );
    }

    var flatEqId = EquipmentsSource._data.features.flatMap(c => c.properties.code)
    const show3D = this.map.getPitch() >= 10 && !this.previewMode && !this.selectionMode;

    this.eq3DModelLayerIds.forEach((eqId) => {
      if (this.map.getLayer(eqId) && show3D) {
        const visibility = flatEqId.includes(eqId) ? "visible" : "none";
        this.map.setLayoutProperty(eqId, "visibility", visibility);

      } else {
        console.error("RTG Layer not found", eqId);
      }
    });

    for (const [key, field] of Object.entries(this.EQUIPMENT_PALETTE_FIELD_MAP)) {
      const result = this.generateEquipmentColorPalette(field, this.equipmentfiltered.eq2Ds.map(c => c.properties));
      this.equipmentcolorPalettes[key] = result.colorPalette;
    }


    this.map.setPaintProperty('eq2Ds', 'fill-color', ["match", ["get", this.equipmentactivePalette], ...this.equipmentcolorPalettes[this.equipmentactivePalette].colorExpr]);
    //if (this.map?.getLayer('stacks3D')) {
    //this.map.setPaintProperty('stacks3D', 'fill-extrusion-color', ["match", ["get", this.activePalette], ...this.containerColorPalettes[this.activePalette].colorExpr]);
    //this.map.setPaintProperty('eq2Ds', 'fill-color', ["match", ["get", this.activePalette], ...this.containerColorPalettes[this.activePalette].colorExpr]);
    //}
  }




  splitContainersByFilter() {
    const filtered = {
      containers: [] as turf.Feature[],
      stacks: [] as turf.Feature[]
    };

    const dimmed = {
      containers: [] as turf.Feature[],
      stacks: [] as turf.Feature[]
    };
    if (!this.isFilterActive) {
      filtered.containers = [...this.containers];
      filtered.stacks = [...this.stacks];
      return { filtered, dimmed };
    }

    this.containers.forEach(container => {
      const filterProps = {
        ...container.properties.containerinfo,
        ...container.properties,
        code: this.getBlockCode(container.properties),
      };
      if (this.matchesFilter(filterProps)) {
        filtered.containers.push(container);
      } else {
        dimmed.containers.push(container);
      }
    });

    return { filtered, dimmed };
  }

  splitEquipmentsByFilter() {
    const filtered = {
      eq2Ds: [] as turf.Feature[],
      eq2DsLabels: [] as turf.Feature[],
    };

    const dimmed = {
      eq2Ds: [] as turf.Feature[],
      eq2DsLabels: [] as turf.Feature[],

    };

    if (!this.isEquipmentFilterActive) {
      filtered.eq2Ds = [...this.eq2Ds];
      filtered.eq2DsLabels = [...this.eq2DsLabels];

      return { filtered, dimmed };
    }

    this.eq2Ds.forEach(eq => {
      if (this.equipmentmatchesFilter({ ...eq.properties })) {
        filtered.eq2Ds.push(eq);
      } else {
        dimmed.eq2Ds.push(eq);
      }
    });
    this.eq2DsLabels.forEach(eq => {
      if (this.equipmentmatchesFilter({ ...eq.properties })) {
        filtered.eq2DsLabels.push(eq);
      } else {
        dimmed.eq2DsLabels.push(eq);
      }
    });



    return { filtered, dimmed };
  }

  equipmentmatchesFilter(properties: any): boolean {
    if (!this.hasEquipmentActiveFilters) return true;
    if (!properties) return false;
    let matches = true;

    if (this.equipmentsFilter.status?.length > 0) {
      const selected = this.equipmentsFilter.status;
      const propertyValue = properties.status;

      if (selected != null && selected.length > 0) {
        const selected = this.equipmentsFilter.status || [];
        const propertyValues = properties.status || [];

        const propArray = Array.isArray(propertyValues) ? propertyValues : [propertyValues];

        if (selected.length > 0) {
          const hasMatch = selected.some(val => propArray.includes(val.trim()));

          if (!hasMatch) {
            matches = false;
          }
        }
      }
    }
    if (this.equipmentsFilter.code?.length > 0) {
      const selected = this.equipmentsFilter.code;
      const propertyValue = properties.code;

      if (selected != null && selected.length > 0) {
        const selected = this.equipmentsFilter.code || [];
        const propertyValues = properties.code || [];

        const propArray = Array.isArray(propertyValues) ? propertyValues : [propertyValues];

        if (selected.length > 0) {
          const hasMatch = selected.some(val => propArray.includes(val.trim()));

          if (!hasMatch) {
            matches = false;
          }
        }
      }
    }

    if (this.equipmentsFilter.operationType?.length > 0) {
      const selected = this.equipmentsFilter.operationType;
      const propertyValue = properties.operationType;

      if (selected != null && selected.length > 0) {
        const selected = this.equipmentsFilter.operationType || [];
        const propertyValues = properties.operationType || [];

        const propArray = Array.isArray(propertyValues) ? propertyValues : [propertyValues];

        if (selected.length > 0) {
          const hasMatch = selected.some(val => propArray.includes(val.trim()));

          if (!hasMatch) {
            matches = false;
          }
        }
      }
    }
    if (this.equipmentsFilter.vessel?.length > 0) {
      const selected = this.equipmentsFilter.vessel;
      const propertyValue = properties.vessel;

      if (selected != null && selected.length > 0) {
        const selected = this.equipmentsFilter.vessel || [];
        const propertyValues = properties.vessel || [];

        const propArray = Array.isArray(propertyValues) ? propertyValues : [propertyValues];

        if (selected.length > 0) {
          const hasMatch = selected.some(val => propArray.includes(val.trim()));

          if (!hasMatch) {
            matches = false;
          }
        }
      }
    }
    if (this.equipmentsFilter.terminal?.length > 0) {
      const selected = this.equipmentsFilter.terminal;
      const propertyValue = properties.terminal;

      if (selected != null && selected.length > 0) {
        const selected = this.equipmentsFilter.terminal || [];
        const propertyValues = properties.terminal || [];

        const propArray = Array.isArray(propertyValues) ? propertyValues : [propertyValues];

        if (selected.length > 0) {
          const hasMatch = selected.some(val => propArray.includes(val.trim()));

          if (!hasMatch) {
            matches = false;
          }
        }
      }
    }



    return matches;


  }


  matchesFilter(properties: any): boolean {

    if (!this.isFilterActive) return true;
    if (!properties) return false;
    let matches = true;

    if (this.containerFilter.code && String(this.containerFilter.code).trim() !== '') {
      if (!this.blockCodesMatch(this.getBlockCode(properties), this.containerFilter.code)) {
        matches = false;
      }
    }

    if (this.containerFilter.containerCycleType?.length > 0) {
      const selected = this.containerFilter.containerCycleType;
      const propertyValue = properties.ContainerCycleType;

      if (selected != null && selected.length > 0) {
        const selected = this.containerFilter.containerCycleType || [];
        const propertyValues = properties.ContainerCycleType || [];

        const propArray = Array.isArray(propertyValues) ? propertyValues : [propertyValues];

        if (selected.length > 0) {
          const hasMatch = selected.some(val => propArray.includes(val.trim()));

          if (!hasMatch) {
            matches = false;
          }
        }
      }
    }

    if (this.containerFilter.orderType?.length > 0) {
      const selected = this.containerFilter.orderType;
      const propertyValue = properties.OrderType;

      if (selected != null && selected.length > 0) {
        const selected = this.containerFilter.orderType || [];
        const propertyValues = properties.OrderType || [];

        const propArray = Array.isArray(propertyValues) ? propertyValues : [propertyValues];

        if (selected.length > 0) {
          const hasMatch = selected.some(val => propArray.includes(val.trim()));

          if (!hasMatch) {
            matches = false;
          }
        }
      }
    }

    if (this.containerFilter.loadStatus && this.containerFilter.loadStatus.trim() !== '') {
      if (!properties.LoadStatus || properties.LoadStatus !== this.containerFilter.loadStatus.trim()) {
        matches = false;
      }
    }
    
    if (this.containerFilter.noDeliveryToPTIsRequired && this.containerFilter.noDeliveryToPTIsRequired.trim() !== '') {

      if (Number(properties.NoDeliveryToPTIsRequired) != Number(this.containerFilter.noDeliveryToPTIsRequired)) {
        matches = false;
      }
    }
    if (this.containerFilter.voyageName?.length > 0) {
      const selected = this.containerFilter.voyageName;
      const propertyValue = properties.VoyageName;

      if (selected != null && selected.length > 0) {
        const selected = this.containerFilter.voyageName || [];
        const propertyValues = properties.VoyageName || [];

        const propArray = Array.isArray(propertyValues) ? propertyValues : [propertyValues];
        if (selected.length > 0) {

          const hasMatch = selected.some(val => propArray.includes(val.trim()));

          if (!hasMatch) {
            matches = false;
          }
        }
      }
    }
    if (this.containerFilter.terminalDestination?.length > 0) {
      const selected = this.containerFilter.terminalDestination;
      const propertyValue = properties.TerminalDestination;

      if (selected != null && selected.length > 0) {
        const selected = this.containerFilter.terminalDestination || [];
        const propertyValues = properties.TerminalDestination || [];

        const propArray = Array.isArray(propertyValues) ? propertyValues : [propertyValues];
        if (selected.length > 0) {
          const hasMatch = selected.some(val => propArray.includes(val.trim()));

          if (!hasMatch) {
            matches = false;
          }
        }
      }
    }

    if (this.containerFilter.shipmentType?.length > 0) {
      const selected = this.containerFilter.shipmentType;
      const propertyValue = properties.ShipmentType;

      if (selected != null && selected.length > 0) {
        const selected = this.containerFilter.shipmentType || [];
        const propertyValues = properties.ShipmentType || [];

        const propArray = Array.isArray(propertyValues) ? propertyValues : [propertyValues];
        if (selected.length > 0) {
          const hasMatch = selected.some(val => propArray.includes(val.trim()));

          if (!hasMatch) {
            matches = false;
          }
        }
      }
    }


    if (this.containerFilter.portOfDischarge?.length > 0) {
      const selected = this.containerFilter.portOfDischarge;
      const propertyValue = properties.PortOfDischarge;

      if (selected != null && selected.length > 0) {
        const selected = this.containerFilter.portOfDischarge || [];
        const propertyValues = properties.PortOfDischarge || [];

        const propArray = Array.isArray(propertyValues) ? propertyValues : [propertyValues];
        if (selected.length > 0) {
          const hasMatch = selected.some(val => propArray.includes(val.trim()));

          if (!hasMatch) {
            matches = false;
          }
        }
      }
    }

    if (this.containerFilter.portOfTranship?.length > 0) {
      const selected = this.containerFilter.portOfTranship;
      const propertyValue = properties.PortOfTranship;

      if (selected != null && selected.length > 0) {
        const selected = this.containerFilter.portOfTranship || [];
        const propertyValues = properties.PortOfTranship || [];

        const propArray = Array.isArray(propertyValues) ? propertyValues : [propertyValues];
        if (selected.length > 0) {
          const hasMatch = selected.some(val => propArray.includes(val.trim()));

          if (!hasMatch) {
            matches = false;
          }
        }
      }
    }


    if (this.containerFilter.containerSize?.length > 0) {
      const selected = this.containerFilter.containerSize;
      const propertyValue = properties.ContainerSize;

      if (selected != null && selected.length > 0) {
        const selected = this.containerFilter.containerSize || [];
        const propertyValues = properties.ContainerSize || [];

        const propArray = Array.isArray(propertyValues) ? propertyValues : [propertyValues];
        if (selected.length > 0) {
          const hasMatch = selected.some(val => propArray.includes(val.trim()));

          if (!hasMatch) {
            matches = false;
          }
        }
      }
    }
    if (this.containerFilter.containerType?.length > 0) {
      const selected = this.containerFilter.containerType;
      const propertyValue = properties.ContainerType;

      if (selected != null && selected.length > 0) {
        const selected = this.containerFilter.containerType || [];
        const propertyValues = properties.ContainerType || [];

        const propArray = Array.isArray(propertyValues) ? propertyValues : [propertyValues];

        if (selected.length > 0) {
          const hasMatch = selected.some(val => propArray.includes(val.trim()));

          if (!hasMatch) {
            matches = false;
          }
        }
      }
    }
    return matches;
  }

  toggleOccupationLayers() {
    if (!this.map) {
      return;
    }

    const show3D = this.map.getPitch() >= 10 && !this.previewMode && !this.selectionMode;
    const show2D = this.map.getPitch() < 10 && !this.previewMode && !this.selectionMode;

    // لایه‌های اصلی
    this.map.setLayoutProperty(
      "stacks3D",
      "visibility",
      show3D ? "visible" : "none"
    )

    this.map.setLayoutProperty(
      "stacks2D",
      "visibility",
      show2D ? "visible" : "none"
    )

    // لایه‌های dimmed
    this.map.setLayoutProperty(
      "stacks3D-dimmed",
      "visibility",
      show3D ? "visible" : "none"
    )

   /*  this.map.setLayoutProperty(
      "stacks2D-dimmed",
      "visibility",
      show2D ? "visible" : "none"
    ) */

  } 

  setContainerFilter(filterOptions: {
    area?: string;
    bay?: number;
    row?: number;
    layer?: number;
    line?: string;
    containerCycleType: string,
    loadStatus: string,
    noDeliveryToPTIsRequired: boolean,
    containerSize: string,
    containerType: string,
    voyageName: string,
    shipmentType: string,
    portOfTranship: string,
    portOfDischarge: string,
    terminalDestination: string,
    orderType: string

  }) {
    this.containerFilter = filterOptions;

    this.isFilterActive = this.hasActiveFilters(filterOptions);

    this.applyContainerFilter();

    const onIdleHandler = () => {
      // فقط یکبار اجرا شود
      this.map.off('idle', onIdleHandler);
      this.$store.state.berthMonitoring.isLoading = false
      //this.filterSvc.loading$.next(false);   // لودر خاموش شد
    };
    this.map.on('idle', onIdleHandler);

    //this.map?.triggerRepaint();
  }

  setEquipmentFilter(filterOptions: {
    code?: string;
    currentArea?: number;
    operationType?: number;
    status?: number;
    vessel?: string;
    terminal?: string,
  }) {
    this.equipmentsFilter = filterOptions;
    this.isEquipmentFilterActive = this.hasEquipmentActiveFilters(filterOptions);
    this.applyEquipmentFilter();

    const onIdleHandler = () => {
      // فقط یکبار اجرا شود
      this.map.off('idle', onIdleHandler);
      this.$store.state.berthMonitoring.isLoading = false
      //this.filterSvc.loading$.next(false);   // لودر خاموش شد
    };
    this.map.on('idle', onIdleHandler);

    //this.map?.triggerRepaint();
  }
  clearContainerFilter() {
    this.containerFilter = {};
    this.isFilterActive = false;
    this.applyContainerFilter();

    this.map?.triggerRepaint();
  }
  clearEquipmentFilter() {
    this.equipmentsFilter = {};
    this.isEquipmentFilterActive = false;
    this.applyEquipmentFilter();

    this.map?.triggerRepaint();
  }


  hasActiveFilters(filterOptions: any): boolean {
    return !!(
      (filterOptions.code && String(filterOptions.code).trim() !== '') ||
      (filterOptions.bay !== undefined && filterOptions.bay !== null && filterOptions.bay !== '') ||
      (filterOptions.row !== undefined && filterOptions.row !== null && filterOptions.row !== '') ||
      (filterOptions.layer !== undefined && filterOptions.layer !== null && filterOptions.layer !== '') ||
      (filterOptions.line && filterOptions.line.trim() !== '') ||
      (filterOptions.containerCycleType?.length > 0) ||
      (filterOptions.loadStatus && String(filterOptions.loadStatus).trim() !== '') ||
      (filterOptions.noDeliveryToPTIsRequired && filterOptions.noDeliveryToPTIsRequired !== '') ||
      (filterOptions.containerSize?.length > 0) ||
      (filterOptions.containerType?.length > 0) ||
      (filterOptions.voyageName?.length > 0) ||
      (filterOptions.terminalDestination?.length > 0) ||
      (filterOptions.shipmentType?.length > 0) ||
      (filterOptions.portOfTranship?.length > 0) ||
      (filterOptions.portOfDischarge?.length > 0) ||
      (filterOptions.orderType?.length > 0)
    );
  }
  hasEquipmentActiveFilters(filterOptions: any): boolean {
    return !!(
      (filterOptions.code?.length > 0) ||
      (filterOptions.currentArea?.length > 0) ||
      (filterOptions.operationType?.length > 0) ||
      (filterOptions.status?.length > 0) ||
      (filterOptions.vessel?.length > 0) ||
      (filterOptions.terminal?.length > 0)
    );
  }


  //   axios({
  //   method: 'post', //you can set what request you want to be
  //   url: 'https://example.com/request',
  //   data: {id: varID},
  //   headers: {
  //     Authorization: 'Bearer ' + varToken
  //   }
  // })


  // fetchDetailedOccupation() {
  //   let dataurl =
  //   "json/GetContainerStackDetails.json";
  //   if (this.terminalId == 7) {
  //     dataurl = "json/stack_detail_DAR.json";
  //   }
  //   axios
  //     .get(dataurl)
  //     .then((response) => {
  //       this.createContainerFeatures(response.data.Result);
  //       this.renderYard();
  //     })
  //     .catch((error) => {
  //       console.error(error.message);
  //     });
  // }

  /**
   * MapOccupationIntoDictionary
   */
  MapOccupationIntoDictionary(
    occupationArray: Array<Occupation>
  ): OccupationDictionary {
    if (!occupationArray || occupationArray.length == 0) {
      throw new Error("Occupation array was null or empty!")
    }

  const occupationDict = new OccupationDictionary();
  occupationArray.forEach(occupation => {
    const newOcc = new Occupation(
      occupation.Area,
      occupation.Bay,
      occupation.Bay2,
      occupation.Bay3,
      occupation.ContainerLength,
      occupation.MaxLayer,
      occupation.Row
    );
    if (occupation.Bay != null) {
      occupationDict.SetBay(occupation.Area, occupation.Row, occupation.Bay, newOcc);
    }
    if (occupation.Bay2 != null) {
      occupationDict.SetBay(occupation.Area, occupation.Row, occupation.Bay2, newOcc);
    }
    if (occupation.Bay3 != null) {
      occupationDict.SetBay(occupation.Area, occupation.Row, occupation.Bay3, newOcc);
    }
  });
  return occupationDict;
  }

  /**
   * Is called when the user presses the save selection button
   */
  saveSelectionClicked() {
    if ("appInterface" in window && this.selectSlotsTool) {
      window["appInterface"].selectSlots_Completed(
        JSON.stringify(this.selectSlotsTool.getSelectedSlots())
      )
    }

    if (this.selectSlotsTool) {
      this.selectSlotsTool.setEnabled(false)
      this.selectionMode = false
    }
  }

  /**
   * Is called when the user presses the cancel button
   */
  cancelClicked() {
    if (this.selectSlotsTool) {
      this.selectSlotsTool.setEnabled(false)
      this.selectionMode = false
    }
  }

  /**
   * Fired when the user clicks on a feature with the mouse
   * @param {MapMouseEvent} e
   */
  // onFeatureClicked(e) {
  //   // ایجاد bbox با tolerance متناسب با zoom
  //   const zoom = this.map.getZoom();
  //   const tolerance = Math.max(3, Math.round(20 / zoom)); // tolerance پویا بر اساس zoom

  //   const bbox: [mapboxgl.PointLike, mapboxgl.PointLike] = [
  //     [e.point.x - tolerance, e.point.y - tolerance],
  //     [e.point.x + tolerance, e.point.y + tolerance]
  //   ];

  //   // بررسی hitbox با bbox
  //   const hitboxFeatures = this.map.queryRenderedFeatures(bbox, {
  //     layers: ['area-labels-hitbox']
  //   });

  //   if (hitboxFeatures.length > 0) {
  //     const props = hitboxFeatures[0].properties;
  //     this.clickobject(props);
  //     this.$router.push({
  //       query: {
  //         blockInfo: JSON.stringify(props)
  //       }
  //     });
  //     return;
  //   }

  //   // بررسی بقیه features با bbox
  //   const features = this.map.queryRenderedFeatures(bbox);

  //   if (features.length > 0) {
  //     const props = features[0].properties;
  //     this.clickobject(props);

  //     if (features[0].source == "containers") {
  //       const url = window.location.href;
  //       this.$router.push(`?containerinfo=${props.containerinfo}`);
  //       setTimeout(() => {
  //         window.location.replace(url);
  //       }, 200);
  //     }

  //     if (features[0].source == "vechiles") {
  //       if (props.shipid) {
  //         const url = window.location.href;
  //         let vechileid = props.shipid;
  //         this.$router.push(`?vechileid=${vechileid}&row=${props.row}&bay=${props.bay}&layer=${props.layer}`);
  //       }
  //     }
  //   }
  // }
  onFeatureClicked(e) {
    const is3DMode =
      this.map.getPitch() >= 10 && !this.previewMode && !this.selectionMode

    if (is3DMode) {
      const rtg3DClick = this.findRTG3DClickAtLngLat(e.lngLat)
      if (rtg3DClick?.properties) {
        this.handleRTGEquipmentClick(
          rtg3DClick.properties as Record<string, unknown>
        )
        return
      }
    }

    const features = this.map.queryRenderedFeatures(e.point, {
      layers: [
        "rtg-surface-layer",
        "eq-labels",
        "vessel-surface-layer",
        "areas",
        "stacks3D",
        "slots",
        "slot-labels",
        "area-labels",
        "stacks2D",
      ],
    })

    if (features.length === 0) return

    const topFeature = features[0]

    if (topFeature.source == "vechiles") {
      const props = topFeature.properties
      if (props.type === "rtg" || props.equipmentid) {
        this.handleRTGEquipmentClick(props as Record<string, unknown>)
        return
      }
      this.clickobject(props)
      if (props.shipid) {
        this.$router.push(
          `?vechileid=${props.shipid}&row=${props.row}&bay=${props.bay}&layer=${props.layer}`
        )
      }
      return
    }

    if (topFeature.source == "areas") {
      const blockInfo = this.resolveAreaBlockInfoForClick(
        topFeature.properties as Record<string, unknown>
      )
      this.clickobject(blockInfo)
      this.$router.push({
        query: { blockInfo: JSON.stringify(blockInfo) },
      })
      return
    }
    if (topFeature.source == "containers") {
      const props = topFeature.properties
      this.openContainerStackModal(this.buildContainerStackModalData(props))
      return
    }
  }

  pagecomplete() {
    if (this.pageurl) {
      const url = this.pageurl
      window.location.replace(`${url}?complete=true`)
      setTimeout(() => {
        window.location.replace(url)
      }, 2000)
    }
    this.loadcomplete("All")
  }

  /**
   * Fired when the mouse hovers over a feature on the map
   * @param {MapMouseEvent} e
   */
  _onMouseMove(e) {
    this.lastMouseLngLat = e.lngLat; // ذخیره مختصات جغرافیایی موس

    if (!this.map) return

    const slotSelectionActive = Boolean(this.selectSlotsTool?.enabled)
    const editorActive = Boolean(this.editor?.active())
    if (!slotSelectionActive && !editorActive) {
      const areaLabelFeatures = this.map.queryRenderedFeatures(e.point, {
        layers: ['area-labels']
      })

      if (areaLabelFeatures.length > 0) {
        this.map.getCanvas().style.cursor = 'pointer'
        return
      }
      const features = this.map.queryRenderedFeatures(e.point)
      let mousetype = ""
      features.forEach((feat) => {
        if (
          feat["source"] == "areas" ||
          feat["source"] == "slots" ||
          feat["source"] == "previewareas" ||
          feat["source"] == "previewslots" ||
          feat["source"] == "containers" ||
          feat["source"] == "vechiles"
        ) {
          mousetype = "pointer"
        }
      })

      this.map.getCanvas().style.cursor = mousetype
    } 
  }

  /**
   * Extract the session Id from the URL
   */
  readQueryStringParams(): string {
    let sessionId = ""
    let terminalId = 1
    this.useRoro3dModel = true
    window.location.href.replace(
      /[?&]+([^=&]+)=([^&]*)/gi,
      //@ts-ignore
      (m: string, key: string, value: string) => {
        if (key == "sessionId") {
          sessionId = value
        }
        if (key == "terminalId") {
          terminalId = Number(value)
        }
        if (key == "apiurl") {
          this.apiUrl = value
        }
        if (key == "useRoro3dModel") {
          this.useRoro3dModel = Number(value) == 1
        }
        if (key == "pageurl") {
          this.pageurl = value
        }
        if (key == "quality") {
          if (value.toLowerCase() == "high") {
            this.renderQuality = "High"
          }
          if (value.toLowerCase() == "medium") {
            this.renderQuality = "Medium"
          }
          if (value.toLowerCase() == "low") {
            this.renderQuality = "Low"
            this.useRoro3dModel = false
          }
        }
      }
    )


    //For testing purposes only
    // if (!sessionId) {
    //  sessionId ="d281d13c-3a30-45d1-b5da-156ee0b390d6";


    //  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyaWQiOiIxIiwibmJmIjoxNjI3MjA1MjAzLCJleHAiOjE2MjcyMDg4MDMsImlhdCI6MTYyNzIwNTIwM30.cY5vKtY8UATnSNiiHWFnBUiLWrcs23h-owdmbc5WMJY";

    // console.error("No session Id found!");
    //  }

    axios.defaults.headers.common["Authorization"] = `bearer ${sessionId}`
    axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*'
    return sessionId
  }

  preview(yvObject: YardViewObject) {
    if (!this.map) {
      return
    }

    //Get preview area source
    const previewAreas: GeoJSONSource = this.map.getSource(
      "previewareas"
    ) as GeoJSONSource

    //Get preview slots source
    const previewslots: GeoJSONSource = this.map.getSource(
      "previewslots"
    ) as GeoJSONSource

    this.previewMode = yvObject != null
    this.previewObject = yvObject != null ? yvObject.Code : null

    if (
      yvObject &&
      ((yvObject.GeoShape == "CIRCLE" &&
        yvObject.GeoPointLongitude &&
        yvObject.GeoPointLatitude) ||
        (yvObject.GeoShape && yvObject.GeoShapePoints))
    ) {
      const feat = this.generateFeature(yvObject)
      yvObject.Feature = feat

      if (!yvObject.Feature) {
        return
      }

      //Set preview area data
      previewAreas.setData(
        turf.featureCollection([
          yvObject.Feature,
        ]) as GeoJSON.FeatureCollection<GeoJSON.Geometry>
      )

      if (yvObject.Structure !== "NONE") {
        previewslots.setData(
          turf.featureCollection(
            this.renderSlots(yvObject)
          ) as GeoJSON.FeatureCollection<GeoJSON.Geometry>
        )
      }
    } else {
      this.map
      previewAreas.setData(
        turf.featureCollection(
          []
        ) as GeoJSON.FeatureCollection<GeoJSON.Geometry>
      )
      this.map
      previewslots.setData(
        turf.featureCollection(
          []
        ) as GeoJSON.FeatureCollection<GeoJSON.Geometry>
      )
    }

    this.renderYard()
  }

  refresh(includingStructure) {
    if (includingStructure) {
      this.areas = []
      this.slots = []
      this.stacks = []
      this.containers = []
      this.clear3DModels()
      this.fetchObjectData()
      this.eq2Ds = [];
      this.eq2DsLabels = [];

    } else {
      this.stacks = []
      this.containers = []
      this.clear3DModels()
      this.fetchOccupation()
      this.eq2Ds = [];
      this.eq2DsLabels = [];

    }
  }
  clear3DModels() {
    for (const id of this.roro3DModelList) {
      if (this.map.getLayer(id)) this.map.removeLayer(id)
    }
    this.roro3DModelList = []
  }
  highlightSlots(selectedItemsStr: string) {
    if (this.selectSlotsTool && !this.selectSlotsTool.enabled) {
      const selectedItems = JSON.parse(
        selectedItemsStr
      ) as SelectionInterface[]
      this.selectSlotsTool.highlight(selectedItems)
      this.previewMode = selectedItems != null
    }
  }

  selectSlots(selectedItems: string) {
    if (this.selectSlotsTool) {
      this.selectSlotsTool.setEnabled(
        true,
        JSON.parse(selectedItems) as SelectionInterface[]
      )
      this.selectionMode = true
    }
  }

  toggleOccupationLayers() {
    if (!this.map) {
      return
    }

    this.map.setLayoutProperty(
      "stacks3D",
      "visibility",
      this.map.getPitch() < 10 || this.previewMode || this.selectionMode
        ? "none"
        : "visible"
    )

    this.map.setLayoutProperty(
      "stacks3D-dimmed",
      "visibility",
      this.map.getPitch() < 10 || this.previewMode || this.selectionMode
        ? "none"
        : "visible"
    )

    this.map.setLayoutProperty(
      "stacks2D",
      "visibility",
      this.map.getPitch() >= 10 || this.previewMode || this.selectionMode
        ? "none"
        : "visible"
    )

    this.map.setLayoutProperty(
      "stacks2D-dimmed",
      "visibility",
      this.map.getPitch() >= 10 || this.previewMode || this.selectionMode
        ? "none"
        : "visible"
    )

    this.map.setLayoutProperty(
      "eq2Ds",
      "visibility",
      this.map.getPitch() >= 10 || this.previewMode || this.selectionMode
        ? "none"
        : "visible"
    );

    // Show or hidden RTG switch between 2D & 3D
    const map = this.map;
    this.eq3DModelLayerIds.forEach((eqId) => {
      if (map.getLayer(eqId)) {
        // شرط زاویه دید
        var is3DMode = map.getPitch() >= 10 && !this.previewMode && !this.selectionMode;
        var isValidId = true
        if (this.equipmentfiltered.eq2Ds && this.equipmentfiltered.eq2Ds.length > 0) {
          // شرط وجود در لیست
          isValidId = this.equipmentfiltered.eq2Ds.flatMap(c => c.properties.code).includes(eqId);
        }


        // هر دو شرط باید برقرار باشد
        if (is3DMode && isValidId) {
          map.setLayoutProperty(eqId, "visibility", "visible");
        } else {
          map.setLayoutProperty(eqId, "visibility", "none");
        }
      } else {
        console.error("RTG Layer not found", eqId);
      }
    });
  }
  generateAreaFeatureFake(
    geoShape,
    geoShapePoints,
    objectType,
    objectCode,
    structure
  ) {
    const geometryCoordinates: Array<Array<number>> = []
    if (geoShapePoints.geometry) {
      if (geoShapePoints.geometry.coordinates) {
        geoShapePoints.geometry.coordinates[0].forEach((item) => {
          geometryCoordinates.push([item[0], item[1]])
        })
      }
    } else {
      const coordinates = geoShapePoints.split(",")
      coordinates.forEach((coordinate) => {
        const latlon = coordinate.split("/")
        geometryCoordinates.push([Number(latlon[1]), Number(latlon[0])])
      })
      //Polygon requires first and last position to be the same
      geometryCoordinates.push(geometryCoordinates[0])
    }

    if (objectType == "ROROxx") {
      const area = this.areaObjects.find((area) => area.code == objectCode)

      const maxLength = Number(area.LaneLength)
      const maxWidth =
        area.Lanes.length *
        (Number(area.LaneWidth) + Number(area.LaneInterspace)) -
        Number(area.LaneInterspace)
      const angelX = Number(area.AngleX) + 90
      const angelY = Number(area.AngleY)
      const point0 = geometryCoordinates[0]
      let directionAngle = 90
      if (angelY == 270) {
        directionAngle = -90
      }

      const point1 = turf.destination(point0, maxLength / 1000, angelX).geometry
        .coordinates
      const point2 = turf.destination(
        point1,
        maxWidth / 1000,
        angelX + directionAngle
      ).geometry.coordinates
      const point3 = turf.destination(
        point0,
        maxWidth / 1000,
        angelX + directionAngle
      ).geometry.coordinates
      const newArray = [point0, point1, point2, point3, point0]

      const newPlolygon = turf.polygon([newArray], {
        code: objectCode,
        fid: objectCode,
        objectType: objectType,
        structure: structure,
      })

    }
    //For Create Fake Data Container

    if (
      objectType == "CONTAREA" &&
      this.terminalId == 7 &&
      objectCode == "KH01"
    ) {
      const area = this.areaObjects.find((area) => area.Code == objectCode)
      const maxLength =
        Number(area.NumberOfBays) *
        (Number(area.PositionLength) + Number(area.BayInterspace)) -
        Number(area.BayInterspace)
      const maxWidth =
        Number(area.NumberOfRows) *
        (Number(area.PositionWidth) + Number(area.RowInterspace)) -
        Number(area.RowInterspace)

      const angelX = Number(area.AngleX) + 90
      const angelY = Number(area.AngleY)
      const point0 = geometryCoordinates[0]
      let directionAngle = 90
      if (angelY == 270) {
        directionAngle = -90
      }

      const point1 = turf.destination(point0, maxLength / 1000, angelX).geometry
        .coordinates
      const point2 = turf.destination(
        point1,
        maxWidth / 1000,
        angelX + directionAngle
      ).geometry.coordinates
      const point3 = turf.destination(
        point0,
        maxWidth / 1000,
        angelX + directionAngle
      ).geometry.coordinates
      const newArray = [point0, point1, point2, point3, point0]

      const newPlolygon = turf.polygon([newArray], {
        code: objectCode,
        fid: objectCode,
        objectType: objectType,
        structure: structure,
      })
      //

      //Create Fake Data

      if (objectCode == "HC01" && this.terminalId == 9) {
        const newareas = []
        for (let col = 1; col <= 2; col++) {
          const fixpoint = turf.destination(
            point0,
            ((maxLength + 40) * (col - 1)) / 1000,
            angelX
          ).geometry.coordinates
          for (let i = 1; i <= 6; i++) {
            const point3 = turf.destination(
              fixpoint,
              ((maxWidth + 10) * (i - 1)) / 1000,
              angelX + directionAngle
            ).geometry.coordinates
            const res = this.generateAreaCorrectPolygon(
              point3,
              maxLength,
              maxWidth,
              angelX,
              directionAngle
            )
            const newp = turf.polygon([res], {})

            const area0 = Object.assign({}, this.areaObjects[0])
            //@ts-ignore
            area0.GeoShapePoints = newp
            let md = "A"
            if (col == 1) md = "A"
            if (col == 2) md = "B"
            if (col == 3) md = "C"
            if (i >= 10) {
              area0.Code = "A" + md + i
            } else {
              area0.Code = "A" + md + "0" + i
            }
            /// if(!(col==1 && i==1))
            newareas.push(area0)
            this.areaObjects.push(area0)
          }
        }

      }

      return newPlolygon
    }

    return turf.polygon([geometryCoordinates], {
      code: objectCode,
      fid: objectCode,
      objectType: objectType,
      structure: structure,
    })
  }
}
